// AUTO-GENERATED by scripts/generate-comprehensive-assessment.mjs
// DO NOT EDIT BY HAND. Regenerate via: node scripts/generate-comprehensive-assessment.mjs

export const COMPREHENSIVE_ASSESSMENT_ID = "ASM-2026-comprehensive-alma";

export const COMPREHENSIVE_ARTIFACTS = [
  {
    "id": 1000,
    "artifactId": "AR-101",
    "name": "Acceptable Use Policy",
    "description": "Catalog evidence: POL-acceptable-use.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Policies/POL-acceptable-use.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Policy",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-101",
    "status": "ACTIVE"
  },
  {
    "id": 1001,
    "artifactId": "AR-102",
    "name": "Access Management Policy",
    "description": "Catalog evidence: POL-access-management.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Policies/POL-access-management.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Policy",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-102",
    "status": "ACTIVE"
  },
  {
    "id": 1002,
    "artifactId": "AR-103",
    "name": "Data Classification Policy",
    "description": "Catalog evidence: POL-data-classification.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Policies/POL-data-classification.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Policy",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-103",
    "status": "ACTIVE"
  },
  {
    "id": 1003,
    "artifactId": "AR-104",
    "name": "Encryption Standards Policy",
    "description": "Catalog evidence: POL-encryption-standards.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Policies/POL-encryption-standards.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Policy",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-104",
    "status": "ACTIVE"
  },
  {
    "id": 1004,
    "artifactId": "AR-105",
    "name": "Information Security Policy",
    "description": "Catalog evidence: POL-information-security.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Policies/POL-information-security.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Policy",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-105",
    "status": "ACTIVE"
  },
  {
    "id": 1005,
    "artifactId": "AR-106",
    "name": "Physical Security Policy",
    "description": "Catalog evidence: POL-physical-security.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Policies/POL-physical-security.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Policy",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-106",
    "status": "ACTIVE"
  },
  {
    "id": 1006,
    "artifactId": "AR-107",
    "name": "Third Party Risk Management Policy",
    "description": "Catalog evidence: POL-third-party-risk.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Policies/POL-third-party-risk.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Policy",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-107",
    "status": "ACTIVE"
  },
  {
    "id": 1007,
    "artifactId": "AR-108",
    "name": "Quarterly Access Recertification Procedure",
    "description": "Catalog evidence: PROC-access-review.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Procedures/PROC-access-review.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Procedure",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-108",
    "status": "ACTIVE"
  },
  {
    "id": 1008,
    "artifactId": "AR-109",
    "name": "Backup and Restore Procedure",
    "description": "Catalog evidence: PROC-backup-restore.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Procedures/PROC-backup-restore.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Procedure",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-109",
    "status": "ACTIVE"
  },
  {
    "id": 1009,
    "artifactId": "AR-110",
    "name": "Incident Response Playbook (Excerpt)",
    "description": "Catalog evidence: PROC-incident-response-playbook.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Procedures/PROC-incident-response-playbook.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Procedure",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-110",
    "status": "ACTIVE"
  },
  {
    "id": 1010,
    "artifactId": "AR-111",
    "name": "Patch Management Procedure",
    "description": "Catalog evidence: PROC-patch-management.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Procedures/PROC-patch-management.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Procedure",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-111",
    "status": "ACTIVE"
  },
  {
    "id": 1011,
    "artifactId": "AR-112",
    "name": "Hardware Inventory Sampling Walkthrough",
    "description": "Catalog evidence: PROC-sampling-walkthrough.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Procedures/PROC-sampling-walkthrough.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Procedure",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-112",
    "status": "ACTIVE"
  },
  {
    "id": 1012,
    "artifactId": "AR-113",
    "name": "Q4 2025 Access Recertification Report",
    "description": "Catalog evidence: RPT-access-certification-q4.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Reports/RPT-access-certification-q4.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Report",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-113",
    "status": "ACTIVE"
  },
  {
    "id": 1013,
    "artifactId": "AR-114",
    "name": "AWS Tag Compliance Report",
    "description": "Catalog evidence: RPT-aws-tag-compliance.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Reports/RPT-aws-tag-compliance.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Report",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-114",
    "status": "ACTIVE"
  },
  {
    "id": 1014,
    "artifactId": "AR-115",
    "name": "Quarterly Backup Restore Test Report",
    "description": "Catalog evidence: RPT-backup-restore-test.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Reports/RPT-backup-restore-test.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Report",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-115",
    "status": "ACTIVE"
  },
  {
    "id": 1015,
    "artifactId": "AR-116",
    "name": "Network Discovery Scan Results",
    "description": "Catalog evidence: RPT-nmap-scan-results.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Reports/RPT-nmap-scan-results.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Report",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-116",
    "status": "ACTIVE"
  },
  {
    "id": 1016,
    "artifactId": "AR-117",
    "name": "Q1 2026 Phishing Simulation Report",
    "description": "Catalog evidence: RPT-phishing-simulation-q1.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Reports/RPT-phishing-simulation-q1.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Report",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-117",
    "status": "ACTIVE"
  },
  {
    "id": 1017,
    "artifactId": "AR-118",
    "name": "Weekly Vulnerability Scan Summary",
    "description": "Catalog evidence: RPT-vulnerability-scan-summary.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Reports/RPT-vulnerability-scan-summary.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Report",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-118",
    "status": "ACTIVE"
  },
  {
    "id": 1018,
    "artifactId": "AR-119",
    "name": "Alma Security Hardware Inventory",
    "description": "Catalog evidence: INV-hardware-inventory.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Inventories/INV-hardware-inventory.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Inventory",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-119",
    "status": "ACTIVE"
  },
  {
    "id": 1019,
    "artifactId": "AR-120",
    "name": "Service Account Inventory",
    "description": "Catalog evidence: INV-service-accounts.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Inventories/INV-service-accounts.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Inventory",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-120",
    "status": "ACTIVE"
  },
  {
    "id": 1020,
    "artifactId": "AR-121",
    "name": "Authorized Software Inventory",
    "description": "Catalog evidence: INV-software-inventory.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Inventories/INV-software-inventory.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Inventory",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-121",
    "status": "ACTIVE"
  },
  {
    "id": 1021,
    "artifactId": "AR-122",
    "name": "SOC Incident Ticket",
    "description": "Catalog evidence: TKT-SOC-1001-phishing.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Tickets/TKT-SOC-1001-phishing.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Ticket",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-122",
    "status": "ACTIVE"
  },
  {
    "id": 1022,
    "artifactId": "AR-123",
    "name": "SOC Incident Ticket",
    "description": "Catalog evidence: TKT-SOC-1004.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Tickets/TKT-SOC-1004.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Ticket",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-123",
    "status": "ACTIVE"
  },
  {
    "id": 1023,
    "artifactId": "AR-124",
    "name": "SOC Incident Ticket",
    "description": "Catalog evidence: TKT-SOC-1005.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Tickets/TKT-SOC-1005.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Ticket",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-124",
    "status": "ACTIVE"
  },
  {
    "id": 1024,
    "artifactId": "AR-125",
    "name": "GV.RM — Risk Management Strategy: Assessment Artifacts",
    "description": "Catalog evidence: EVD-GV.RM-02-assessment-artifacts.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-GV.RM-02-assessment-artifacts.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-125",
    "status": "ACTIVE"
  },
  {
    "id": 1025,
    "artifactId": "AR-126",
    "name": "PR.IP Assessment Artifacts",
    "description": "Catalog evidence: EVD-PR.IP-assessment-artifacts.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-PR.IP-assessment-artifacts.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-126",
    "status": "ACTIVE"
  },
  {
    "id": 1026,
    "artifactId": "AR-127",
    "name": "Alma Security Business Case",
    "description": "Catalog evidence: EVD-alma-business-case.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-alma-business-case.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-127",
    "status": "ACTIVE"
  },
  {
    "id": 1027,
    "artifactId": "AR-128",
    "name": "AWS Config Compliance Snapshot",
    "description": "Catalog evidence: EVD-aws-config-compliance.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-aws-config-compliance.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-128",
    "status": "ACTIVE"
  },
  {
    "id": 1028,
    "artifactId": "AR-129",
    "name": "�-k_�&D��_�\u0016T�s��R��&�l�A���nY�w\u0004�5?�J�I\u0010\u000e�T;P���8N��d�tz��^l9�0nm�z�d�5��\u000bb�c�'�hW�qDh�6�6$��GQK-VH�5Q��>l*{\u0017<SF+w�/V\u0007��]�V���-3������O��wn#�9\u0003\u001c8:&'\t��\bP^�R�k��T��H*hA���#ȫ�Ÿ\u00133}?��\u0001o\u000f�����B\u0012\r�Ҳ{1u���m��V�P�\u0010C�4�\u000b\r��\u0019V\u0000�\u0010��ޓ��}#:$�X�D�<e����\u0014k0\u0011�@\u001a߄���c����-�5�ox��v�������\u0018\"�;\u001a��}8h)��h�+\u001f\u0003�6�\u0011��\u001f��X�\u0002]o\u0017�t�\u001b��*��=�zl���D��{J\u001b��\u000bMW4`\b���]�ܩ+\u001a�ʖI\u0007�\u0010�t�\u0019Ow�¥^Dr7�\u00024zK��։tX�Q�\u001b�[�q���\u0011T^�R4Y��-ȁ)X!�1�R�\u0011l�-�H]NG\u0003�\u0001�qe��T���&��E�~��W�c�U�\t6��\u0004h�몧�眂c�����TB�җ�!�/�mL{w������!�\u001e�����C<1�N唕��M\u0011�NI��|l��+�I'f\u0011�ao�k��\u001fRm+i�/9�6���#�0��\u0007HsfX��VK.�I��\u0001p&FU���8�'2�\u0017�Կ\u0000}���8:L3�M���J]�T�ޖ5� ]\u0018+e�~<h  ���@&\u001bz^E�n\u0002��D\u0000��2]\t�",
    "description": "Catalog evidence: EVD-csf-assessment-workbook.xlsx",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-csf-assessment-workbook.xlsx",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-129",
    "status": "ACTIVE"
  },
  {
    "id": 1029,
    "artifactId": "AR-130",
    "name": "�-k_�&D��_�\u0016T�s��R��&�l�A���nY�w\u0004�5?�J�I\u0010\u000e�T;P���8N��d�tz��^l9�0nm�z�d�5��\u000bb�c�'�hW�qDh�6�6$��GQK-VH�5Q��>l*{\u0017<SF+w�/V\u0007��]�V���-3������O��wn#�9\u0003\u001c8:&'\t��\bP^�R�k��T��H*hA���#ȫ�Ÿ\u00133}?��\u0001o\u000f�����B\u0012\r�Ҳ{1u���m��V�P�\u0010C�4�\u000b\r��\u0019V\u0000�\u0010��ޓ��}#:$�X�D�<e����\u0014k0\u0011�@\u001a߄���c����-�5�ox��v�������\u0018\"�;\u001a��}8h)��h�+\u001f\u0003�6�\u0011��\u001f��X�\u0002]o\u0017�t�\u001b��*��=�zl���D��{J\u001b��\u000bMW4`\b���]�ܩ+\u001a�ʖI\u0007�\u0010�t�\u0019Ow�¥^Dr7�\u00024zK��։tX�Q�\u001b�[�q���\u0011T^�R4Y��-ȁ)X!�1�R�\u0011l�-�H]NG\u0003�\u0001�qe��T���&��E�~��W�c�U�\t6��\u0004h�몧�眂c�����TB�җ�!�/�mL{w������!�\u001e�����C<1�N唕��M\u0011�NI��|l��+�I'f\u0011�ao�k��\u001fRm+i�/9�6���#�0��\u0007HsfX��VK.�I��\u0001p&FU���8�'2�\u0017�Կ\u0000}���8:L3�M���J]�T�ޖ5� ]\u0018+e�~<h  ���@&\u001bz^E�n\u0002��D\u0000��2]\t�",
    "description": "Catalog evidence: EVD-phish-campaign-2025-05-26.xlsx",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-phish-campaign-2025-05-26.xlsx",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-130",
    "status": "ACTIVE"
  },
  {
    "id": 1030,
    "artifactId": "AR-131",
    "name": "SentinelOne Application Control Configuration Evidence",
    "description": "Catalog evidence: EVD-sentinelone-app-control.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-sentinelone-app-control.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-131",
    "status": "ACTIVE"
  },
  {
    "id": 1031,
    "artifactId": "AR-132",
    "name": "Q1 2026 Security Awareness Training Completion Evidence",
    "description": "Catalog evidence: EVD-training-completion-q1.md",
    "link": "https://github.com/CPAtoCybersecurity/csf_profile/blob/main/ASSESSMENT_CATALOG/5_Artifacts/Evidence/EVD-training-completion-q1.md",
    "complianceRequirement": null,
    "controlId": null,
    "linkedSubcategoryIds": [],
    "linkedEvaluationIds": [],
    "type": "Evidence",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "AR-132",
    "status": "ACTIVE"
  }
];

export const COMPREHENSIVE_SCOPE_IDS = [
  "DE.AE-02 Ex1",
  "DE.AE-03 Ex1",
  "DE.AE-04 Ex1",
  "DE.AE-06 Ex1",
  "DE.AE-07 Ex1",
  "DE.AE-08 Ex1",
  "DE.CM-01 Ex1",
  "DE.CM-02 Ex1",
  "DE.CM-03 Ex1",
  "DE.CM-06 Ex1",
  "DE.CM-09 Ex1",
  "GV.OC-01 Ex1",
  "GV.OC-02 Ex1",
  "GV.OC-03 Ex1",
  "GV.OC-04 Ex1",
  "GV.OC-05 Ex1",
  "GV.OV-02 Ex1",
  "GV.OV-03 Ex1",
  "GV.PO-01 Ex1",
  "GV.PO-02 Ex1",
  "GV.RM-01 Ex1",
  "GV.RM-02 Ex1",
  "GV.RM-03 Ex1",
  "GV.RM-04 Ex1",
  "GV.RM-05 Ex1",
  "GV.RM-06 Ex1",
  "GV.RM-07 Ex1",
  "GV.RR-01 Ex1",
  "GV.RR-02 Ex1",
  "GV.RR-03 Ex1",
  "GV.RR-04 Ex1",
  "GV.SC-01 Ex1",
  "GV.SC-02 Ex1",
  "GV.SC-03 Ex1",
  "GV.SC-04 Ex1",
  "GV.SC-05 Ex1",
  "GV.SC-06 Ex1",
  "GV.SC-07 Ex1",
  "GV.SC-08 Ex1",
  "GV.SC-09 Ex1",
  "GV.SC-10 Ex1",
  "PR.AA-01 Ex1",
  "PR.AA-02 Ex1",
  "PR.AA-03 Ex1",
  "PR.AA-04 Ex1",
  "PR.AA-05 Ex1",
  "PR.AA-06 Ex1",
  "PR.AT-01 Ex1",
  "PR.AT-02 Ex1",
  "PR.DS-01 Ex1",
  "PR.DS-02 Ex1",
  "PR.DS-10 Ex1",
  "PR.DS-11 Ex1",
  "PR.IR-01 Ex1",
  "PR.IR-02 Ex1",
  "PR.IR-03 Ex1",
  "PR.IR-04 Ex1",
  "PR.PS-01 Ex1",
  "PR.PS-02 Ex1",
  "PR.PS-03 Ex1",
  "PR.PS-04 Ex1",
  "PR.PS-05 Ex1",
  "PR.PS-06 Ex1",
  "RC.CO-03 Ex1",
  "RC.CO-04 Ex1",
  "RC.RP-01 Ex1",
  "RC.RP-02 Ex1",
  "RC.RP-03 Ex1",
  "RC.RP-04 Ex1",
  "RC.RP-05 Ex1",
  "RC.RP-06 Ex1",
  "RS.AN-03 Ex1",
  "RS.AN-06 Ex1",
  "RS.AN-07 Ex1",
  "RS.AN-08 Ex1",
  "RS.CO-02 Ex1",
  "RS.CO-03 Ex1",
  "RS.MA-01 Ex1",
  "RS.MA-02 Ex1",
  "RS.MA-03 Ex1",
  "RS.MA-04 Ex1",
  "RS.MA-05 Ex1",
  "RS.MI-01 Ex1",
  "RS.MI-02 Ex1"
];

export const COMPREHENSIVE_OBSERVATIONS = {
  "DE.AE-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review CloudTrail and GuardDuty configuration\n2. Examine detection rule tuning\n3. Verify TTD (Time to Detect) metrics\n4. Assess 24/7 monitoring gaps",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 2,
        "targetScore": 5,
        "observations": "CloudTrail and GuardDuty provide SIEM-like functionality. TTD at 9 hours. Malicious activity detection rules tuned based on threat intelligence.",
        "observationDate": "2025-01-26",
        "testingStatus": "Complete",
        "examine": false,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.AE-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Assess log aggregation architecture\n2. Evaluate event correlation capabilities\n3. Test threat intelligence integration in correlation\n4. Review correlation effectiveness",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1001",
      "FND-1002",
      "FND-1003"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "Alma Security correlates information from multiple detection sources through AWS GuardDuty, which natively ingests CloudTrail management events, VPC Flow Logs, and DNS query logs to generate correlated findings. SentinelOne endpoint telemetry provides host-level correlation of process execution, file system changes, and network connections. However, correlation between cloud-native sources (GuardDuty) and endpoint sources (SentinelOne) remains manual -- the SOC team must pivot between consoles to link related events. There is no unified SIEM platform that aggregates all sources into a single correlation engine. During testing, a simulated lateral movement scenario was detectable across individual sources but required manual analyst effort to correlate the CloudTrail API calls with corresponding VPC Flow Log entries and SentinelOne process telemetry. The lack of automated cross-platform correlation increases mean time to investigate for complex incidents. ### Strengths - GuardDuty provides automated multi-signal correlation across CloudTrail, VPC Flow Logs, and DNS - SentinelOne correlates endpoint-level events (process, file, network) within its own telemetry - CloudTrail centralized to a single S3 bucket across all AWS accounts enabling organization-wide visibility - SOC analysts trained on manual cross-platform pivot techniques ### Gaps - No unified SIEM to correlate cloud-native and endpoint telemetry in a single platform - Cross-source correlation is manual and analyst-dependent, increasing investigation time - Threat intelligence feed integration limited to GuardDuty built-in threat lists - No automated correlation with physical access or identity management event sources",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.AE-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review automated impact estimation capabilities\n2. Evaluate manual impact assessment process\n3. Test impact estimation accuracy\n4. Assess communication of impact estimates",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Weekly Vulnerability Scan Summary",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1004",
      "FND-1005",
      "FND-1006"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "Alma Security estimates incident impact and scope through a combination of GuardDuty severity ratings and manual SOC analyst assessment. GuardDuty provides initial severity classification (Low/Medium/High) based on the type and context of detected activity. SOC analysts supplement this with manual scope assessment by checking affected assets against the CMDB, evaluating data sensitivity classifications, and estimating business impact. The incident response playbook defines impact categories (Negligible, Minor, Moderate, Major, Critical) with clear criteria for each level. However, scope estimation beyond the initially detected assets relies heavily on individual analyst judgment. The playbook lacks quantitative scoring rubrics for scope, leading to inconsistency between analysts. Review of 3 recent incident tickets showed appropriate severity ratings but varying levels of detail in scope documentation. ### Strengths - GuardDuty provides automated initial severity classification with contextual enrichment - Incident response playbook defines five-level impact classification with documented criteria - SOC analysts cross-reference affected assets against CMDB for blast radius estimation - ServiceNow incident tickets include structured fields for impact and scope recording ### Gaps - Scope estimation lacks quantitative scoring rubric, relying on analyst judgment - No automated tool to map blast radius across interconnected systems - Inconsistent scope documentation detail across different SOC analysts - Business impact quantification (revenue, customers affected) not systematically captured",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.AE-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Verify automated alert routing\n2. Assess on-demand access to security findings\n3. Review automated ticket creation workflow\n4. Evaluate manual reporting and escalation",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1007",
      "FND-1008",
      "FND-1009"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 6,
        "observations": "Alma Security distributes adverse event information through multiple channels. GuardDuty findings route to the Slack #security-alerts channel via SNS/Lambda integration, providing near-real-time visibility to the SOC team and authorized security personnel. High and critical severity findings trigger automatic ServiceNow ticket creation with assignment to the on-call responder. The SOC team has console access to GuardDuty, SentinelOne, and CloudTrail for direct log analysis. The Slack-based notification system provides effective distribution during business hours when the team is actively monitoring. After-hours notification relies on the on-call rotation with PagerDuty integration for high-severity events. Medium and low severity findings accumulate in Slack and ServiceNow queues for next-business-day review. Testing confirmed that GuardDuty high-severity findings reach the on-call responder within 5 minutes through PagerDuty. ### Strengths - GuardDuty findings auto-route to Slack #security-alerts for team-wide visibility - High-severity findings trigger automatic ServiceNow ticket creation and on-call paging - Authorized personnel have direct console access to all detection platforms - PagerDuty integration ensures after-hours notification for critical events within 5 minutes ### Gaps - Medium-severity findings do not trigger after-hours notification, potentially delaying response - No automated daily digest or summary report of accumulated findings for leadership - Alert distribution limited to security team; business unit stakeholders not included in relevant notifications - No mechanism to confirm alert acknowledgment or track mean time to acknowledge",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.AE-07 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Assess threat intelligence feed integration\n2. Evaluate asset context integration\n3. Review vulnerability disclosure monitoring\n4. Test threat intelligence effectiveness",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1010",
      "FND-1011",
      "FND-1012",
      "FND-1013"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "Alma Security integrates cyber threat intelligence primarily through vendor-provided feeds. GuardDuty includes AWS-curated threat intelligence that identifies known malicious IP addresses, domains, and behavioral patterns. SentinelOne provides its own threat intelligence through the SentinelOne cloud, including indicators of compromise, malware signatures, and behavioral detection models updated continuously. However, Alma does not subscribe to or integrate external CTI feeds beyond what the primary vendors provide. There is no formal CTI program that aggregates intelligence from ISACs, commercial feeds, or open-source threat intelligence platforms. Vulnerability disclosures are tracked informally through vendor security advisories and the Vulnerability Scan Summary reports, but there is no systematic process for rapidly acquiring and analyzing zero-day disclosures for Alma's specific technology stack. ### Strengths - GuardDuty includes continuously updated AWS-curated threat intelligence - SentinelOne provides real-time IOC and behavioral detection intelligence from its cloud platform - Vulnerability scan reports reference known CVEs and threat context - SOC analysts reference vendor threat intelligence during incident analysis ### Gaps - No external CTI feeds beyond vendor-provided intelligence (no ISAC membership, no commercial CTI subscription) - No formal CTI program or dedicated threat intelligence function - Vulnerability disclosure tracking is informal and reactive - Asset inventory context not systematically integrated into detection tuning decisions - No threat modeling process to prioritize intelligence relevant to Alma's specific threat landscape",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.AE-08 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review incident declaration criteria\n2. Evaluate false positive management\n3. Test incident declaration accuracy\n4. Assess declaration timeliness",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1014",
      "FND-1015",
      "FND-1016"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "The incident response playbook defines incident declaration criteria based on event severity, asset sensitivity, data exposure risk, and potential business impact. GuardDuty findings at High severity automatically generate ServiceNow incident tickets, effectively declaring them as incidents requiring response. Medium-severity findings are triaged by SOC analysts who apply the playbook criteria to determine whether to escalate to incident status. Testing of 5 recent GuardDuty findings showed consistent application of automatic declaration for high-severity events. For the 2 medium-severity findings reviewed, SOC analysts correctly applied the playbook criteria and documented their rationale. Known false positive patterns are maintained in a SOC knowledge base article and referenced during triage to reduce unnecessary incident declarations. However, the criteria do not explicitly address compound events where multiple low-severity findings collectively indicate a significant threat. ### Strengths - Incident declaration criteria documented in the incident response playbook with clear severity thresholds - High-severity GuardDuty findings trigger automatic incident declaration via ServiceNow - SOC analysts document triage rationale when applying criteria to medium-severity events - Known false positive catalog maintained and referenced during triage ### Gaps - No criteria for compound event analysis where multiple low-severity findings may collectively warrant incident declaration - Incident criteria review cycle not defined; criteria may not reflect evolving threat landscape - Declaration threshold calibration relies on individual analyst interpretation for borderline cases - No metric tracking false positive rate or missed incident rate for criteria effectiveness",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.CM-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Verify network traffic monitoring coverage\n2. Evaluate network anomaly detection\n3. Test unauthorized endpoint detection\n4. Assess rogue wireless monitoring",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1017",
      "FND-1018",
      "FND-1019"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "Alma Security monitors networks through VPC Flow Logs enabled across all production AWS VPCs, GuardDuty network-based threat detection, Palo Alto firewall logging for on-premises and hybrid network segments, and DNS query log analysis. GuardDuty monitors VPC Flow Logs and DNS logs to detect network anomalies including port scanning, unusual data transfer volumes, and communication with known malicious infrastructure. VPC Flow Logs are centralized to a single S3 bucket and retained for 90 days. Palo Alto firewall logs capture north-south and east-west traffic with application-level visibility. Testing confirmed that VPC Flow Logs are enabled on all 12 production VPCs and that GuardDuty correctly detected a simulated port scan within 15 minutes. However, monitoring of non-production VPCs (development, staging) is inconsistent, with Flow Logs disabled on 3 of 5 non-production VPCs. Network baseline comparison is not automated; deviation detection relies on GuardDuty's anomaly models rather than organization-specific baselines. ### Strengths - VPC Flow Logs enabled and centralized across all 12 production VPCs - GuardDuty provides automated network anomaly detection with DNS and Flow Log analysis - Palo Alto firewall provides application-layer visibility for on-premises network segments - Network-based threat detection validated through simulated port scan (15-minute detection) ### Gaps - VPC Flow Logs disabled on 3 of 5 non-production VPCs, creating blind spots for pre-production attacks - No organization-specific network baselines for deviation comparison - Wireless network monitoring limited to corporate office; no rogue AP detection capability - No automated network flow baseline comparison beyond GuardDuty anomaly models",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.CM-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Verify physical access control monitoring\n2. Assess visitor management controls\n3. Evaluate tamper detection\n4. Review surveillance and alarm systems",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)"
    ],
    "linkedFindings": [
      "FND-1020",
      "FND-1021",
      "FND-1022"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 4,
        "observations": "Alma Security monitors the physical environment through badge reader access controls at the corporate office, security cameras at building entry points, and a visitor registration system requiring sign-in and escort assignment. Badge reader logs are retained for 90 days and reviewed monthly by the facilities team for anomalous patterns. Physical environment monitoring is limited in scope given Alma's cloud-first infrastructure model -- primary computing resources reside in AWS rather than on-premises data centers. The corporate office houses the Windows Domain Controller and employee workstations but no production servers. After-hours badge access generates alerts to the facilities manager but not to the security team. There is no integration between physical access logs and logical access monitoring, meaning a compromised badge would not trigger correlation with network authentication events. ### Strengths - Badge reader access controls operational at all corporate office entry points - Security cameras cover building entrances with 30-day footage retention - Visitor registration requires sign-in and escort assignment - Monthly badge access log review by facilities team ### Gaps - After-hours physical access alerts route to facilities only, not to security team - No integration between physical access logs and logical security monitoring - Physical access anomaly detection is manual and monthly, not real-time - No tamper detection on physical access control hardware",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.CM-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Assess user behavior analytics capabilities\n2. Verify logical access monitoring\n3. Evaluate technology usage monitoring\n4. Assess deception technology posture",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1023",
      "FND-1024",
      "FND-1025",
      "FND-1026"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "Alma Security monitors personnel activity through multiple sources: Active Directory logs capture authentication events including failed logons, privilege escalation, and group membership changes on the Windows Domain Controller. CloudTrail records all IAM user and role activity across AWS accounts. SentinelOne monitors endpoint user activity including process execution, file access, and network connections with behavioral analysis for anomaly detection. Failed authentication monitoring is operational, with repeated failed logon attempts generating alerts. However, Alma does not employ dedicated User and Entity Behavior Analytics (UEBA) or insider threat detection tooling. Anomalous user activity detection relies on SentinelOne's endpoint behavioral models and GuardDuty's IAM anomaly detection, which focus on technical indicators rather than user behavioral patterns. There is no monitoring of data exfiltration patterns, unusual working hours activity, or progressive access accumulation that might indicate insider threat activity. ### Strengths - Active Directory authentication logging captures failed logons, privilege changes, and group membership modifications - CloudTrail provides comprehensive IAM activity logging across all AWS accounts - SentinelOne behavioral analysis detects anomalous process execution patterns at the endpoint level - Failed authentication alerts configured for both AD and AWS IAM ### Gaps - No dedicated UEBA or insider threat detection platform - Data exfiltration pattern monitoring not implemented - No monitoring for anomalous working hours or geographic access patterns - Deception technology (honeypots, honey tokens) not deployed - User activity monitoring does not correlate across AD, AWS, and endpoint sources",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.CM-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Verify vendor access monitoring\n2. Assess cloud service provider monitoring\n3. Evaluate vendor activity validation\n4. Review service provider SLA monitoring",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1027",
      "FND-1028",
      "FND-1029"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "Alma Security monitors external service provider activity primarily through CloudTrail logging of IAM role assumption events, which captures when third-party vendors or AWS service teams access Alma's AWS environment via cross-account roles. VPN access for on-premises remote administration by external vendors is logged through the Palo Alto firewall with session recording enabled for privileged activities. Monitoring of cloud-based SaaS provider activities (ServiceNow, Workday, Slack) relies on each platform's native audit logging without centralized collection or correlation. AWS service provider activity (support access, service team actions) is visible through CloudTrail but not actively monitored with specific alerting rules. The organization does not have a comprehensive third-party activity monitoring program that covers all external service providers consistently. ### Strengths - CloudTrail captures all third-party IAM role assumption events across AWS accounts - VPN session logging for external vendor remote access through Palo Alto firewall - Privileged activity session recording enabled for vendor remote administration - Contract requirements specify logging and monitoring obligations for major vendors ### Gaps - SaaS provider audit logs not centralized or correlated with infrastructure monitoring - No specific alerting rules for AWS service provider access events - Inconsistent monitoring coverage across different types of external service providers - No automated baseline for expected third-party activity patterns",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "DE.CM-09 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Verify common attack vector monitoring\n2. Assess authentication attack detection\n3. Evaluate configuration drift monitoring\n4. Test endpoint health and integrity monitoring",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "SOC Incident Ticket",
      "Incident Response Playbook (Excerpt)"
    ],
    "linkedFindings": [
      "FND-1030",
      "FND-1031",
      "FND-1032",
      "FND-1033"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "Alma Security monitors computing hardware and software through SentinelOne endpoint detection and response (EDR) deployed across all managed endpoints, AWS Config for cloud resource configuration compliance monitoring, and GuardDuty for runtime workload threat detection. SentinelOne provides continuous monitoring for malware, ransomware, unauthorized process execution, and behavioral anomalies on Windows and macOS endpoints. AWS Config evaluates cloud resource configurations against defined compliance rules, flagging deviations such as unencrypted S3 buckets, overly permissive security groups, and missing logging configurations. Vulnerability scanning runs monthly through the established scanning tool, producing the Vulnerability Scan Summary report. SentinelOne agent coverage is at 95% of managed endpoints, with 3 legacy systems lacking agent support identified in the coverage gap analysis. Email filtering and web content filtering provide monitoring of common attack vectors, though advanced sandboxing or detonation capabilities are not deployed. Software configuration baseline monitoring relies on AWS Config for cloud resources but lacks equivalent enforcement for on-premises systems beyond SentinelOne application control. ### Strengths - SentinelOne EDR deployed on 95% of managed endpoints with behavioral analysis - AWS Config provides continuous cloud configuration compliance monitoring - Monthly vulnerability scans with documented findings and remediation tracking - GuardDuty provides runtime threat detection for AWS workloads - SentinelOne application control monitors for unauthorized software execution ### Gaps - 3 legacy endpoints lack SentinelOne agent coverage due to OS compatibility - No advanced email sandboxing or detonation for zero-day attachment analysis - On-premises software configuration baseline enforcement limited to SentinelOne application control - Hardware tamper detection not implemented for on-premises equipment - Patch compliance monitoring is monthly rather than continuous",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.OC-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review mission alignment documentation\n2. Interview CISO on mission-risk linkage\n3. Examine strategic planning artifacts\n4. Cross-reference with non-security leadership",
    "linkedArtifacts": [
      "Information Security Policy",
      "Data Classification Policy"
    ],
    "linkedFindings": [
      "FND-1034"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Mission statement published on corporate website, investor materials, and internal wiki - CISO explicitly references mission in cybersecurity strategy, mapping security goals to business objectives - Quarterly Board presentations connect risk management decisions to mission enablement ### Gaps - Mission-to-security mapping not formally communicated below director level - New hires do not receive mission-security alignment briefing during onboarding",
        "observationDate": "2026-03-03",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.OC-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review stakeholder identification documentation\n2. Validate customer-facing security expectations\n3. Interview Gerry (IT/Security Manager) on stakeholder engagement\n4. Review investor and Board expectations",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Quarterly Access Recertification Procedure"
    ],
    "linkedFindings": [
      "FND-1035"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Internal stakeholders (Board, engineering, sales) and their cybersecurity expectations are documented - External stakeholder requirements (customer security questionnaires, SOC 2 expectations) tracked in ServiceNow - Regulatory obligations mapped to policies and controls ### Gaps - Stakeholder register not formally updated since Q3 2025 - Partner ecosystem security expectations not yet documented",
        "observationDate": "2026-03-04",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.OC-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review regulatory obligations inventory\n2. Examine compliance tracking process\n3. Interview CISO on regulatory alignment\n4. Validate contractual obligation management",
    "linkedArtifacts": [
      "Information Security Policy",
      "Data Classification Policy"
    ],
    "linkedFindings": [
      "FND-1036"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Legal and regulatory requirements tracked in ServiceNow with mapped policy controls - Contractual cybersecurity obligations cataloged for major customer agreements - Cybersecurity strategy explicitly aligned to SOC 2, GDPR, and state privacy law requirements ### Gaps - Emerging AI regulations not yet mapped to policy requirements - Contractual obligation tracking incomplete for Tier 2 and Tier 3 customer agreements",
        "observationDate": "2026-03-04",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.OC-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review business impact analysis (BIA)\n2. Validate critical service identification\n3. Interview engineering leadership on resilience objectives\n4. Examine customer communication on service expectations",
    "linkedArtifacts": [
      "Information Security Policy",
      "Authorized Software Inventory"
    ],
    "linkedFindings": [
      "FND-1037"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Business Impact Analysis (BIA) identifies critical capabilities and services with defined RTOs and RPOs - Service catalog maps critical customer-facing services to supporting infrastructure - Resilience objectives communicated to engineering and operations teams ### Gaps - BIA last updated Q2 2025; does not reflect recent service additions - RTO/RPO objectives not tested against actual recovery capabilities in 6+ months",
        "observationDate": "2026-03-05",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.OC-05 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review external dependency inventory\n2. Validate single points of failure analysis\n3. Interview Gerry on dependency management\n4. Examine contingency planning for key dependencies",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "Third Party Risk Management Policy",
      "Alma Security Hardware Inventory"
    ],
    "linkedFindings": [
      "FND-1038"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - External dependency inventory maintained in ServiceNow covering cloud providers, SaaS tools, and critical vendors - Single points of failure identified for infrastructure dependencies (AWS, DNS, CDN) - Dependencies communicated to engineering through architecture documentation ### Gaps - Dependency inventory does not include all indirect dependencies (sub-processors of Tier 1 vendors) - Failure mode analysis not completed for three recently onboarded critical SaaS tools",
        "observationDate": "2026-03-05",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.OV-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review audit findings integration\n2. Examine personnel performance oversight\n3. Validate incident-driven strategy review\n4. Interview CISO on strategy coverage assessment",
    "linkedArtifacts": [
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1039"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Audit findings systematically reviewed against cybersecurity strategy for coverage gaps - Performance oversight of cybersecurity roles conducted semi-annually - Strategy updated after Q3 2025 incident to address detection gaps ### Gaps - No formal process to review strategy after every significant incident (only major ones trigger review) - Performance reviews for non-security personnel with cyber responsibilities lack consistency",
        "observationDate": "2026-03-06",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.OV-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review KPI measurement and reporting\n2. Examine KRI (Key Risk Indicator) tracking\n3. Validate senior leadership communication\n4. Assess adjustment process based on performance data",
    "linkedArtifacts": [
      "Information Security Policy",
      "Q4 2025 Access Recertification Report"
    ],
    "linkedFindings": [
      "FND-1040"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 7,
        "targetScore": 8,
        "observations": "### Strengths - KPIs tracked quarterly: TTD (9 hrs), TTI (14 hrs), TTR-CJC (6 days), TTR-C (12 days) - KRIs defined for top five risks with automated threshold alerting in ServiceNow - Metrics communicated to senior leadership through quarterly CISO dashboard ### Gaps - KPI benchmarking against industry peers not formalized - Some KRI thresholds set based on initial estimates, not validated against operational data",
        "observationDate": "2026-03-06",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.PO-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review information security policy framework\n2. Validate policy alignment with strategy\n3. Examine policy communication and acknowledgment\n4. Interview non-security personnel on policy awareness",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1041"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 7,
        "targetScore": 8,
        "observations": "### Strengths - Comprehensive Information Security Policy approved by CEO and CISO, reviewed annually - Policy acknowledgment tracked through HRIS with 97% completion rate - Senior management approval workflow enforced through ServiceNow with digital signatures ### Gaps - 3% of employees have not acknowledged current policy version (mostly recent hires in onboarding pipeline) - Supporting procedures referenced in policy not all updated to match latest policy revision",
        "observationDate": "2026-03-07",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.PO-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review policy revision history\n2. Validate change-driven policy updates\n3. Examine policy enforcement mechanisms\n4. Interview CISO on policy lifecycle management",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1042"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Policy reviewed annually with off-cycle reviews triggered by major events - Regulatory change tracker in ServiceNow maps changes to affected policies - Recent policy update completed for AI adoption and data classification changes ### Gaps - Policy review timeline not formally documented for all trigger types (M&A, technology changes) - Two supporting procedures overdue for annual review by 30+ days",
        "observationDate": "2026-03-07",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RM-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "Alma Security updates cybersecurity risk management objectives annually during Q4 strategic planning, with the CISO presenting proposed objectives to the CEO and Board. Near-term objectives align with the SOC 2 Type II roadmap and quarterly KPI targets (TTD, TTI, TTR). Long-term objectives map to the 3-year security strategy. Major business changes (funding rounds, acquisitions) trigger off-cycle objective reviews.",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1043"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Risk management objectives established annually during Q4 strategic planning - Measurable KPI targets defined (TTD, TTI, TTR) and agreed upon by CISO and CEO - Senior leaders formally agree on objectives documented in Board meeting minutes ### Gaps - Objectives not updated after Series C funding discussion that shifted business priorities - Department-level awareness of risk management objectives limited below VP level",
        "observationDate": "2026-03-08",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RM-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review risk appetite statement\n2. Validate risk tolerance communication\n3. Examine tolerance-driven decisions\n4. Interview CEO or CFO on risk appetite governance",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1044"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - Risk appetite statement established by CISO with CEO and CFO input - Tolerance thresholds quantified for key risk categories (TTD, patching windows, vendor compliance) - Risk appetite periodically refined based on incident experience and exposure data ### Gaps - Board ratification of risk appetite statement pending (scheduled Q2 2026) - No documented example of tolerance thresholds actively driving a risk acceptance or escalation decision",
        "observationDate": "2026-03-08",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RM-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review enterprise risk management framework\n2. Validate cybersecurity risk escalation to ERM\n3. Examine cross-functional risk governance\n4. Interview CISO on ERM integration",
    "linkedArtifacts": [],
    "linkedFindings": [
      "FND-1045"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Cybersecurity risks aggregated alongside financial, operational, and compliance risks in unified register - CISO participates in enterprise risk management planning sessions - Escalation criteria defined for elevating cybersecurity risks to enterprise level ### Gaps - Enterprise risk register format differs slightly between cybersecurity and financial risk entries - Bottom-up risk identification from non-security teams not formalized",
        "observationDate": "2026-03-09",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RM-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review risk response framework\n2. Validate response option implementation\n3. Examine shared responsibility documentation\n4. Interview CISO on risk response decision-making",
    "linkedArtifacts": [
      "Information Security Policy",
      "Data Classification Policy"
    ],
    "linkedFindings": [
      "FND-1046"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Risk acceptance and avoidance criteria defined by data classification tier - Cyber liability insurance maintained ($5M coverage) with annual review - Shared responsibility models documented for AWS and major SaaS vendors ### Gaps - Risk acceptance approvals not consistently documented in ServiceNow (some informal email approvals) - Shared responsibility matrices not completed for three recently onboarded cloud services",
        "observationDate": "2026-03-09",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RM-05 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review communication structure documentation\n2. Validate upward reporting mechanisms\n3. Examine cross-functional communication\n4. Interview non-security department heads on risk communication",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1047"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Quarterly Board presentations, monthly CEO reports, weekly CISO-CEO 1:1s established - Cross-department communication channels defined (Slack, ServiceNow, security committee meetings) - Critical finding escalation path documented and tested ### Gaps - Internal audit function not yet fully integrated into cybersecurity risk communication loop - No formal mechanism for non-security staff to report emerging cyber risks upward",
        "observationDate": "2026-03-10",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RM-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review risk assessment methodology\n2. Validate risk register consistency\n3. Examine risk documentation templates\n4. Interview risk management personnel on methodology application",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1048"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - FAIR-aligned quantitative methodology defined for high-value risk assessments - Standardized risk register template in ServiceNow with consistent fields - Risk prioritization criteria documented and applied through ServiceNow scoring - Consistent risk categories enable aggregation and trend analysis ### Gaps - Quantitative analysis criteria not clearly communicated to all risk assessors - Two risk entries in register missing required fields (treatment plan, target date)",
        "observationDate": "2026-03-10",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RM-07 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review positive risk documentation\n2. Validate opportunity-risk integration\n3. Examine innovation-security balance\n4. Interview CISO on positive risk management",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1049"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - Strategic opportunities identified (early SOC 2 as sales enabler, zero-trust as differentiator) - Stretch goals documented in cybersecurity strategy with status tracking - CISO includes opportunity section in quarterly Board presentations ### Gaps - Positive risks not formally scored alongside negative risks in the risk register - No systematic method for identifying new strategic opportunities beyond CISO-driven process",
        "observationDate": "2026-03-10",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RR-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review leadership accountability documentation\n2. Examine security culture initiatives\n3. Validate ethical security practices\n4. Interview CEO or Board member on cybersecurity governance",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1050"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Board, CEO, and CISO roles formally agreed and documented in governance framework - CEO communicates security culture expectations in all-hands meetings - CISO directed to maintain comprehensive risk strategy with annual and event-driven reviews - Semi-annual authority and coordination reviews conducted ### Gaps - Board member cybersecurity expertise limited; no dedicated cyber advisory board member - Security culture messaging could be more frequent (currently quarterly)",
        "observationDate": "2026-03-11",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RR-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review documented roles and responsibilities\n2. Validate job descriptions include security responsibilities\n3. Examine responsibility communication\n4. Interview team leads on role clarity",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1051"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Risk management roles documented in Information Security Policy with escalation paths - RACI matrix maintained in ServiceNow mapping all cybersecurity functions - Performance goals documented for security team tied to organizational KPIs - Cybersecurity responsibilities included in personnel descriptions for relevant roles ### Gaps - RACI matrix last reviewed Q3 2025; does not reflect recent team restructuring - Performance goals for department heads' cybersecurity responsibilities not consistently measured",
        "observationDate": "2026-03-11",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RR-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review security budget and staffing\n2. Validate resource-to-risk alignment\n3. Examine management review of resource adequacy\n4. Interview CISO on resource constraints",
    "linkedArtifacts": [
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1052"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - 15-person security team with dedicated roles across GRC, engineering, SOC, and identity management - Annual cybersecurity budget developed jointly by CISO and CFO, aligned to risk tolerance - Quarterly resource adequacy reviews conducted by CEO and CISO - Technology investments mapped to specific risk treatments ### Gaps - Two open security engineering positions unfilled for 3+ months - Training budget underutilized (60% spent) due to operational workload constraints",
        "observationDate": "2026-03-12",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.RR-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review HR-security integration\n2. Examine background check practices\n3. Validate personnel security obligations\n4. Interview HR on cybersecurity integration",
    "linkedArtifacts": [
      "Access Management Policy",
      "Quarterly Access Recertification Procedure"
    ],
    "linkedFindings": [
      "FND-1053"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Cybersecurity integrated into all HR lifecycle stages (screening, onboarding, changes, offboarding) - Background checks conducted for all sensitive roles with biennial refresh - Security certification funding and career development paths established - Policy acknowledgment obligations enforced with progressive non-compliance response ### Gaps - Background check refresh cycle overdue for 5 employees in sensitive roles - Offboarding access revocation took 48+ hours for 2 of 10 sampled departures (target: 24 hours)",
        "observationDate": "2026-03-12",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review SCRM program documentation\n2. Validate program maturity against objectives\n3. Examine stakeholder agreement\n4. Interview Gerry on C-SCRM program execution",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1054"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - C-SCRM strategy documented with clear objectives aligned to enterprise risk framework - Program plan with quarterly milestones tracked in ServiceNow - Cross-functional C-SCRM committee established with monthly meetings - Vendor intake workflow enforces security assessment before procurement approval ### Gaps - Program maturity tracking against 3-year roadmap not formalized beyond milestones - C-SCRM strategy not reviewed since initial publication (Q2 2025)",
        "observationDate": "2026-03-13",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review C-SCRM role assignments\n2. Validate supplier and partner role communication\n3. Examine internal C-SCRM role communication\n4. Interview procurement and security personnel",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1055"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - C-SCRM roles documented in TPRM policy with designated GRC Manager as program lead - RACI matrix maps activities across security, procurement, legal, and engineering - Supplier cybersecurity responsibilities defined in contractual agreements - Information sharing rules established with TLP classifications ### Gaps - Performance goals for C-SCRM roles not consistently measured in reviews - Information sharing protocols not tested through tabletop or simulation",
        "observationDate": "2026-03-13",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review integration with enterprise risk management\n2. Validate risk assessment integration\n3. Examine improvement process integration\n4. Interview CISO on C-SCRM integration approach",
    "linkedArtifacts": [
      "Third Party Risk Management Policy",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1056"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - C-SCRM alignment areas documented against enterprise risk management framework - Supply chain risks in unified risk register alongside internal cybersecurity risks - Material supply chain risks escalated to senior management through defined criteria - Improvement process incorporates supply chain lessons learned ### Gaps - Integrated control set documentation incomplete for recently added supply chain controls - C-SCRM improvement process findings not systematically fed back into enterprise improvement cycle",
        "observationDate": "2026-03-13",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review supplier inventory in ServiceNow\n2. Verify criticality ratings against documented criteria\n3. Interview procurement team on tiering process\n4. Sample quarterly review documentation",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 5,
        "observations": "The IT Manager explained that GRC verified that: - Supplier risk tiers documented in Third Party Risk Management Policy - No PO No Pay policy ensures all suppliers paid were identified - Suppliers ranked by data sensitivity, system access level, and mission importance",
        "observationDate": "2025-01-10",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-05 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review cybersecurity requirements for suppliers\n2. Validate contractual security provisions\n3. Examine requirement prioritization\n4. Interview legal/procurement on contract security clauses",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1057"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Standardized security addenda included in all vendor contracts with tiered requirements - SLAs defined for vulnerability remediation, incident notification, and compliance reporting - Contractual requirements for vulnerability disclosure and SBOM provision established - Information sharing rules defined in contracts with TLP classifications ### Gaps - 2 of 10 sampled contracts missing complete security addenda (pre-template contracts from 2024) - SBOM requirements only enforced for vendors onboarded after Q3 2025",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review due diligence process documentation\n2. Validate supplier risk assessment execution\n3. Examine product and technology assessment\n4. Interview procurement team on due diligence practices",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1058"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Due diligence scaled by criticality tier with comprehensive assessments for Tier 1 candidates - Cybersecurity capabilities evaluated through questionnaires, certification review, and reference checks - Product authenticity verification performed for critical software (hash checks, signature validation) - All 5 sampled Q1 onboardings had completed due diligence before contract execution ### Gaps - Due diligence completion time averaging 22 business days (target: 15) - Product integrity checks not formalized for hardware components",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-07 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review ongoing supplier risk assessment program\n2. Validate continuous monitoring practices\n3. Examine supplier risk response process\n4. Validate business continuity planning for supplier disruptions",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1059"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 6,
        "targetScore": 7,
        "observations": "### Strengths - Assessment frequency scaled by tier with continuous monitoring for Tier 1 vendors - Compliance evidence (SOC 2 reports, questionnaires) evaluated on contractual cadence - Risk profile change monitoring through security rating feeds and news monitoring - Business continuity plans for Tier 1 vendor disruptions documented and tested annually ### Gaps - 1 of 8 Tier 1 vendors overdue for annual assessment by 45 days - Vendor disruption scenario not included in most recent tabletop exercise",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-08 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review supplier incident response integration\n2. Validate supplier participation in exercises\n3. Examine crisis communication with suppliers\n4. Interview Nadia Khan (D&R Lead) on supplier incident coordination",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1060"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - Incident reporting rules defined in vendor contracts with tiered notification timelines - Supplier incident response roles documented in IR playbook - Crisis communication channels established with Tier 1 vendors - Lessons learned sessions conducted after Q3 2025 vendor-related incident ### Gaps - Only 2 of 8 Tier 1 vendors have participated in tabletop exercises - Crisis communication contact directory not updated since Q3 2025",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-09 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review supply chain security integration in policies\n2. Validate provenance and integrity practices\n3. Examine risk reporting on supply chain security\n4. Interview Chris Magann (VM Lead) on supply chain vulnerability management",
    "linkedArtifacts": [
      "Third Party Risk Management Policy",
      "Authorized Software Inventory"
    ],
    "linkedFindings": [
      "FND-1061"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - Provenance records required for critical technology acquisitions through procurement policy - Component integrity reporting included in quarterly CISO Board presentations - Supplier maintenance access requires named accounts with MFA and automatic logging - Hardware upgrade integrity checks automated through AWS Config for cloud infrastructure ### Gaps - SBOM coverage at 60% for critical applications (target: 100%) - Supplier maintenance access logs not reviewed systematically (only on-demand)",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "GV.SC-10 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review supplier termination procedures\n2. Validate access deactivation practices\n3. Examine end-of-life and obsolescence planning\n4. Interview Gerry on supplier offboarding process",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1062",
      "FND-1063"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - Vendor offboarding procedures documented for both normal and adverse terminations - EOL tracker maintained in ServiceNow with 12-month advance planning window - Access deactivation workflow triggers within 24 hours of termination notification - Data destruction certification required within 30 days of contract end ### Gaps - 1 of 2 sampled terminations had orphaned API key revoked 5 days after termination (missed in initial sweep) - Data leakage risk assessment not documented for either sampled termination - Transition plan template not formalized for Tier 1 vendor transitions",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AA-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review identity management policy and procedures\n2. Verify user onboarding process\n3. Examine offboarding procedures\n4. Identify orphaned and dormant accounts\n5. Review service account management",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Service Account Inventory"
    ],
    "linkedFindings": [
      "FND-1064",
      "FND-1065",
      "FND-1066",
      "FND-1067"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "Alma Security maintains identity and credential management through a Workday-to-ServiceNow integration pipeline backed by Active Directory on the on-premises Windows Domain Controller. The provisioning workflow is operational for standard employee roles, with automated AD account creation, group membership assignment, and Windows Authenticator SSO enrollment. The offboarding workflow triggers account disablement within the required SLA for involuntary terminations (same-day) and voluntary departures (next business day). Testing of 8 recent terminations confirmed that 7 were processed within SLA; 1 voluntary termination experienced a 3-day delay attributed to a ServiceNow workflow error that has since been resolved. The service account inventory in ServiceNow CMDB tracks 45 service accounts with documented owners. However, cross-referencing against running services on the Windows Domain Controller and AWS identified 3 service accounts not present in the inventory, all created during emergency change windows and never reconciled into the formal inventory. The quarterly access recertification process covers service accounts, but the 3 undocumented accounts were excluded from the Q4 2025 review cycle. The shared developer SSH key on port 45001 remains the most significant identity management gap. Eight developers share a single RSA-4096 key for production database access, eliminating individual accountability. The key has never been rotated. Remediation is planned for Q3 2026 via HashiCorp Vault SSH certificate authority, but no interim compensating controls exist beyond Palo Alto firewall session logging on port 45001. ### Strengths - Workday-ServiceNow integration provides automated identity lifecycle for standard employee roles - Offboarding SLA adherence at 87.5% (7 of 8 tested) for access revocation timing - Service account ownership documented for 93% of known accounts (42 of 45) - Monthly privileged account reviews conducted by Gerry's security team with documented outcomes - MFA Rollout project ($80K) actively strengthening credential management ### Gaps - Shared developer SSH key on port 45001 violates credential uniqueness and individual accountability principles - 3 service accounts created during emergency changes not in CMDB inventory - AWS IAM and Kubernetes deprovisioning requires manual intervention (24-48 hour gap after termination) - Role-change workflow not fully automated; access creep identified at 12% of AD group memberships - Credential recovery relies on knowledge-based identity verification, susceptible to social engineering",
        "observationDate": "2026-03-12",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AA-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review identity proofing policy and standards\n2. Examine employee onboarding identity verification\n3. Assess credential uniqueness and binding controls\n4. Evaluate remote identity proofing procedures\n5. Test credential lifecycle binding integrity",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Third Party Risk Management Policy"
    ],
    "linkedFindings": [
      "FND-1068",
      "FND-1069",
      "FND-1070"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "Alma Security performs identity proofing through the HR onboarding process, requiring government-issued photo identification before any system credentials are issued. The ServiceNow provisioning workflow includes a mandatory identity verification gate: the workflow will not progress to Active Directory account creation until HR marks the identity proofing step as \"Verified\" in Workday. Testing of 8 recent onboarding records confirmed that all 8 had completed identity proofing before credential issuance, including 3 remote employees who completed video verification with HR. Credential uniqueness is enforced through the Windows Authenticator SSO platform and the Active Directory unique UPN requirement. A query of Active Directory confirmed zero duplicate User Principal Names across 350 user objects. The Information Security Policy explicitly prohibits shared accounts, and the quarterly privileged access review validates that each privileged account maps to a single identified individual. The shared developer SSH key on port 45001 is the primary exception to credential binding controls. This key is shared among approximately 8 developers, breaking the one-to-one identity-to-credential binding that is otherwise enforced across the environment. The CSV assessment data from the 2025 assessment scored this subcategory at 3 (Q1 2025), improving to 5 (Q2 2025) after SSO credential uniqueness enforcement was verified. The shared SSH key was identified for Q3 2025 remediation in the prior assessment but remains outstanding, now retargeted to Q3 2026 through the HashiCorp Vault SSH CA project. The remote identity proofing procedure was formalized in Q4 2025 after the security team discovered that 3 remote hires in early 2025 had received credentials before completing identity verification. The new procedure requires video verification with both HR and the hiring manager present, and the ServiceNow workflow gate prevents this scenario from recurring. ### Strengths - Identity proofing gate in ServiceNow prevents credential issuance before verification (100% compliance in sample) - Zero duplicate UPNs in Active Directory confirming credential uniqueness for user accounts - Remote identity proofing procedure formalized with video verification requirement - Contractor identity proofing follows documented process with Procurement team validation - Quarterly privileged access reviews verify individual credential binding for elevated accounts ### Gaps - Shared developer SSH key on port 45001 breaks one-to-one identity-to-credential binding for 8 developers - No defined identity assurance levels mapped to access sensitivity (all users receive same proofing level) - Remote video verification is not recorded or retained for audit purposes - Contractor credential expiration not automatically tied to contract end date in Workday",
        "observationDate": "2026-03-13",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AA-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review authentication policy requirements\n2. Verify MFA implementation coverage\n3. Assess MFA configuration strength\n4. Test password policy enforcement\n5. Review SSH key and certificate management\n6. Assess directory services security",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Q1 2026 Phishing Simulation Report"
    ],
    "linkedFindings": [
      "FND-1071",
      "FND-1072",
      "FND-1073",
      "FND-1074",
      "FND-1075"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 6,
        "observations": "Alma Security's authentication posture shows significant investment through the MFA Rollout project ($80K) alongside persistent high-risk gaps that require urgent remediation. The Windows Authenticator SSO enforces MFA for cloud application access and VPN connections, with enrollment at approximately 85% of the employee population as of Q1 2026. Testing confirmed MFA enforcement is active: login attempts to 3 sampled applications (ServiceNow, GitHub, AWS Console) all required second-factor authentication. The authentication policy prohibits SMS-based MFA due to SIM-swapping risk, a decision Nadia Khan made based on threat intelligence specific to companies in the authentication SaaS space. However, the AWS root account for the production environment lacks MFA entirely. This was confirmed through the AWS IAM credential report, which shows the root account has console access enabled with password-only authentication. Gerry acknowledged this finding during the interview and committed to immediate remediation by enabling a hardware security key on the root account, with the physical key to be stored in the office safe. This represents a critical-severity finding given that root account compromise would grant unrestricted control over all AWS resources including the production Kubernetes cluster. The shared developer SSH key on port 45001 bypasses all MFA controls. Developers authenticating via this key are not required to present a second factor, and the key itself has never been rotated since creation. Palo Alto firewall logs on port 45001 show an average of 12 SSH sessions per day, all originating from internal IP addresses. While the firewall logging provides forensic capability, it does not prevent unauthorized use of the key. Active Directory password policy enforces 14-character minimum length with complexity requirements, 5-attempt lockout with 30-minute duration, and 90-day password history (12 passwords remembered). NTLMv1 and LM authentication protocols are disabled through GPO. Device authentication on the office network uses 802.1X through the Palo Alto firewall for wired connections, with certificate-based authentication for corporate devices. Five AWS IAM accounts still use long-lived access keys rather than SSO-federated temporary credentials. The oldest key was created 14 months ago and has never been rotated. These accounts bypass MFA enforcement since access key authentication does not support MFA natively through the CLI. ### Strengths - MFA enforcement active at 85% enrollment with SMS prohibition policy - FIDO2 hardware keys deployed for security team members (phishing-resistant MFA) - AD password policy aligned with CIS Benchmarks (14-char minimum, NTLMv1 disabled) - 802.1X device authentication operational on office network via Palo Alto - SentinelOne providing device health attestation across managed endpoints - Authentication event monitoring operational with SIEM alerting for anomalies ### Gaps - AWS root account lacks MFA (critical-severity finding) - Shared developer SSH key on port 45001 bypasses all authentication controls including MFA - MFA enrollment at 85%, not 100%; 15% of users authenticate with password only - 5 AWS IAM accounts using long-lived access keys (14 months oldest, no rotation) - No automated network quarantine for SentinelOne non-compliant devices - Phishing-resistant MFA (FIDO2) limited to security team; not extended to all privileged users",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AA-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review identity assertion architecture and standards\n2. Examine SSO token and assertion configuration\n3. Test assertion transport security\n4. Assess federation and cross-domain assertion trust\n5. Evaluate assertion verification at relying parties",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1076",
      "FND-1077",
      "FND-1078",
      "FND-1079",
      "FND-1080"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "Alma Security protects identity assertions through cryptographic signing at the Windows Authenticator SSO platform and Active Directory Kerberos infrastructure. SAML 2.0 assertions are digitally signed using SHA-256 with RSA-2048, verified through examination of 3 integrated application configurations. OAuth 2.0 access tokens use RS256 signing with 1-hour expiration, tightened from the previous 8-hour setting in Q4 2025. Kerberos encryption has been hardened to AES-256 only, with RC4 (ARCFOUR) disabled through GPO since Q3 2025 to mitigate Kerberoasting risk. Token lifecycle management shows improvement: the Q4 2025 tightening of token expiration settings (access tokens from 8 hours to 1 hour, refresh tokens from 30 days to 24-hour inactivity / 7-day maximum) significantly reduces the window for session hijacking. The security team demonstrated session revocation capability during a February 2026 tabletop exercise, terminating all active sessions for a simulated compromised account in under 5 minutes. However, applications that cache tokens locally may continue granting access for up to 1 hour after revocation, and back-channel logout (OIDC) is not configured for any integrated applications. Federation trust management is the weakest area. The federation inventory is maintained in a spreadsheet rather than a centralized configuration management tool. During the assessment, 2 of 35 SaaS application federation configurations were found to have stale metadata that had not been refreshed after the January 2026 SSO certificate rotation. Both applications continued to function because the previous certificate had not yet expired, but the stale metadata creates a risk of federation failure at certificate expiration and indicates a gap in federation lifecycle management. AWS federation through SAML is properly configured with audience restrictions, issuer validation, and external ID conditions for cross-account role assumption. The 4-account architecture (production, staging, development, shared services) uses role-based trust policies with appropriate scoping. Kubernetes service account tokens in EKS use projected tokens with audience binding, though expiration is not consistently configured across all namespaces. ### Strengths - SAML assertions digitally signed (SHA-256/RSA-2048) with annual certificate rotation - OAuth token expiration tightened to 1 hour (from 8 hours) in Q4 2025 - Kerberos hardened to AES-256 only; RC4 disabled to mitigate Kerberoasting - AWS federation uses external ID conditions to prevent confused deputy attacks - Session revocation capability demonstrated in under 5 minutes during tabletop exercise - All assertion transport verified over TLS 1.2+ ### Gaps - SAML assertion encryption enabled for only 12 of 35 integrated applications - 2 SaaS applications have stale federation metadata after January 2026 certificate rotation - Federation inventory maintained in spreadsheet, not in ServiceNow CMDB - Back-channel logout not configured; token caching creates up to 1-hour revocation gap - Kubernetes service account token expiration not consistently configured across namespaces - No automated assertion verification testing at relying parties",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AA-05 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review access control policy framework\n2. Audit privileged access accounts\n3. Verify access request and approval workflow\n4. Examine access recertification process\n5. Assess third-party and contractor access controls\n6. Review separation of duties controls",
    "linkedArtifacts": [
      "Access Management Policy",
      "Quarterly Access Recertification Procedure",
      "Q4 2025 Access Recertification Report",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "The IT Security Manager confirmed that: - Access Management Policy documents RBAC requirements and least privilege principles - ServiceNow workflow enforces manager and asset owner approval before provisioning - Quarterly access certification campaigns achieve 95%+ completion rate - Privileged accounts are managed through CyberArk PAM solution",
        "observationDate": "2026-02-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AA-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review physical access control policy and procedures\n2. Examine badge and credential management\n3. Assess physical access monitoring and logging\n4. Test data center and server room access controls\n5. Evaluate visitor management process\n6. Assess AWS physical security reliance",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Access Management Policy",
      "Alma Security Hardware Inventory"
    ],
    "linkedFindings": [
      "FND-1081",
      "FND-1082",
      "FND-1083",
      "FND-1084",
      "FND-1085"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 6,
        "observations": "Alma Security's physical access controls for the Redwood City headquarters are well-structured with a defined zone classification system and electronic badge-based access enforcement. The facility has 8 classified access zones mapped to 6 role categories in a physical access matrix maintained by the facilities team. The server room housing the Windows Domain Controller, Palo Alto firewall appliances, and network switching infrastructure is classified as a high-security zone requiring badge-plus-PIN authentication. Access is restricted to 11 authorized individuals and reviewed monthly. Badge lifecycle management is integrated into the employee onboarding and offboarding workflows through ServiceNow. Testing of 6 Q4 2025 terminations revealed that 4 badges were deactivated within the required SLA, but 2 badges remained active for 3 and 5 business days after the employee's last day respectively. Both were voluntary terminations where the manual handoff between IT and the facilities team caused the delay. The facilities manager confirmed this gap and reported that a ServiceNow automation to directly trigger badge deactivation is under development for deployment by May 2026. The visitor management process is operational with consistent adherence to procedures. Visitor logs for the past 30 days showed 47 visitor entries, all with complete registration data (name, company, host, purpose, entry/exit time). Visitor badges are visually distinct (bright orange, date-printed) and reconciliation records confirm 100% badge return. Three vendor technician visits to the server room (two for Palo Alto maintenance, one for HVAC) followed the pre-approval process with ServiceNow documentation. Environmental controls in the server room are operational. Temperature and humidity sensors, water leak detection, and smoke detection are active with appropriate alert thresholds. The January 2026 quarterly environmental test confirmed all systems functioning within parameters. UPS provides 30 minutes of battery runtime with automatic transfer to the building backup generator. AWS physical security for production Kubernetes workloads is inherited through the shared responsibility model. The most recent AWS SOC 2 Type II report review (November 2025) confirmed adequate physical controls at AWS data centers with no concerns raised. Physical access logs are retained in the ACS but are not forwarded to the SIEM for correlation with logical access events. Nadia Khan highlighted this as a gap: the inability to correlate physical entry to the server room with concurrent Active Directory or AWS authentication events limits investigation capability for insider threat scenarios. ### Strengths - 8-zone physical access classification with role-based access matrix - Server room protected by badge-plus-PIN multi-factor physical authentication - Monthly review of server room access authorization (11 authorized individuals) - Visitor management achieves 100% badge return and complete registration data - Vendor technician visits follow pre-approval process with ServiceNow documentation - Environmental monitoring operational with quarterly testing cadence - AWS physical security validated through annual SOC 2 Type II report review ### Gaps - 2 of 6 sampled terminations had delayed badge deactivation (3-5 business days) - Badge deactivation relies on manual handoff between IT and facilities - Physical access logs not forwarded to SIEM for logical-physical correlation - No anti-tailgating measures at main building entrance - Visitor log is paper-based with no digital visitor management system - Server room camera footage not integrated with ACS badge logs for automated correlation",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AT-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review training program documentation\n2. Verify Workday training records\n3. Examine phishing simulation results\n4. Assess new hire onboarding process",
    "linkedArtifacts": [
      "Acceptable Use Policy",
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Q1 2026 Phishing Simulation Report"
    ],
    "linkedFindings": [
      "FND-1086",
      "FND-1087",
      "FND-1088"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - **Mature quarterly training cadence.** Alma exceeds the annual training minimum with quarterly security awareness modules delivered through Workday to all 300 employees. The Q1 module serves as the comprehensive annual refresher while Q2-Q4 modules address targeted topics. - **Effective phishing simulation program.** Quarterly phishing simulations have driven a measurable improvement in employee resilience. Click rates have declined from 18% to approximately 7% over four quarters. Repeat clickers are automatically enrolled in supplemental training through Workday. - **Strong new hire onboarding integration.** Security training is gated in the onboarding process -- ServiceNow access provisioning requires Workday training completion confirmation. This prevents new employees from receiving system access before completing baseline security awareness training. - **Active reporting culture.** The phishing@almasecurity.com reporting inbox and #security-alerts Slack channel provide clear, well-communicated mechanisms for employees to report suspicious activity. The D&R team provides feedback to reporters, which reinforces the behavior. - **Policy documentation includes consequences.** Both the Acceptable Use Policy and Information Security Policy contain explicit sections on consequences for cybersecurity violations, with a documented escalation path from retraining through formal disciplinary action. ### Gaps - **No scored knowledge assessments.** Workday training modules use acknowledgment-based completion rather than scored quizzes with pass/fail thresholds. This means completion is verified but actual comprehension is not quantitatively measured. This is the most significant gap in the awareness program. - **Contractor coverage incomplete.** The 12 EMEA-based contractors are enrolled in the same training program but content is not localized. The AUP acknowledgment requirement has not been formally extended to all contractor personnel through the vendor onboarding process. - **No vishing or SMS simulation.** Phishing simulations are limited to email-based campaigns. Voice-based (vishing) and SMS-based (smishing) social engineering vectors are not tested, leaving a gap in assessing employee preparedness for non-email attack channels. - **No unified assessment dashboard.** Phishing simulation results, Workday completion records, and incident reporting data exist in separate systems with no consolidated view of workforce security awareness posture.",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.AT-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Identify roles designated as requiring specialized training\n2. Review role-based training curriculum and delivery records\n3. Examine hands-on and technical skill validation\n4. Assess periodic knowledge testing for specialized roles\n5. Verify annual refresher requirements",
    "linkedArtifacts": [
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Acceptable Use Policy",
      "Q1 2026 Phishing Simulation Report"
    ],
    "linkedFindings": [
      "FND-1089",
      "FND-1090",
      "FND-1091",
      "FND-1092",
      "FND-1093"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - **D&R team receives structured vendor training.** Nadia Khan's D&R team completes SentinelOne EDR training through the vendor platform, and the team participates in incident response tabletop exercises. This team has the most mature specialized training practice at Alma. - **VM team pursues professional development.** Chris Magann holds GIAC certifications that Alma partially funds, and both Chris and Tigan Wang attend vendor conferences and webinars. The team demonstrates individual initiative in maintaining specialized knowledge. - **Tabletop exercises provide practical assessment.** The Q4 2025 tabletop exercise tested D&R analysts on incident handling and escalation procedures. The exercise identified actionable gaps in cloud-specific (AWS) incident response that were subsequently addressed through targeted training. - **Operational performance serves as informal assessment.** D&R incident response metrics (MTTD, MTTR) and VM remediation tracking provide indirect evidence of whether specialized personnel possess the required skills to execute their responsibilities effectively. ### Gaps - **No formal role classification matrix.** Specialized training designations are based on institutional knowledge rather than a documented, policy-backed role classification matrix. As Alma scales, new roles may not be evaluated for specialized training requirements. - **Training tracked outside Workday.** Specialized training completion is tracked in team-level spreadsheets and vendor portals rather than the centralized Workday platform. This creates fragmented audit trails and limits management visibility into compliance. - **No formal competency assessments.** There are no structured, periodic tests or evaluations to measure whether specialized personnel have retained and can apply role-specific knowledge. Competency is inferred from operational performance rather than directly assessed. - **No annual specialized refresher policy.** While general awareness refreshers are mandated quarterly, there is no distinct policy requirement for specialized role refreshers covering role-specific content. Refresher activity depends on vendor release cycles and individual initiative. - **Developer security training is optional.** Developer and DevSecOps roles are not formally designated as specialized training roles despite having production access and writing security-sensitive code. Security training for these roles is limited to optional lunch-and-learn sessions. - **VM team lacks formal curriculum.** While the VM team members are skilled, there is no documented training plan that maps to their specific responsibilities with Alma's AWS and Windows domain controller infrastructure.",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.DS-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review data-at-rest encryption policy and standards\n2. Assess encryption implementation across storage systems\n3. Evaluate data integrity controls\n4. Test access restrictions on data-at-rest\n5. Examine removable media controls\n6. Validate secure storage infrastructure",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Data Classification Policy",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1094",
      "FND-1095",
      "FND-1096",
      "FND-1097",
      "FND-1098",
      "FND-1099"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "### Strengths - AES-256 encryption standard is defined and being systematically deployed across all storage platforms through two dedicated projects (Data Encryption Upgrade $95K, S3 Bucket Security $70K) - AWS RDS PostgreSQL encryption at rest is enabled on all production instances using KMS customer-managed keys - SentinelOne removable media controls are fully deployed across the 300-person endpoint fleet with a documented exception process and weekly DLP log review - Biometric data receives application-level encryption before storage, providing defense-in-depth beyond infrastructure encryption - KMS key rotation is configured on a 365-day cycle with CloudTrail audit logging of all key usage - BitLocker encryption is enabled on on-premises Windows Domain Controller servers ### Gaps - S3 bucket encryption migration from SSE-S3 to SSE-KMS (customer-managed keys) is approximately 60% complete; remaining buckets have less granular key management control - Data classification schema is still in development, meaning encryption requirements cannot be fully mapped to data sensitivity levels - No centralized encryption compliance dashboard spanning both cloud and on-premises environments, limiting cross-environment visibility - File integrity monitoring via SentinelOne has coverage gaps on some Kubernetes worker nodes - Key rotation cycle of 365 days may be insufficient for keys protecting biometric data (highest sensitivity) - Proactive data integrity validation program is not yet established; reliance on reactive FIM monitoring only - On-premises encryption compliance is not centrally reported, requiring manual verification",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.DS-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review data-in-transit encryption policy and standards\n2. Assess TLS configuration and enforcement\n3. Evaluate internal service communication encryption\n4. Test VPN and remote access encryption\n5. Validate unencrypted connection blocking",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary"
    ],
    "linkedFindings": [
      "FND-1100",
      "FND-1101",
      "FND-1102",
      "FND-1103",
      "FND-1104",
      "FND-1105"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - TLS 1.2 minimum is enforced across all externally-facing services, with TLS 1.3 enabled where supported - HSTS headers deployed on all web properties with max-age of one year and includeSubDomains - SSL Labs scan results show A or A+ ratings across all tested public endpoints with no deprecated cipher suites - Internal service mesh provides mutual TLS (mTLS) for pod-to-pod communication within Kubernetes - PostgreSQL connections enforce SSL mode \"verify-full\" requiring both encryption and certificate verification - VPN uses IKEv2 with AES-256 encryption and certificate-based authentication for remote access - Site-to-site VPN with IPsec encryption connects AWS to on-premises Redwood City environment - HTTP-to-HTTPS redirects confirmed operational on all web properties - AWS Config rules detect non-compliant TLS configurations with 48-hour remediation SLA ### Gaps - TLS 1.3 is not yet the default on all endpoints; some load balancers still use TLS 1.2-minimum policies - No automated TLS certificate expiration monitoring beyond ACM auto-renewal (third-party certificates may lack monitoring) - VPN split tunnel exceptions are not fully documented with business justifications - Automated SSL scanning does not cover internal-only service mesh endpoints - On-premises Windows DC transport encryption policy is not formally documented separately from the general encryption standard - Development and staging environments may allow plaintext connections for debugging purposes without documented exception tracking - S3 SecureTransport condition not yet applied to all buckets (in progress via S3 Bucket Security project)",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.DS-10 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review data-in-use protection policies and standards\n2. Assess memory handling for sensitive data\n3. Evaluate process isolation controls\n4. Test unauthorized data-in-use access prevention",
    "linkedArtifacts": [
      "Data Classification Policy",
      "Encryption Standards Policy",
      "SentinelOne Application Control Configuration Evidence"
    ],
    "linkedFindings": [
      "FND-1106",
      "FND-1107",
      "FND-1108",
      "FND-1109",
      "FND-1110",
      "FND-1111"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Kubernetes pod security standards enforce non-root execution, dropped capabilities, and privilege escalation prohibition across all workloads - Biometric processing services operate in a dedicated Kubernetes namespace with the most restrictive network policies (ingress only from API gateway, egress only to database) - Container runtime uses Linux namespace isolation (PID, network, mount, UTS, IPC) with seccomp profiles restricting system calls - Core dumps are disabled on all container hosts, preventing crash dumps from containing sensitive data - ASLR, DEP/NX, and stack canaries are enabled across all Linux container hosts - Windows Credential Guard is enabled on the Domain Controller, isolating credential material in a virtualization-based security container - SentinelOne provides behavioral monitoring for memory injection, process hollowing, and runtime attack patterns ### Gaps - No formal secure memory handling standard for application development; memory clearing practices for biometric data are implemented but not independently verified - Application-level memory clearing of biometric data after processing has not been validated through code review or memory analysis - No hardware-based confidential computing (Intel SGX, AMD SEV) for biometric processing workloads; data is unencrypted in memory during processing - No unified data-in-use protection program; controls exist across multiple tools but are not managed as a coordinated capability with coverage metrics - DLP monitoring does not specifically cover data-in-use exfiltration vectors (screen capture, clipboard scraping, memory dump extraction) - Container runtime security has not been independently audited or penetration tested - Data-in-use protection requirements are not yet mapped to data classification levels",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.DS-11 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review backup policy and procedures\n2. Assess backup execution and completeness\n3. Evaluate backup confidentiality and integrity protection\n4. Test backup restoration procedures\n5. Verify off-site and geographic backup distribution",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ],
    "linkedFindings": [
      "FND-1112",
      "FND-1113",
      "FND-1114",
      "FND-1115",
      "FND-1116",
      "FND-1117",
      "FND-1118",
      "FND-1119"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 7,
        "observations": "### Strengths - Automated daily backups operational for all critical systems: RDS PostgreSQL (35-day retention with continuous archiving), S3 (versioning enabled), Kubernetes persistent volumes (Velero nightly, 30-day retention), and on-premises Windows DC - RDS continuous transaction log archiving enables point-in-time recovery to any second within the 35-day retention window, supporting an RPO of 5 minutes for the continuous authentication platform - Quarterly restore testing program is established with documented test plans and formal test reports; Q4 2025 test successfully restored PostgreSQL database within 45 minutes - Backup encryption is enforced across all platforms: RDS uses KMS CMK, S3 backup buckets use SSE-KMS, on-premises backups use Windows Server Backup encryption - Cross-region backup replication is configured for RDS snapshots and critical S3 data - IAM policies separate backup create and backup delete permissions, providing ransomware resilience through duty separation - GitOps repository provides version-controlled infrastructure-as-code serving as configuration backup and recovery mechanism ### Gaps - No full-environment DR recovery test has been conducted; quarterly tests cover individual system restoration only - RTO and RPO targets are defined informally and have not been formally approved by business stakeholders - Q1 2026 quarterly restore test has not yet been conducted (due by end of March) - S3 Object Lock (WORM protection) is not yet deployed to all backup buckets; rollout in progress via S3 Bucket Security project - Velero backup scope does not cover all Kubernetes namespaces; some non-production workloads with persistent data lack backup coverage - No automated alerting for backup job failures; current monitoring relies on manual log review - On-premises backup replication to AWS relies on a manual scheduled transfer process without failure alerting - DR plan is still in development through the Cloud Security Optimization project ($100K); formal recovery procedures not yet documented - Cross-region backup restoration has not been tested",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.IR-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review network architecture and segmentation design\n2. Examine firewall and gateway security controls\n3. Assess network integrity monitoring capabilities\n4. Evaluate network access control for device connectivity\n5. Test segmentation effectiveness",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Physical Security Policy",
      "Backup and Restore Procedure"
    ],
    "linkedFindings": [
      "FND-1120",
      "FND-1121",
      "FND-1122",
      "FND-1123",
      "FND-1124"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Palo Alto next-generation firewall provides application-layer inspection and zone-based segmentation at the on-premises perimeter with 2FA enforcement for administrative access - VPC Flow Logs and DNS query logging provide foundational network visibility across the AWS environment - AWS VPC architecture uses multi-AZ design with Security Groups enforcing tier-level micro-segmentation - Kubernetes namespaces provide logical separation of workloads within the cluster ### Gaps - **No WAF deployed** — Internet-facing SaaS application lacks application-layer filtering; WAF Install project ($112K) is in progress but not yet operational, leaving exposure to OWASP Top 10 attacks - **No formal network segmentation policy** — Segmentation exists in practice but is not governed by a documented policy defining trust zones, allowed flows, and review cadence - **NAC not implemented** — No pre-admission device posture assessment; devices connect to the corporate network based on physical access alone - **Kubernetes network policies incomplete** — Not all namespaces enforce network policies, allowing potential east-west lateral movement within the cluster - **Windows Server 2012 R2 on the network** — Legacy fileserver on an unsupported OS increases the attack surface for the network segment it occupies; Q3 upgrade planned but currently exposed - **No regular segmentation testing** — Segmentation effectiveness has not been independently validated through penetration testing or red team exercises",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.IR-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review physical environmental protection controls at Redwood City data center\n2. Assess AWS infrastructure environmental resilience\n3. Evaluate environmental monitoring and alerting\n4. Examine environmental controls maintenance program",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ],
    "linkedFindings": [
      "FND-1125",
      "FND-1126",
      "FND-1127",
      "FND-1128",
      "FND-1129"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "### Strengths - Fire suppression system is deployed in the Redwood City data center, providing automated detection and suppression - HVAC monitoring is active with alerting configured for temperature and humidity deviations - AWS multi-AZ production architecture provides inherent environmental resilience through geographic distribution of availability zones - Infrastructure team demonstrates understanding of the AWS shared responsibility model for physical and environmental controls ### Gaps - **No formal environmental risk assessment** — Environmental threats to the Redwood City facility have not been systematically identified and documented - **Fire suppression inspection records not reviewed** — Cannot independently confirm testing cadence, last inspection date, or system reliability - **Flood detection uncertain** — Presence of water intrusion sensors in the data center has not been confirmed, relevant given Northern California flood risk - **UPS capacity and testing undocumented** — Battery replacement schedule, load testing cadence, and capacity relative to current equipment load are not documented - **No environmental trend reporting** — HVAC monitoring captures events but trends are not analyzed to identify gradual degradation or capacity concerns - **Environmental monitoring not linked to IT incident management** — Environmental alerts may not trigger appropriate IT response procedures",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.IR-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review redundancy and failover architecture\n2. Assess disaster recovery planning and testing\n3. Evaluate high-availability component implementation\n4. Test failover capabilities\n5. Review resilience monitoring and incident response integration",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Incident Response Playbook (Excerpt)"
    ],
    "linkedFindings": [
      "FND-1130",
      "FND-1131",
      "FND-1132",
      "FND-1133",
      "FND-1134"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "### Strengths - **Multi-AZ deployment validated** — Production workloads distributed across multiple AWS Availability Zones, providing geographic resilience against single-zone failures - **Kubernetes pod redundancy operational** — Replica sets maintain multiple instances of critical services with automatic rescheduling on failure - **Auto-scaling configured** — Horizontal Pod Autoscalers dynamically adjust capacity based on utilization, providing both performance scaling and resilience through capacity headroom - **Failover testing completed** — The infrastructure team has actually tested failover rather than assuming the architecture works as designed; this is a strong operational maturity indicator - **Redundant storage and compute provisioned** — Critical systems have dedicated redundant resources - **High-availability components are a design principle** — The architecture reflects intentional HA design rather than afterthought ### Gaps - **DR plan not yet complete** — The disaster recovery plan is in development as part of the Cloud Security Optimization project ($100K budget), but no approved plan exists as of Q1 2026 - **RTO/RPO not formally defined** — Recovery objectives have not been documented or agreed upon with business stakeholders, making it impossible to measure DR readiness - **Failover test results not formally documented** — While testing was performed, formal documentation of scenarios tested, success criteria, observed recovery times, and lessons learned is limited - **No failover testing cadence established** — Testing was performed but no recurring schedule ensures continued validation as infrastructure evolves - **No DR tabletop exercise** — Coordination-level disaster recovery has not been tested; only technical failover has been validated - **On-premises resilience gap** — Redwood City data center does not have equivalent multi-site resilience capabilities",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.IR-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review capacity planning processes and documentation\n2. Evaluate auto-scaling and elastic capacity mechanisms\n3. Assess DDoS mitigation capabilities\n4. Review infrastructure monitoring for capacity events\n5. Evaluate power and environmental capacity",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ],
    "linkedFindings": [
      "FND-1135",
      "FND-1136",
      "FND-1137",
      "FND-1138",
      "FND-1139",
      "FND-1140",
      "FND-1141"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - **Kubernetes auto-scaling operational** — Horizontal Pod Autoscalers dynamically adjust pod counts based on CPU and memory utilization, providing reactive capacity management for production workloads - **AWS node auto-scaling configured** — Worker nodes scale in response to pod scheduling demand, extending capacity beyond pod-level scaling - **AWS Shield Standard active** — Baseline Layer 3/4 DDoS protection is automatically applied to all AWS resources - **Resource utilization monitoring in place** — CloudWatch and infrastructure monitoring dashboards track CPU, memory, and storage utilization with alerting ### Gaps - **No formal capacity planning process** — Capacity management is entirely reactive through auto-scaling; no proactive forecasting, growth modeling, or capacity reviews are performed - **No capacity model for business growth** — The relationship between customer growth (targeting 10,000 customers), feature deployment, and infrastructure resource requirements is not modeled - **No WAF for application-layer DDoS mitigation** — AWS Shield Standard only protects against volumetric Layer 3/4 attacks; application-layer (Layer 7) DDoS attacks are not mitigated; WAF project ($112K) in progress - **No DDoS response runbook** — Procedures for responding to an active DDoS attack are not documented, including escalation paths and decision criteria for engaging AWS Shield Advanced - **No rate limiting** — Neither the load balancer nor the application layer enforces rate limiting, leaving the platform vulnerable to request flooding - **On-premises capacity not documented** — Physical capacity constraints (rack space, power, cooling) for the Redwood City data center are not formally assessed - **Log storage capacity not assessed** — Retention requirements versus available storage for audit and investigation logs have not been evaluated - **Windows Server 2012 R2 capacity limitations** — Legacy fileserver may present storage and performance constraints given its age; Q3 upgrade planned",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.PS-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review configuration management policy and standards\n2. Examine hardened baseline documentation and enforcement\n3. Validate automated configuration compliance monitoring\n4. Test configuration drift detection and remediation\n5. Assess lifecycle management of baseline configurations",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Patch Management Procedure",
      "Weekly Vulnerability Scan Summary"
    ],
    "linkedFindings": [
      "FND-1142",
      "FND-1143",
      "FND-1144",
      "FND-1145"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 6,
        "observations": "### Strengths - Hardened baselines derived from CIS Benchmarks are documented and codified as infrastructure-as-code (Ansible playbooks and Terraform modules), providing repeatable and auditable configuration enforcement - 95% of production systems are running on hardened baselines, demonstrating strong deployment coverage - AWS Config provides continuous compliance monitoring with 47 custom and managed rules mapped to baseline standards - Deviation alerting is operational with tiered routing: PagerDuty for critical deviations, Slack for high severity, weekly digest for medium/low - Infrastructure-as-code approach ensures new systems inherit hardened configurations at provisioning time ### Gaps - 5% of systems (legacy development environments) are not on hardened baselines and operate without equivalent configuration enforcement - Kubernetes node baselines have not been independently validated against the CIS Kubernetes Benchmark (kube-bench not deployed) - On-premises Windows domain controller configurations are managed separately from the IaC workflow and lack equivalent automated compliance monitoring - Baseline review cadence is ad hoc rather than formally scheduled; no evidence of periodic review aligned with CIS Benchmark update cycles - Auto-remediation coverage is limited to approximately 30% of AWS Config rules; the majority of deviations require manual remediation",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.PS-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review software lifecycle management policy\n2. Examine software asset inventory and tracking\n3. Validate patch management operations\n4. Assess end-of-life and unsupported software tracking\n5. Verify software authenticity and integrity controls\n6. Test unauthorized software detection and removal",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ],
    "linkedFindings": [
      "FND-1146",
      "FND-1147",
      "FND-1148",
      "FND-1149",
      "FND-1150",
      "FND-1151"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Patch management program is operational with defined SLAs (critical: 14 days, emergency: 72 hours) enforced through AWS Systems Manager Patch Manager - Automated vulnerability scanning runs weekly (daily for crown jewel systems) and generates remediation tickets - Container base images are rebuilt weekly, providing regular patching cadence for containerized workloads - Software inventory tracked through SentinelOne (endpoints), AWS Systems Manager (servers), and Amazon ECR (container images) - Monthly patch compliance reporting to CISO provides executive visibility ### Gaps - Windows Server 2012 R2 fileserver is 2+ years past end-of-life with no vendor patches available; compensating controls in place but risk acceptance is aging - No software bill of materials (SBOM) for the SaaS platform; transitive dependency vulnerabilities not systematically tracked - Container image signing (Sigstore/Cosign) not implemented; no cryptographic verification of image integrity between build and deployment - Kubernetes node patching occasionally exceeds SLA due to workload scheduling coordination challenges - Application-layer dependency patching (npm, pip) relies on developer-initiated updates rather than automated tooling - Software procurement process does not consistently capture free/open-source tools used by developers - Estimated 15-20% of SaaS tools in use have not been through formal security review",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.PS-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review hardware lifecycle management policy\n2. Examine hardware asset inventory and tracking\n3. Validate hardware maintenance and warranty management\n4. Assess end-of-life hardware tracking and replacement\n5. Test secure hardware disposal and decommissioning",
    "linkedArtifacts": [
      "Alma Security Hardware Inventory",
      "Authorized Software Inventory",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1152",
      "FND-1153",
      "FND-1154",
      "FND-1155",
      "FND-1156",
      "FND-1157"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Laptop replacement follows a defined 4-year lifecycle with automated ServiceNow workflow triggers, covering approximately 300 endpoints - ServiceNow CMDB tracks on-premises hardware with asset tags, serial numbers, warranty dates, and ownership - AWS resource tagging standards provide cloud infrastructure tracking with Config-enforced tagging compliance - SentinelOne provides real-time hardware inventory data for all managed endpoints - Hardware disposal follows NIST SP 800-88 guidelines with certificates of destruction retained ### Gaps - No unified asset inventory dashboard combining on-premises and cloud hardware; teams use separate views requiring manual correlation - CMDB updates lag for asset transfers, relocations, and returns, resulting in stale inventory records identified during reconciliation - Windows Server 2012 R2 fileserver runs on out-of-warranty Dell hardware with no vendor support, compounding the software EOL risk with hardware failure risk - No standardized lifecycle replacement policy for server and infrastructure hardware; replacement is reactive rather than planned - Network infrastructure (switches, access points) has minimal lifecycle tracking in CMDB - Hardware disposal procedure documentation has not been updated since June 2024 - No automated EOL alerting based on vendor lifecycle data; tracking depends on institutional knowledge",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.PS-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review logging policy and requirements\n2. Examine log source coverage and collection\n3. Validate centralized log aggregation and management\n4. Test monitoring and anomaly detection\n5. Assess log integrity and access controls",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1158",
      "FND-1159",
      "FND-1160",
      "FND-1161",
      "FND-1162",
      "FND-1163"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "### Strengths - CloudTrail enabled across all AWS accounts capturing API activity with 12-month online retention and 24-month archival - VPC Flow Logs and GuardDuty provide network and threat detection coverage for AWS infrastructure - EKS audit logs collected via Fluent Bit daemonsets and forwarded to CloudWatch Logs - GuardDuty findings aggregated through Security Hub with PagerDuty routing for critical findings - 25 custom CloudWatch metric filters and alarms monitor high-value events (root account usage, IAM changes, security group modifications, S3 policy changes) - Logging and Monitoring Policy defines event categories, retention periods, and responsibilities ### Gaps - No centralized SIEM platform; reliance on AWS-native tools (CloudWatch, GuardDuty, Security Hub) limits cross-platform log correlation - On-premises systems (Windows DC, legacy fileserver) forward to local syslog server but are not integrated into the CloudWatch-based monitoring workflow - No 24/7 SOC monitoring; security team operates during business hours with PagerDuty on-call for critical alerts only - No cross-source correlation capability (e.g., correlating failed auth attempts with subsequent access from different IP) - Application-layer security logging is limited to error rates and latency; no behavioral analysis or business logic abuse detection - Logging policy lacks platform-specific configuration standards (specific Windows Event IDs, Linux auditd rules, K8s audit policy levels) - No proactive threat hunting program; detection is entirely alert-driven",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.PS-05 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review application control policy and standards\n2. Examine application control deployment and coverage\n3. Validate the authorized software inventory\n4. Test application control enforcement effectiveness\n5. Assess administrative privilege restrictions for software installation",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Authorized Software Inventory",
      "Acceptable Use Policy"
    ],
    "linkedFindings": [
      "FND-1164",
      "FND-1165",
      "FND-1166",
      "FND-1167",
      "FND-1168",
      "FND-1169"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 6,
        "observations": "### Strengths - SentinelOne deployed on 98%+ of workstations and laptops with application control policy active - Known malicious executables are blocked in real-time by SentinelOne behavioral AI and signature-based detection - Security team reviews application control alerts daily during business hours - ServiceNow maintains approved software catalog with self-service provisioning workflow - Windows endpoints enforce Group Policy restrictions preventing standard user software installation - Established blocklist/allowlist management process with business justification documentation ### Gaps - SentinelOne application control operates in hybrid mode (detect-only for unrecognized applications) rather than full enforcement; unrecognized executables can run pending manual review - 40% of users (engineering and product teams) have local admin rights on macOS devices, bypassing IT installation restrictions - Linux server execution control relies on baseline noexec mount options only; no allowlist-level enforcement (SELinux not enabled) - Kubernetes nodes accessible via shared SSH key on port 45001 with root access, allowing arbitrary code execution on cluster hosts and bypassing all container-level controls - Kubernetes pod security standards only partially enforced through custom admission webhook - Approved software catalog does not cover open-source tools, browser extensions, or developer libraries - No automated sync between ServiceNow catalog and SentinelOne allowlist",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "PR.PS-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review secure development lifecycle (SDLC) policy and standards\n2. Examine security integration in the CI/CD pipeline\n3. Validate third-party component and dependency management\n4. Assess developer security training and awareness\n5. Test security review and code review practices\n6. Validate vulnerability remediation in developed software",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1170",
      "FND-1171",
      "FND-1172",
      "FND-1173",
      "FND-1174",
      "FND-1175",
      "FND-1176",
      "FND-1177",
      "FND-1178"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 2,
        "targetScore": 5,
        "observations": "### Strengths - Containerized application architecture deployed on AWS EKS provides infrastructure-level isolation - Amazon ECR image scanning (Inspector-powered) identifies known CVEs in container images on push - CI/CD pipeline built on GitLab CI with automated unit and integration testing - Container base images rebuilt weekly, providing regular security update cadence for dependencies within images - CISO has flagged SSDLC establishment as a priority for Q3 2026, indicating organizational awareness of the gap ### Gaps - No formal Secure Software Development Lifecycle (SSDLC) policy or standards document; security in development is ad hoc and dependent on individual developer awareness - No SAST tooling integrated into CI/CD pipeline; source code is not automatically analyzed for security vulnerabilities before deployment - No DAST tooling; the running application is not tested for vulnerabilities like SQL injection or XSS through automated scanning - No security quality gates in the pipeline; container images with critical CVEs can deploy to production without blocking - SQL Injection Mitigation project ($60K budget) has not started despite being identified through vulnerability scanning; this represents a known, unaddressed vulnerability class in the production application - No SBOM generation or automated software composition analysis for dependency tracking - No threat modeling practice for new features or architectural changes - No developer security training program specific to secure coding practices - npm audit not enforced in the pipeline; dependency vulnerability scanning relies on ad-hoc developer initiative - No license compliance scanning for third-party dependencies",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.CO-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review recovery communication procedures and channels\n2. Evaluate stakeholder identification and notification lists\n3. Assess recovery information security during communication\n4. Test communication execution history\n5. Evaluate crisis communication coordination with suppliers",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1179",
      "FND-1180",
      "FND-1181",
      "FND-1182"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Incident communication procedures are documented in the incident response playbook, providing a foundation for recovery communication - Stakeholder communication during recovery uses Slack and direct channels, with defined internal notification paths - The 2024 security incidents demonstrated functional recovery communication with stakeholders, providing real-world execution evidence - Trust-rebuilding initiatives following 2024 incidents reflect organizational awareness of communication importance during recovery ### Gaps - **Communication procedures not rehearsed** — Recovery communication procedures have not been tested through tabletop exercises or communication drills, creating execution risk during high-stress incidents - **No formal communication cadence** — Recovery status update frequency is ad hoc rather than defined at regular intervals for different stakeholder groups - **Supplier communication not formalized** — Crisis communication procedures for coordinating with critical suppliers (AWS, SaaS vendors) are not documented - **Slack channel access controls not reviewed** — Recovery communication channels have not been formally reviewed for appropriate access controls and information security - **No contractual obligation register** — Information-sharing requirements from customer and vendor contracts are not consolidated into a reference register for recovery communication",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.CO-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review public communication policy and approval process\n2. Evaluate public messaging templates and content guidelines\n3. Assess breach notification compliance\n4. Test public communication execution history",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1183",
      "FND-1184",
      "FND-1185"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Breach notification procedures exist within the incident response playbook addressing regulatory notification requirements - The 2024 security incidents triggered breach notification and public communication, providing real execution evidence - Public trust score KPI tracking demonstrates organizational commitment to measuring and recovering public confidence - Trust-rebuilding initiatives following 2024 incidents indicate lessons learned were applied to public communication strategy ### Gaps - **No pre-approved messaging templates** — Public communication templates for incident recovery exist in draft form but have not been pre-approved for rapid deployment, creating delays during incidents - **Approval workflow not formalized** — The public communication approval process (legal review, leadership sign-off) is understood but not documented as a formal workflow with defined roles and timelines - **Breach notification compliance not independently verified** — Compliance with specific regulatory notification timelines and content requirements has not been independently validated - **No public communication rehearsal** — Public messaging has not been tested through a tabletop or simulation exercise to validate the end-to-end approval and release process",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.RP-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review recovery plan activation criteria and procedures\n2. Evaluate recovery role assignments and communication\n3. Assess recovery plan execution history\n4. Test recovery initiation readiness\n5. Evaluate recovery authorization and decision-making",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ],
    "linkedFindings": [
      "FND-1186",
      "FND-1187",
      "FND-1188"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Incident response playbook includes recovery initiation procedures with defined handoff criteria from containment to recovery - Quarterly restore testing validates recovery execution for PostgreSQL backups and verifies automated backup integrity - AWS multi-AZ architecture and Kubernetes pod redundancy provide infrastructure-level recovery capabilities that were exercised during 2024 incidents - 2024 security incident recovery demonstrated the team's ability to execute recovery procedures under real conditions ### Gaps - **DR plan not yet complete** — The Cloud Security Optimization project ($100K) is developing the formal DR plan, but recovery procedures currently rely on the incident response playbook without a dedicated recovery plan document - **Recovery plan not rehearsed end-to-end** — Quarterly restore tests validate backup restoration but do not exercise the full recovery plan activation including role notification, decision-making, and communication procedures - **No formal recovery training** — Personnel with recovery responsibilities have not received dedicated recovery role training or participated in tabletop exercises - **Recovery authorization criteria informal** — The authority and criteria to initiate recovery operations are understood operationally but not formally documented",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.RP-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review recovery action selection and prioritization criteria\n2. Evaluate recovery scoping procedures\n3. Assess recovery action execution capabilities\n4. Test recovery prioritization adaptability",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ],
    "linkedFindings": [
      "FND-1189",
      "FND-1190",
      "FND-1191"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Recovery actions leverage multiple proven mechanisms: PostgreSQL automated backup restoration, AWS multi-AZ failover, and Kubernetes pod redeployment - Quarterly restore tests validate execution of core recovery actions on a regular cadence - The 2024 security incident recovery demonstrated adaptive recovery action selection when the scope of impact evolved - The continuous authentication platform is recognized as the highest-priority recovery target ### Gaps - **No formal recovery prioritization framework** — Recovery actions are selected based on engineering judgment rather than a documented prioritization matrix tied to business impact analysis - **Limited multi-system recovery coordination** — Procedures for coordinating recovery across multiple interdependent systems are not documented - **DR plan incomplete** — The Cloud Security Optimization project will formalize recovery action selection criteria, but is not yet delivered - **Resource constraint planning absent** — No documented approach for adjusting recovery priorities when personnel or infrastructure resources are constrained",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.RP-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review automated backup verification procedures\n2. Evaluate backup integrity testing during quarterly restore tests\n3. Assess backup security controls\n4. Test restoration asset inventory and currency",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1192",
      "FND-1193",
      "FND-1194"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "### Strengths - Automated backup verification runs against PostgreSQL backups and confirms integrity before restoration - Quarterly restore tests validate backup completeness and data consistency in isolated environments - AWS-managed backup encryption provides tamper protection at the storage layer - Backup verification is automated rather than manual, reducing human error in integrity checks ### Gaps - **No IOC scanning of backup assets** — Backup integrity verification checks for corruption but does not scan for indicators of compromise that could reintroduce threats during restoration - **Restoration asset inventory incomplete** — Not all restoration assets (Kubernetes manifests, infrastructure-as-code templates, application configuration) are covered by integrity verification - **No immutable backup copies** — Backups are not stored in an immutable or write-once format to protect against ransomware or insider tampering - **Verification scope limited to databases** — Automated verification focuses on PostgreSQL backups but does not extend to application-tier backup assets",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.RP-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review post-incident operational norm establishment process\n2. Evaluate system restoration confirmation procedures\n3. Assess restored system performance monitoring\n4. Test post-incident risk reassessment",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1195",
      "FND-1196",
      "FND-1197"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - The 2024 security incidents drove establishment of trust-rebuilding initiatives and KPI tracking for the public trust score, demonstrating post-incident operational norm adjustment - AWS multi-AZ architecture provides infrastructure-level support for maintaining service delivery during post-incident operations - System owners participate in restoration confirmation through Slack coordination and direct communication - Post-recovery monitoring using Kubernetes health checks and AWS CloudWatch validates restored system performance ### Gaps - **No formal RTO/RPO documentation** — Service delivery objectives for the continuous authentication platform and other critical systems are not documented; the DR plan project will address this - **System owner sign-off not formalized** — Restoration confirmation relies on informal communication rather than documented acceptance criteria and sign-off procedures - **No post-restoration monitoring enhancement procedure** — Enhanced monitoring during post-recovery stabilization is applied ad hoc rather than following a documented procedure - **Risk register updates not systematic** — Post-incident risk reassessment occurs but is not systematically linked to risk register entries with tracking and closure",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.RP-05 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review restored asset integrity verification procedures\n2. Evaluate restoration correctness validation\n3. Assess normal operating status confirmation\n4. Test post-restoration security validation",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ],
    "linkedFindings": [
      "FND-1198",
      "FND-1199",
      "FND-1200"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Quarterly restore tests verify PostgreSQL data integrity and application functionality in isolated environments before production deployment - Automated backup verification confirms data integrity prior to restoration attempts - Kubernetes pod health checks and AWS resource monitoring provide automated verification of restored infrastructure - 2024 incident recovery included root cause remediation verification before service restoration ### Gaps - **No formal IOC scanning post-restoration** — Restored assets are not scanned for indicators of compromise as a documented step in the recovery procedure - **End-to-end functional testing not automated** — Post-restoration testing of the continuous authentication service relies on manual verification rather than automated end-to-end tests - **No defined stabilization period** — There is no documented observation period between restoration completion and full operational declaration - **Security control validation not explicit** — Post-restoration verification does not include an explicit checklist for confirming security controls (access controls, encryption, logging) are operational",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RC.RP-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review recovery closure criteria\n2. Evaluate after-action reporting process\n3. Assess lessons learned integration\n4. Test recovery documentation completeness",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1201",
      "FND-1202",
      "FND-1203"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "### Strengths - Post-incident reviews are conducted following security incidents, capturing incident details, response and recovery actions, and lessons learned - The 2024 security incident after-action process drove concrete improvements including trust-rebuilding initiatives and procedure updates - Lessons learned from 2024 incidents were incorporated into updated incident response and recovery procedures - Recovery completion is communicated to stakeholders through Slack and leadership confirmation ### Gaps - **Post-incident review process not formalized** — No standard template, required sections, completion timeline, or quality review exists for after-action reports, leading to inconsistency - **Recovery closure criteria not documented** — The end of recovery is declared through informal leadership sign-off rather than against documented, measurable criteria - **Lessons learned tracking incomplete** — Lessons learned are captured but not systematically tracked to completion with assigned owners, deadlines, and closure verification - **No recovery documentation retention policy** — Incident recovery documentation retention requirements are not defined",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": false
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.AN-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review incident analysis methodology and procedures\n2. Examine completed incident analysis reports\n3. Validate analysis tooling and capabilities\n4. Test analyst competency and process adherence",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ],
    "linkedFindings": [
      "FND-1204",
      "FND-1205",
      "FND-1206"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "Alma Security performs incident root cause analysis using a combination of SentinelOne endpoint forensic telemetry, CloudTrail API event history, and GuardDuty findings to reconstruct incident timelines and identify attack vectors. The incident response playbook defines root cause analysis as a required step before incident closure, with documentation in the ServiceNow incident ticket. Nadia Khan's D&R team leads root cause investigations, with each incident assigned a lead analyst responsible for timeline reconstruction and vulnerability identification. Review of 3 closed incident tickets showed that all included root cause documentation, though the depth and rigor varied. The phishing incident (TKT-SOC-1001) included comprehensive root cause analysis tracing the attack vector through email delivery, credential compromise, and lateral movement. Two lower-severity incidents had root cause documented as a single paragraph without detailed event sequencing. The playbook does not define minimum root cause documentation standards or require formal root cause analysis techniques (such as 5-Whys or fault tree analysis). ### Strengths - Root cause analysis required as a mandatory step before incident closure per playbook - SentinelOne provides detailed endpoint forensic telemetry for timeline reconstruction - CloudTrail and GuardDuty provide cloud-level event history for attack vector identification - Lead analyst assigned for each incident responsible for root cause determination ### Gaps - Root cause documentation depth inconsistent across incidents; no minimum standard defined - No formal root cause analysis methodology (5-Whys, fault tree, Ishikawa) required - Systemic root cause identification (beyond immediate technical cause) not consistently performed - Root cause findings not systematically fed back into detection rule tuning or control improvements",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.AN-06 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review investigation documentation requirements\n2. Examine investigation records for completeness\n3. Validate record integrity and preservation controls\n4. Test provenance tracking for collected evidence",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1207",
      "FND-1208",
      "FND-1209"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "Alma Security records investigation actions through ServiceNow incident ticket work notes, where responders document actions taken during investigation and response. Each work note entry includes a timestamp and the identity of the person making the entry, providing an audit trail of investigation activities. The incident lead is responsible for maintaining the incident record and ensuring comprehensive documentation of investigative steps. ServiceNow provides built-in audit trail integrity through its platform logging, capturing all modifications to incident records with tamper-evident timestamps. Review of 3 incident tickets showed that investigation actions were documented, but the level of detail varied between responders. The phishing incident ticket included detailed step-by-step investigation notes, while lower-severity incidents had summary-level documentation. The incident response playbook states documentation requirements but does not provide templates or checklists for minimum investigation action recording. ### Strengths - ServiceNow provides timestamped, identity-attributed work notes for all investigation actions - Platform audit trail captures all modifications to incident records with tamper-evident logging - Incident lead designated as responsible for documentation completeness - Evidence preservation procedures documented in the incident response playbook ### Gaps - Investigation documentation detail varies between responders; no standardized template - No checklist of minimum required investigation actions to document - Evidence chain-of-custody documentation not formalized beyond ServiceNow record integrity - No peer review of investigation documentation for completeness before incident closure",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.AN-07 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review incident data collection procedures\n2. Examine data collection tooling and capabilities\n3. Validate integrity preservation mechanisms\n4. Test provenance documentation for collected data",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ],
    "linkedFindings": [
      "FND-1210",
      "FND-1211",
      "FND-1212"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "Alma Security collects incident data and metadata from multiple sources during investigations. SentinelOne provides forensic data export capabilities including process trees, file system activity, network connections, and registry changes from affected endpoints. CloudTrail logs are stored in an S3 bucket with versioning enabled and server-side encryption, providing integrity protection for cloud-level event data. GuardDuty findings include metadata on detection context, severity, and related resources. Evidence preservation relies on the immutability of source systems (CloudTrail log integrity validation, S3 versioning) rather than a dedicated forensic evidence management system. The incident response playbook defines evidence collection as a required step, but there is no standardized evidence catalog or manifest that tracks what data was collected for each incident. SentinelOne's Deep Visibility provides rich endpoint telemetry retention for 14 days, after which historical data must be explicitly exported and preserved if needed for longer-term investigation. ### Strengths - CloudTrail log integrity validation and S3 versioning protect evidence immutability - SentinelOne Deep Visibility provides 14 days of rich endpoint forensic telemetry - Evidence collection defined as a required step in the incident response playbook - Multiple data sources (SentinelOne, CloudTrail, GuardDuty) provide comprehensive incident metadata ### Gaps - No dedicated forensic evidence management system or evidence locker - No standardized evidence catalog or manifest per incident - SentinelOne telemetry retention limited to 14 days without manual export - Evidence provenance documentation (who collected, when, how) not formalized",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.AN-08 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review magnitude estimation criteria and procedures\n2. Examine magnitude estimation in recent incidents\n3. Validate automated IOC scanning capabilities\n4. Test magnitude validation process",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ],
    "linkedFindings": [
      "FND-1213",
      "FND-1214",
      "FND-1215"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "Alma Security estimates incident magnitude through a combination of initial GuardDuty severity assessment and manual SOC analyst investigation. When an incident is declared, the assigned analyst reviews other potential targets by searching for indicators of compromise across the SentinelOne endpoint fleet and CloudTrail logs. GuardDuty findings include related resource identification that helps scope the blast radius within AWS infrastructure. SentinelOne's threat hunting capability allows analysts to search for IOCs (file hashes, IP addresses, domain names, behavioral patterns) across all managed endpoints. This provides the ability to identify additional compromised systems beyond the initial detection. However, the magnitude estimation process is largely manual and analyst-dependent. GuardDuty provides automated finding correlation within AWS but does not extend to on-premises or SaaS systems. There are no automated IOC sweep tools that run proactively when a new incident is declared. ### Strengths - SentinelOne threat hunting enables fleet-wide IOC sweeps across managed endpoints - GuardDuty correlates related findings across AWS accounts to identify blast radius - Incident response playbook includes magnitude estimation as a required investigation step - CloudTrail provides searchable event history for scoping cloud-level impact ### Gaps - No automated IOC sweep triggered upon incident declaration - Magnitude estimation is manual and dependent on individual analyst thoroughness - Cross-platform magnitude assessment (cloud + endpoint + SaaS) not unified - No validated magnitude estimation validation step before determining response scope",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.CO-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review notification policies and procedures\n2. Examine notification criteria and triggers\n3. Validate notification execution for recent incidents\n4. Test notification workflow and escalation chains",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1216",
      "FND-1217",
      "FND-1218"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "The incident response playbook defines stakeholder notification procedures for internal and external parties. Internal notification flows through Slack #security-alerts for the security team and escalates to executive leadership via direct communication for major incidents. The CISO (Gerry) is the designated authority for external notifications to regulators, law enforcement, and affected customers. Breach notification procedures reference applicable regulatory requirements, and contractual notification obligations are documented for key business partners and customers. Review of 2 recent incidents confirmed that internal stakeholder notification followed the playbook procedures. However, the organization has not conducted a tabletop exercise specifically testing the external breach notification workflow end-to-end, including regulatory filing, customer communication, and law enforcement engagement. Notification timelines and templates for different regulatory jurisdictions are documented but have not been validated through simulation. ### Strengths - Stakeholder notification procedures documented in the incident response playbook with clear escalation paths - Slack #security-alerts provides rapid internal security team notification - CISO designated as breach notification authority with documented decision criteria - Contractual notification obligations tracked for key business relationships - Regulatory notification requirements cataloged by jurisdiction ### Gaps - No tabletop exercise validating the external breach notification workflow end-to-end - Notification templates not tested through simulation - No automated tracking of notification compliance timelines - Customer notification distribution mechanism not pre-staged for rapid deployment",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.CO-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review information sharing policies and agreements\n2. Examine internal communication and escalation practices\n3. Validate external information sharing practices\n4. Test information sharing workflow execution",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1219",
      "FND-1220",
      "FND-1221"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "Alma Security shares incident information through defined channels based on the audience and sensitivity of the information. Internal information sharing occurs through Slack #security-alerts for the security team, ServiceNow incident tickets for detailed technical information, and executive status reports for leadership during major incidents. Nadia Khan coordinates incident status updates and ensures consistent messaging across internal channels. External information sharing is governed by contractual agreements and the CISO's authorization. Information sharing agreements with key partners define the scope, format, and classification of information that can be shared. The organization does not currently participate in ISACs or voluntary threat intelligence sharing communities. External communications undergo sensitive data sanitization before release to prevent inadvertent disclosure of proprietary indicators or victim-identifying information. ### Strengths - Incident information sharing procedures documented with clear channel assignments - Slack #security-alerts provides real-time security team coordination - Executive status reporting established for major incidents with defined cadence - Information sharing agreements with key partners define scope and classification - Sensitive data sanitization applied to external communications ### Gaps - No ISAC participation or voluntary threat intelligence sharing with industry peers - Crisis communication methods with critical suppliers not formalized beyond existing agreements - HR notification procedures for insider threat incidents not explicitly defined in the playbook - External sharing limited to contractual obligations; no proactive community contribution",
        "observationDate": "2026-03-14",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.MA-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review incident declaration criteria and authority\n2. Examine incident response plan execution procedures\n3. Validate third-party coordination capabilities\n4. Test plan execution through recent incidents or exercises",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1222",
      "FND-1223",
      "FND-1224"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "Alma Security's incident response plan execution follows a defined workflow from detection through response activation. GuardDuty high-severity findings automatically create ServiceNow incident tickets, initiating the response process. Nadia Khan or the on-call senior analyst designates an incident lead who coordinates response activities according to the playbook. The organization maintains a third-party DFIR retainer for incidents exceeding internal capacity. Review of 2 recent incidents confirmed that the response plan was activated within the defined timelines. The phishing incident (TKT-SOC-1001) demonstrated effective plan execution with appropriate incident lead designation, containment actions, and documentation. The third-party DFIR retainer agreement is current and includes defined escalation thresholds. However, tabletop exercises testing response plan execution against complex multi-vector scenarios have not been conducted in the past 12 months. The playbook does not include explicit triggers for activating business continuity or disaster recovery plans as supplementary response actions. ### Strengths - Automated detection-to-ticket pipeline through GuardDuty-ServiceNow integration ensures rapid response initiation - Incident lead designation process operational with clear accountability - Third-party DFIR retainer current and activation procedures documented - Recent incident execution demonstrated effective playbook adherence ### Gaps - No tabletop exercise conducted in the past 12 months testing complex multi-vector scenarios - Playbook lacks explicit triggers for business continuity or disaster recovery plan activation - No defined process for requesting external incident response assistance at scale - Response plan execution metrics (time to activate, time to contain) not systematically tracked",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.MA-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review triage and validation procedures\n2. Examine triage execution for recent incidents\n3. Validate severity estimation accuracy\n4. Test triage workflow and tooling",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1225",
      "FND-1226",
      "FND-1227"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "Alma Security triages incident reports through a structured ServiceNow workflow where SOC analysts perform preliminary review to confirm reports are cybersecurity-related and require investigation. GuardDuty findings arrive pre-classified by severity (Low/Medium/High), providing an initial estimate that analysts validate and adjust based on contextual factors. The SOC triage runbook defines severity estimation criteria including asset sensitivity, data exposure potential, and business impact indicators. Review of 5 recent incident reports showed consistent preliminary triage with appropriate cybersecurity relevance determination. Severity estimation accuracy was reasonable, though analysts occasionally adjusted initial GuardDuty severity ratings up or down based on organizational context. The triage process averages 30 minutes for initial validation during business hours, extending to 2-4 hours during after-hours on-call response. The SOC handles approximately 15-20 findings per week requiring triage, of which 3-5 are escalated to incident status. ### Strengths - Structured ServiceNow triage workflow with documented preliminary review steps - GuardDuty pre-classification provides automated initial severity estimation - SOC triage runbook defines clear severity estimation criteria - Analysts demonstrate contextual judgment in adjusting vendor severity ratings - Manageable triage volume enables thorough preliminary review ### Gaps - After-hours triage response time (2-4 hours) significantly slower than business hours (30 minutes) - No formal triage quality review or calibration process across analysts - Triage metrics (volume, accuracy, time-to-triage) not systematically tracked - No automated pre-triage enrichment to accelerate analyst review",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.MA-03 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review categorization and prioritization framework\n2. Examine categorization and prioritization for recent incidents\n3. Validate prioritization decision-making\n4. Test categorization consistency",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1228",
      "FND-1229",
      "FND-1230"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "The incident response playbook defines an incident categorization taxonomy covering common incident types: malware, phishing, unauthorized access, data breach, denial of service, insider threat, and misconfiguration. ServiceNow incident records include category and subcategory fields aligned to this taxonomy. Prioritization uses a matrix combining incident scope, likely impact, and time-sensitivity to assign priority levels (P1-Critical through P4-Informational). Review of 4 recent incidents showed consistent categorization. Prioritization was appropriate in all cases, with documented justification for the assigned priority level. Response strategy selection (contain-then-eradicate, monitor-and-assess, or immediate escalation) was documented for 3 of 4 incidents. The categorization taxonomy covers standard incident types but does not include cloud-specific categories (misconfigured IAM, exposed S3 bucket, compromised Lambda function) that reflect Alma's AWS-heavy infrastructure. ### Strengths - Incident categorization taxonomy defined in the playbook with standard incident types - ServiceNow priority matrix combines scope, impact, and time-sensitivity for consistent prioritization - Response strategy selection documented for most incidents with clear rationale - Prioritization justification consistently recorded in incident tickets ### Gaps - Categorization taxonomy lacks cloud-specific incident types relevant to Alma's AWS infrastructure - Response strategy selection not documented for all incidents (3 of 4 reviewed) - No automated prioritization assistance based on affected asset criticality - Concurrent incident prioritization (resource allocation across simultaneous incidents) not formally addressed",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.MA-04 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review escalation criteria and procedures\n2. Examine incident status tracking mechanisms\n3. Validate escalation execution for recent incidents\n4. Test escalation communication channels",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ],
    "linkedFindings": [
      "FND-1231",
      "FND-1232",
      "FND-1233"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "The incident response playbook defines escalation criteria based on incident severity, scope expansion, containment failure, and time-based triggers. ServiceNow incident tickets include escalation timers that trigger notification to the next level if resolution milestones are not met within defined windows. Nadia Khan serves as the primary escalation point for the D&R team, with the CISO (Gerry) as the executive escalation authority for major incidents. External escalation procedures include the third-party DFIR retainer activation threshold, law enforcement engagement criteria, and regulatory notification triggers. Review of 2 recent incidents showed appropriate escalation decisions, with one incident correctly escalated from the SOC analyst to Nadia Khan based on scope expansion. Ongoing incident status tracking occurs through ServiceNow dashboards, though real-time status is communicated primarily through Slack rather than the formal tracking system. ### Strengths - Escalation criteria documented with clear triggers for severity, scope, containment failure, and time-based thresholds - ServiceNow escalation timers automate notification for missed resolution milestones - Clear escalation chain from SOC analyst to D&R lead (Nadia Khan) to CISO (Gerry) - External escalation thresholds defined for DFIR retainer, law enforcement, and regulators - Recent incidents demonstrate appropriate escalation decision-making ### Gaps - Real-time incident status primarily communicated via Slack rather than formal tracking system - No automated escalation based on IOC sweep results or scope expansion detection - Escalation effectiveness metrics not tracked (time-to-escalate, escalation accuracy) - Cross-functional stakeholder escalation (legal, communications, HR) coordination procedures underdeveloped",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.MA-05 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review incident recovery initiation criteria\n2. Examine recovery decision-making for recent incidents\n3. Validate coordination between response and recovery phases\n4. Test recovery readiness assessment",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "Information Security Policy"
    ],
    "linkedFindings": [
      "FND-1234",
      "FND-1235",
      "FND-1236"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 3,
        "targetScore": 5,
        "observations": "The incident response playbook defines recovery initiation criteria requiring three conditions: confirmed containment effectiveness, completed threat eradication, and environmental stability assessment. The incident lead evaluates these criteria and documents the recovery readiness determination in the ServiceNow incident ticket. For major incidents (P1/P2), the CISO approves recovery initiation after reviewing the incident lead's assessment. Review of 2 incidents with recovery phases showed that containment verification was documented in both cases. However, the operational disruption assessment was minimal, noting only expected downtime rather than a comprehensive analysis of recovery impact on business operations. The playbook's recovery criteria do not include explicit checkpoints for data integrity verification, system validation testing, or stakeholder readiness confirmation before initiating recovery actions. ### Strengths - Recovery initiation criteria defined with three required conditions (containment, eradication, stability) - CISO approval gate for major incident recovery initiation provides executive oversight - Incident lead documents recovery readiness determination in ServiceNow - Containment verification consistently performed and documented before recovery ### Gaps - Operational disruption assessment during recovery is superficial; lacks structured business impact analysis - No data integrity verification checkpoint before recovery initiation - System validation testing not required as a pre-recovery gate - Stakeholder readiness confirmation not included in recovery criteria",
        "observationDate": "2026-03-15",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.MI-01 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review containment procedures and capabilities\n2. Examine automated containment capabilities\n3. Validate manual containment procedures for complex scenarios\n4. Test containment effectiveness through recent incidents",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ],
    "linkedFindings": [
      "FND-1237",
      "FND-1238",
      "FND-1239"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 5,
        "targetScore": 6,
        "observations": "Alma Security implements incident containment through both automated and manual mechanisms. SentinelOne provides automated endpoint containment by network-isolating compromised hosts upon confirmed malicious activity detection, maintaining only agent-to-cloud communication for remote investigation. GuardDuty auto-remediation Lambda functions contain cloud-based incidents by applying restrictive security groups to compromised EC2 instances, effectively quarantining them from production networks. Manual containment capabilities are available to Nadia Khan's D&R team through SentinelOne console, AWS security group modifications, Palo Alto firewall rule injection, and Active Directory account suspension. The incident response playbook documents available containment actions for each major incident type. The third-party DFIR retainer includes pre-authorized containment actions for incidents exceeding internal capacity. Review of 2 recent incidents showed effective containment execution. The SentinelOne automated containment response time was under 3 minutes from detection. Manual containment actions were documented in ServiceNow with timestamps and justification. However, containment action verification (confirming the containment was effective) is performed manually with no automated validation mechanism. ### Strengths - SentinelOne automated containment achieves sub-3-minute network isolation for endpoint threats - GuardDuty auto-remediation provides automated cloud workload containment - Multiple manual containment tools available with pre-authorized access for the D&R team - Containment actions documented in ServiceNow with timestamps and responder identification - Third-party DFIR retainer extends containment capability for major incidents ### Gaps - No automated containment effectiveness verification mechanism - Containment options for SaaS application compromise not defined - Automated containment thresholds may need tuning to prevent business disruption from false positives - VLAN-based quarantine for on-premises systems not implemented",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  },
  "RS.MI-02 Ex1": {
    "auditorId": 2,
    "testProcedures": "1. Review eradication procedures and capabilities\n2. Examine automated eradication capabilities\n3. Validate manual eradication procedures for complex scenarios\n4. Test eradication effectiveness through recent incidents",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)"
    ],
    "linkedFindings": [
      "FND-1240",
      "FND-1241",
      "FND-1242"
    ],
    "remediation": {
      "ownerId": null,
      "actionPlan": "",
      "dueDate": ""
    },
    "quarters": {
      "Q1": {
        "actualScore": 4,
        "targetScore": 5,
        "observations": "Alma Security performs incident eradication through automated and manual mechanisms. SentinelOne provides automated eradication through threat remediation (killing malicious processes, quarantining files) and rollback capabilities that reverse unauthorized system changes. GuardDuty auto-remediation Lambda functions perform eradication actions including revoking compromised IAM credentials, terminating unauthorized EC2 instances, and removing malicious security group rules. Manual eradication procedures in the incident response playbook cover system reimaging, credential rotation, malware removal, and persistence mechanism elimination. The D&R team maintains documented runbooks for common eradication scenarios. The third-party DFIR retainer includes eradication capabilities for advanced threats exceeding internal expertise. Review of 2 recent incidents showed effective eradication with documented actions. SentinelOne remediation was successful in both cases. However, post-eradication verification is inconsistent -- the phishing incident included thorough verification scanning, while the second incident's verification was limited to confirming the SentinelOne remediation completed without validating the absence of additional persistence mechanisms. ### Strengths - SentinelOne automated remediation and rollback provide rapid eradication capability - GuardDuty auto-remediation handles cloud-level eradication for common threat patterns - Manual eradication runbooks documented for common incident scenarios - Third-party DFIR retainer available for advanced threat eradication - Eradication actions documented in ServiceNow with outcome recording ### Gaps - Post-eradication verification inconsistent; no standardized verification checklist - Eradication of advanced persistent threats may require capabilities beyond current tooling - No automated re-scan or validation after eradication to confirm complete threat removal - Gold image inventory for system reimaging not regularly validated",
        "observationDate": "2026-03-16",
        "testingStatus": "Complete",
        "examine": true,
        "interview": true,
        "test": true
      },
      "Q2": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q3": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      },
      "Q4": {
        "actualScore": 0,
        "targetScore": 0,
        "observations": "",
        "observationDate": "",
        "testingStatus": "Not Started",
        "examine": false,
        "interview": false,
        "test": false
      }
    }
  }
};

export const COMPREHENSIVE_FINDINGS = [
  {
    "id": "FND-1001",
    "summary": "Cross-source correlation is manual and analyst-dependent, increasing investigation time",
    "description": "Cross-source correlation is manual and analyst-dependent, increasing investigation time",
    "complianceRequirement": "DE.AE-03 Ex1",
    "controlId": "DE.AE-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Deploy a unified SIEM platform to aggregate and auto-correlate GuardDuty findings, CloudTrail, VPC Flow Logs, and SentinelOne telemetry | Integrate third-party threat intelligence feeds beyond GuardDuty built-in lists | Develop automated correlation rules for common multi-source attack patterns | Establish normalized event taxonomy across all detection sources to enable consistent correlation",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1001",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1002",
    "summary": "Threat intelligence feed integration limited to GuardDuty built-in threat lists",
    "description": "Threat intelligence feed integration limited to GuardDuty built-in threat lists",
    "complianceRequirement": "DE.AE-03 Ex1",
    "controlId": "DE.AE-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Deploy a unified SIEM platform to aggregate and auto-correlate GuardDuty findings, CloudTrail, VPC Flow Logs, and SentinelOne telemetry | Integrate third-party threat intelligence feeds beyond GuardDuty built-in lists | Develop automated correlation rules for common multi-source attack patterns | Establish normalized event taxonomy across all detection sources to enable consistent correlation",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1002",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1003",
    "summary": "No automated correlation with physical access or identity management event sources",
    "description": "No automated correlation with physical access or identity management event sources",
    "complianceRequirement": "DE.AE-03 Ex1",
    "controlId": "DE.AE-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Deploy a unified SIEM platform to aggregate and auto-correlate GuardDuty findings, CloudTrail, VPC Flow Logs, and SentinelOne telemetry | Integrate third-party threat intelligence feeds beyond GuardDuty built-in lists | Develop automated correlation rules for common multi-source attack patterns | Establish normalized event taxonomy across all detection sources to enable consistent correlation",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1003",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1004",
    "summary": "No automated tool to map blast radius across interconnected systems",
    "description": "No automated tool to map blast radius across interconnected systems",
    "complianceRequirement": "DE.AE-04 Ex1",
    "controlId": "DE.AE-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop quantitative scope scoring rubric with defined criteria for system interdependency assessment | Implement automated asset interdependency mapping to assist blast radius estimation | Standardize scope documentation templates in ServiceNow with required fields | Include business impact quantification (affected users, revenue exposure) in triage workflow",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1004",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Weekly Vulnerability Scan Summary",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1005",
    "summary": "Inconsistent scope documentation detail across different SOC analysts",
    "description": "Inconsistent scope documentation detail across different SOC analysts",
    "complianceRequirement": "DE.AE-04 Ex1",
    "controlId": "DE.AE-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop quantitative scope scoring rubric with defined criteria for system interdependency assessment | Implement automated asset interdependency mapping to assist blast radius estimation | Standardize scope documentation templates in ServiceNow with required fields | Include business impact quantification (affected users, revenue exposure) in triage workflow",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1005",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Weekly Vulnerability Scan Summary",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1006",
    "summary": "Business impact quantification (revenue, customers affected) not systematically captured",
    "description": "Business impact quantification (revenue, customers affected) not systematically captured",
    "complianceRequirement": "DE.AE-04 Ex1",
    "controlId": "DE.AE-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop quantitative scope scoring rubric with defined criteria for system interdependency assessment | Implement automated asset interdependency mapping to assist blast radius estimation | Standardize scope documentation templates in ServiceNow with required fields | Include business impact quantification (affected users, revenue exposure) in triage workflow",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1006",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Weekly Vulnerability Scan Summary",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1007",
    "summary": "No automated daily digest or summary report of accumulated findings for leadership",
    "description": "No automated daily digest or summary report of accumulated findings for leadership",
    "complianceRequirement": "DE.AE-06 Ex1",
    "controlId": "DE.AE-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Extend after-hours paging to include medium-severity findings with potential for escalation | Implement daily automated detection summary report for security leadership | Add alert acknowledgment tracking with mean-time-to-acknowledge KPI | Configure business-unit-relevant alert routing for incidents affecting specific systems",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1007",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1008",
    "summary": "Alert distribution limited to security team; business unit stakeholders not included in relevant notifications",
    "description": "Alert distribution limited to security team; business unit stakeholders not included in relevant notifications",
    "complianceRequirement": "DE.AE-06 Ex1",
    "controlId": "DE.AE-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Extend after-hours paging to include medium-severity findings with potential for escalation | Implement daily automated detection summary report for security leadership | Add alert acknowledgment tracking with mean-time-to-acknowledge KPI | Configure business-unit-relevant alert routing for incidents affecting specific systems",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1008",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1009",
    "summary": "No mechanism to confirm alert acknowledgment or track mean time to acknowledge",
    "description": "No mechanism to confirm alert acknowledgment or track mean time to acknowledge",
    "complianceRequirement": "DE.AE-06 Ex1",
    "controlId": "DE.AE-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Extend after-hours paging to include medium-severity findings with potential for escalation | Implement daily automated detection summary report for security leadership | Add alert acknowledgment tracking with mean-time-to-acknowledge KPI | Configure business-unit-relevant alert routing for incidents affecting specific systems",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1009",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1010",
    "summary": "No formal CTI program or dedicated threat intelligence function",
    "description": "No formal CTI program or dedicated threat intelligence function",
    "complianceRequirement": "DE.AE-07 Ex1",
    "controlId": "DE.AE-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate ISAC membership and commercial CTI feed subscription for Alma's industry vertical | Establish formal vulnerability disclosure rapid assessment process for critical technology stack | Integrate asset inventory context into detection rule tuning to prioritize alerts for crown jewel systems | Develop lightweight threat modeling process aligned to Alma's threat landscape",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1010",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1011",
    "summary": "Vulnerability disclosure tracking is informal and reactive",
    "description": "Vulnerability disclosure tracking is informal and reactive",
    "complianceRequirement": "DE.AE-07 Ex1",
    "controlId": "DE.AE-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate ISAC membership and commercial CTI feed subscription for Alma's industry vertical | Establish formal vulnerability disclosure rapid assessment process for critical technology stack | Integrate asset inventory context into detection rule tuning to prioritize alerts for crown jewel systems | Develop lightweight threat modeling process aligned to Alma's threat landscape",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1011",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1012",
    "summary": "Asset inventory context not systematically integrated into detection tuning decisions",
    "description": "Asset inventory context not systematically integrated into detection tuning decisions",
    "complianceRequirement": "DE.AE-07 Ex1",
    "controlId": "DE.AE-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate ISAC membership and commercial CTI feed subscription for Alma's industry vertical | Establish formal vulnerability disclosure rapid assessment process for critical technology stack | Integrate asset inventory context into detection rule tuning to prioritize alerts for crown jewel systems | Develop lightweight threat modeling process aligned to Alma's threat landscape",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1012",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1013",
    "summary": "No threat modeling process to prioritize intelligence relevant to Alma's specific threat landscape",
    "description": "No threat modeling process to prioritize intelligence relevant to Alma's specific threat landscape",
    "complianceRequirement": "DE.AE-07 Ex1",
    "controlId": "DE.AE-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate ISAC membership and commercial CTI feed subscription for Alma's industry vertical | Establish formal vulnerability disclosure rapid assessment process for critical technology stack | Integrate asset inventory context into detection rule tuning to prioritize alerts for crown jewel systems | Develop lightweight threat modeling process aligned to Alma's threat landscape",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1013",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1014",
    "summary": "Incident criteria review cycle not defined; criteria may not reflect evolving threat landscape",
    "description": "Incident criteria review cycle not defined; criteria may not reflect evolving threat landscape",
    "complianceRequirement": "DE.AE-08 Ex1",
    "controlId": "DE.AE-08 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add compound event analysis criteria for scenarios where multiple low-severity findings indicate coordinated activity | Establish annual incident criteria review cycle aligned with threat landscape assessment | Implement false positive and missed incident rate tracking to measure criteria effectiveness | Develop calibration exercises for SOC analysts to improve consistency on borderline triage decisions",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1014",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1015",
    "summary": "Declaration threshold calibration relies on individual analyst interpretation for borderline cases",
    "description": "Declaration threshold calibration relies on individual analyst interpretation for borderline cases",
    "complianceRequirement": "DE.AE-08 Ex1",
    "controlId": "DE.AE-08 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add compound event analysis criteria for scenarios where multiple low-severity findings indicate coordinated activity | Establish annual incident criteria review cycle aligned with threat landscape assessment | Implement false positive and missed incident rate tracking to measure criteria effectiveness | Develop calibration exercises for SOC analysts to improve consistency on borderline triage decisions",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1015",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1016",
    "summary": "No metric tracking false positive rate or missed incident rate for criteria effectiveness",
    "description": "No metric tracking false positive rate or missed incident rate for criteria effectiveness",
    "complianceRequirement": "DE.AE-08 Ex1",
    "controlId": "DE.AE-08 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add compound event analysis criteria for scenarios where multiple low-severity findings indicate coordinated activity | Establish annual incident criteria review cycle aligned with threat landscape assessment | Implement false positive and missed incident rate tracking to measure criteria effectiveness | Develop calibration exercises for SOC analysts to improve consistency on borderline triage decisions",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1016",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1017",
    "summary": "No organization-specific network baselines for deviation comparison",
    "description": "No organization-specific network baselines for deviation comparison",
    "complianceRequirement": "DE.CM-01 Ex1",
    "controlId": "DE.CM-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable VPC Flow Logs on all non-production VPCs to eliminate monitoring blind spots | Implement network flow baselining to detect deviations specific to Alma's traffic patterns | Deploy wireless intrusion detection or rogue AP scanning for corporate office network | Extend VPC Flow Log retention to 365 days to support long-duration investigation needs",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1017",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1018",
    "summary": "Wireless network monitoring limited to corporate office; no rogue AP detection capability",
    "description": "Wireless network monitoring limited to corporate office; no rogue AP detection capability",
    "complianceRequirement": "DE.CM-01 Ex1",
    "controlId": "DE.CM-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable VPC Flow Logs on all non-production VPCs to eliminate monitoring blind spots | Implement network flow baselining to detect deviations specific to Alma's traffic patterns | Deploy wireless intrusion detection or rogue AP scanning for corporate office network | Extend VPC Flow Log retention to 365 days to support long-duration investigation needs",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1018",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1019",
    "summary": "No automated network flow baseline comparison beyond GuardDuty anomaly models",
    "description": "No automated network flow baseline comparison beyond GuardDuty anomaly models",
    "complianceRequirement": "DE.CM-01 Ex1",
    "controlId": "DE.CM-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable VPC Flow Logs on all non-production VPCs to eliminate monitoring blind spots | Implement network flow baselining to detect deviations specific to Alma's traffic patterns | Deploy wireless intrusion detection or rogue AP scanning for corporate office network | Extend VPC Flow Log retention to 365 days to support long-duration investigation needs",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1019",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1020",
    "summary": "No integration between physical access logs and logical security monitoring",
    "description": "No integration between physical access logs and logical security monitoring",
    "complianceRequirement": "DE.CM-02 Ex1",
    "controlId": "DE.CM-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Route after-hours physical access alerts to security team in addition to facilities | Integrate physical access logs with SIEM for correlation with logical access events | Implement real-time anomaly detection for physical access patterns (tailgating, repeated failed badge attempts) | Add tamper detection on badge readers and physical access control panels",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1020",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1021",
    "summary": "Physical access anomaly detection is manual and monthly, not real-time",
    "description": "Physical access anomaly detection is manual and monthly, not real-time",
    "complianceRequirement": "DE.CM-02 Ex1",
    "controlId": "DE.CM-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Route after-hours physical access alerts to security team in addition to facilities | Integrate physical access logs with SIEM for correlation with logical access events | Implement real-time anomaly detection for physical access patterns (tailgating, repeated failed badge attempts) | Add tamper detection on badge readers and physical access control panels",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1021",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1022",
    "summary": "No tamper detection on physical access control hardware",
    "description": "No tamper detection on physical access control hardware",
    "complianceRequirement": "DE.CM-02 Ex1",
    "controlId": "DE.CM-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Route after-hours physical access alerts to security team in addition to facilities | Integrate physical access logs with SIEM for correlation with logical access events | Implement real-time anomaly detection for physical access patterns (tailgating, repeated failed badge attempts) | Add tamper detection on badge readers and physical access control panels",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1022",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1023",
    "summary": "Data exfiltration pattern monitoring not implemented",
    "description": "Data exfiltration pattern monitoring not implemented",
    "complianceRequirement": "DE.CM-03 Ex1",
    "controlId": "DE.CM-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate UEBA platform to correlate user activity across AD, AWS, and endpoint sources | Implement data exfiltration monitoring for bulk download, USB, and cloud storage upload patterns | Configure geographic and temporal anomaly alerts for user authentication events | Deploy honey tokens in sensitive data stores to detect unauthorized access attempts",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1023",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1024",
    "summary": "No monitoring for anomalous working hours or geographic access patterns",
    "description": "No monitoring for anomalous working hours or geographic access patterns",
    "complianceRequirement": "DE.CM-03 Ex1",
    "controlId": "DE.CM-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate UEBA platform to correlate user activity across AD, AWS, and endpoint sources | Implement data exfiltration monitoring for bulk download, USB, and cloud storage upload patterns | Configure geographic and temporal anomaly alerts for user authentication events | Deploy honey tokens in sensitive data stores to detect unauthorized access attempts",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1024",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1025",
    "summary": "Deception technology (honeypots, honey tokens) not deployed",
    "description": "Deception technology (honeypots, honey tokens) not deployed",
    "complianceRequirement": "DE.CM-03 Ex1",
    "controlId": "DE.CM-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate UEBA platform to correlate user activity across AD, AWS, and endpoint sources | Implement data exfiltration monitoring for bulk download, USB, and cloud storage upload patterns | Configure geographic and temporal anomaly alerts for user authentication events | Deploy honey tokens in sensitive data stores to detect unauthorized access attempts",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1025",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1026",
    "summary": "User activity monitoring does not correlate across AD, AWS, and endpoint sources",
    "description": "User activity monitoring does not correlate across AD, AWS, and endpoint sources",
    "complianceRequirement": "DE.CM-03 Ex1",
    "controlId": "DE.CM-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate UEBA platform to correlate user activity across AD, AWS, and endpoint sources | Implement data exfiltration monitoring for bulk download, USB, and cloud storage upload patterns | Configure geographic and temporal anomaly alerts for user authentication events | Deploy honey tokens in sensitive data stores to detect unauthorized access attempts",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1026",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1027",
    "summary": "No specific alerting rules for AWS service provider access events",
    "description": "No specific alerting rules for AWS service provider access events",
    "complianceRequirement": "DE.CM-06 Ex1",
    "controlId": "DE.CM-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Centralize SaaS provider audit logs into SIEM for unified third-party activity monitoring | Create specific alerting rules for AWS service provider access and unusual third-party role assumptions | Establish expected activity baselines for each external service provider | Implement quarterly third-party access review with activity log analysis",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1027",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1028",
    "summary": "Inconsistent monitoring coverage across different types of external service providers",
    "description": "Inconsistent monitoring coverage across different types of external service providers",
    "complianceRequirement": "DE.CM-06 Ex1",
    "controlId": "DE.CM-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Centralize SaaS provider audit logs into SIEM for unified third-party activity monitoring | Create specific alerting rules for AWS service provider access and unusual third-party role assumptions | Establish expected activity baselines for each external service provider | Implement quarterly third-party access review with activity log analysis",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1028",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1029",
    "summary": "No automated baseline for expected third-party activity patterns",
    "description": "No automated baseline for expected third-party activity patterns",
    "complianceRequirement": "DE.CM-06 Ex1",
    "controlId": "DE.CM-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Centralize SaaS provider audit logs into SIEM for unified third-party activity monitoring | Create specific alerting rules for AWS service provider access and unusual third-party role assumptions | Establish expected activity baselines for each external service provider | Implement quarterly third-party access review with activity log analysis",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1029",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1030",
    "summary": "No advanced email sandboxing or detonation for zero-day attachment analysis",
    "description": "No advanced email sandboxing or detonation for zero-day attachment analysis",
    "complianceRequirement": "DE.CM-09 Ex1",
    "controlId": "DE.CM-09 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate 3 legacy endpoint coverage gaps through OS upgrade or compensating controls | Deploy email sandboxing capability for advanced attachment and URL analysis | Implement continuous patch compliance monitoring rather than monthly scanning | Establish on-premises software configuration baselines with automated drift detection",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1030",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "SOC Incident Ticket",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1031",
    "summary": "On-premises software configuration baseline enforcement limited to SentinelOne application control",
    "description": "On-premises software configuration baseline enforcement limited to SentinelOne application control",
    "complianceRequirement": "DE.CM-09 Ex1",
    "controlId": "DE.CM-09 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate 3 legacy endpoint coverage gaps through OS upgrade or compensating controls | Deploy email sandboxing capability for advanced attachment and URL analysis | Implement continuous patch compliance monitoring rather than monthly scanning | Establish on-premises software configuration baselines with automated drift detection",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1031",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "SOC Incident Ticket",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1032",
    "summary": "Hardware tamper detection not implemented for on-premises equipment",
    "description": "Hardware tamper detection not implemented for on-premises equipment",
    "complianceRequirement": "DE.CM-09 Ex1",
    "controlId": "DE.CM-09 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate 3 legacy endpoint coverage gaps through OS upgrade or compensating controls | Deploy email sandboxing capability for advanced attachment and URL analysis | Implement continuous patch compliance monitoring rather than monthly scanning | Establish on-premises software configuration baselines with automated drift detection",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1032",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "SOC Incident Ticket",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1033",
    "summary": "Patch compliance monitoring is monthly rather than continuous",
    "description": "Patch compliance monitoring is monthly rather than continuous",
    "complianceRequirement": "DE.CM-09 Ex1",
    "controlId": "DE.CM-09 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate 3 legacy endpoint coverage gaps through OS upgrade or compensating controls | Deploy email sandboxing capability for advanced attachment and URL analysis | Implement continuous patch compliance monitoring rather than monthly scanning | Establish on-premises software configuration baselines with automated drift detection",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1033",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "SOC Incident Ticket",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1034",
    "summary": "New hires do not receive mission-security alignment briefing during onboarding",
    "description": "New hires do not receive mission-security alignment briefing during onboarding",
    "complianceRequirement": "GV.OC-01 Ex1",
    "controlId": "GV.OC-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add mission-security alignment to new hire onboarding | Distribute mission-security mapping to all department heads",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1034",
    "linkedArtifacts": [
      "Information Security Policy",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1035",
    "summary": "Partner ecosystem security expectations not yet documented",
    "description": "Partner ecosystem security expectations not yet documented",
    "complianceRequirement": "GV.OC-02 Ex1",
    "controlId": "GV.OC-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Update stakeholder register quarterly | Document partner ecosystem security expectations",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1035",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Quarterly Access Recertification Procedure"
    ]
  },
  {
    "id": "FND-1036",
    "summary": "Contractual obligation tracking incomplete for Tier 2 and Tier 3 customer agreements",
    "description": "Contractual obligation tracking incomplete for Tier 2 and Tier 3 customer agreements",
    "complianceRequirement": "GV.OC-03 Ex1",
    "controlId": "GV.OC-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Map AI regulatory requirements to existing policies | Extend contractual tracking to all customer tiers",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1036",
    "linkedArtifacts": [
      "Information Security Policy",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1037",
    "summary": "RTO/RPO objectives not tested against actual recovery capabilities in 6+ months",
    "description": "RTO/RPO objectives not tested against actual recovery capabilities in 6+ months",
    "complianceRequirement": "GV.OC-04 Ex1",
    "controlId": "GV.OC-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Update BIA to include Q3-Q4 2025 service additions | Conduct DR test to validate RTO/RPO objectives",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1037",
    "linkedArtifacts": [
      "Information Security Policy",
      "Authorized Software Inventory"
    ]
  },
  {
    "id": "FND-1038",
    "summary": "Failure mode analysis not completed for three recently onboarded critical SaaS tools",
    "description": "Failure mode analysis not completed for three recently onboarded critical SaaS tools",
    "complianceRequirement": "GV.OC-05 Ex1",
    "controlId": "GV.OC-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand dependency inventory to include vendor sub-processors | Complete failure mode analysis for recent SaaS additions",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1038",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "Third Party Risk Management Policy",
      "Alma Security Hardware Inventory"
    ]
  },
  {
    "id": "FND-1039",
    "summary": "Performance reviews for non-security personnel with cyber responsibilities lack consistency",
    "description": "Performance reviews for non-security personnel with cyber responsibilities lack consistency",
    "complianceRequirement": "GV.OV-02 Ex1",
    "controlId": "GV.OV-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Define incident severity threshold that triggers strategy review | Standardize cybersecurity performance criteria for non-security roles",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1039",
    "linkedArtifacts": [
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1040",
    "summary": "Some KRI thresholds set based on initial estimates, not validated against operational data",
    "description": "Some KRI thresholds set based on initial estimates, not validated against operational data",
    "complianceRequirement": "GV.OV-03 Ex1",
    "controlId": "GV.OV-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish industry benchmarking for KPIs | Validate KRI thresholds against 12 months of operational data",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1040",
    "linkedArtifacts": [
      "Information Security Policy",
      "Q4 2025 Access Recertification Report"
    ]
  },
  {
    "id": "FND-1041",
    "summary": "Supporting procedures referenced in policy not all updated to match latest policy revision",
    "description": "Supporting procedures referenced in policy not all updated to match latest policy revision",
    "complianceRequirement": "GV.PO-01 Ex1",
    "controlId": "GV.PO-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Close onboarding acknowledgment gap within 14 days of hire | Update supporting procedures to align with policy v4.2",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1041",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1042",
    "summary": "Two supporting procedures overdue for annual review by 30+ days",
    "description": "Two supporting procedures overdue for annual review by 30+ days",
    "complianceRequirement": "GV.PO-02 Ex1",
    "controlId": "GV.PO-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Document formal review timelines for each trigger type | Clear overdue procedure reviews within 30 days",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1042",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1043",
    "summary": "Department-level awareness of risk management objectives limited below VP level",
    "description": "Department-level awareness of risk management objectives limited below VP level",
    "complianceRequirement": "GV.RM-01 Ex1",
    "controlId": "GV.RM-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish trigger for objective review after major business events | Cascade risk objectives to department heads through quarterly briefings",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1043",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1044",
    "summary": "No documented example of tolerance thresholds actively driving a risk acceptance or escalation decision",
    "description": "No documented example of tolerance thresholds actively driving a risk acceptance or escalation decision",
    "complianceRequirement": "GV.RM-02 Ex1",
    "controlId": "GV.RM-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete Board ratification of risk appetite in Q2 2026 | Document at least two cases where tolerance thresholds drove decisions",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1044",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1045",
    "summary": "Bottom-up risk identification from non-security teams not formalized",
    "description": "Bottom-up risk identification from non-security teams not formalized",
    "complianceRequirement": "GV.RM-03 Ex1",
    "controlId": "GV.RM-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Standardize risk register format across all risk domains | Implement quarterly risk identification surveys for department heads",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1045",
    "linkedArtifacts": []
  },
  {
    "id": "FND-1046",
    "summary": "Shared responsibility matrices not completed for three recently onboarded cloud services",
    "description": "Shared responsibility matrices not completed for three recently onboarded cloud services",
    "complianceRequirement": "GV.RM-04 Ex1",
    "controlId": "GV.RM-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enforce all risk acceptances through ServiceNow workflow | Complete shared responsibility matrices for new cloud services",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1046",
    "linkedArtifacts": [
      "Information Security Policy",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1047",
    "summary": "No formal mechanism for non-security staff to report emerging cyber risks upward",
    "description": "No formal mechanism for non-security staff to report emerging cyber risks upward",
    "complianceRequirement": "GV.RM-05 Ex1",
    "controlId": "GV.RM-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Include internal audit in monthly security committee meetings | Establish anonymous cyber risk reporting channel for all employees",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1047",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1048",
    "summary": "Two risk entries in register missing required fields (treatment plan, target date)",
    "description": "Two risk entries in register missing required fields (treatment plan, target date)",
    "complianceRequirement": "GV.RM-06 Ex1",
    "controlId": "GV.RM-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Train all risk assessors on quantitative analysis criteria | Enforce required field completion in ServiceNow risk register",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1048",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1049",
    "summary": "No systematic method for identifying new strategic opportunities beyond CISO-driven process",
    "description": "No systematic method for identifying new strategic opportunities beyond CISO-driven process",
    "complianceRequirement": "GV.RM-07 Ex1",
    "controlId": "GV.RM-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add positive risk scoring to ServiceNow risk register template | Include opportunity identification in quarterly department head surveys",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1049",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1050",
    "summary": "Security culture messaging could be more frequent (currently quarterly)",
    "description": "Security culture messaging could be more frequent (currently quarterly)",
    "complianceRequirement": "GV.RR-01 Ex1",
    "controlId": "GV.RR-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Recruit Board member with cybersecurity expertise | Increase security culture communications to monthly cadence",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1050",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1051",
    "summary": "Performance goals for department heads' cybersecurity responsibilities not consistently measured",
    "description": "Performance goals for department heads' cybersecurity responsibilities not consistently measured",
    "complianceRequirement": "GV.RR-02 Ex1",
    "controlId": "GV.RR-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Update RACI matrix to reflect current team structure | Add cybersecurity metrics to department head performance reviews",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1051",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1052",
    "summary": "Training budget underutilized (60% spent) due to operational workload constraints",
    "description": "Training budget underutilized (60% spent) due to operational workload constraints",
    "complianceRequirement": "GV.RR-03 Ex1",
    "controlId": "GV.RR-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate hiring for open security engineering positions | Allocate protected time for security team training",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1052",
    "linkedArtifacts": [
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1053",
    "summary": "Offboarding access revocation took 48+ hours for 2 of 10 sampled departures (target: 24 hours)",
    "description": "Offboarding access revocation took 48+ hours for 2 of 10 sampled departures (target: 24 hours)",
    "complianceRequirement": "GV.RR-04 Ex1",
    "controlId": "GV.RR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Clear overdue background check refreshes within 30 days | Automate offboarding access revocation to meet 24-hour SLA",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1053",
    "linkedArtifacts": [
      "Access Management Policy",
      "Quarterly Access Recertification Procedure"
    ]
  },
  {
    "id": "FND-1054",
    "summary": "C-SCRM strategy not reviewed since initial publication (Q2 2025)",
    "description": "C-SCRM strategy not reviewed since initial publication (Q2 2025)",
    "complianceRequirement": "GV.SC-01 Ex1",
    "controlId": "GV.SC-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct annual C-SCRM strategy review in Q2 2026 | Implement maturity model scoring for program progress",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1054",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1055",
    "summary": "Information sharing protocols not tested through tabletop or simulation",
    "description": "Information sharing protocols not tested through tabletop or simulation",
    "complianceRequirement": "GV.SC-02 Ex1",
    "controlId": "GV.SC-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Include C-SCRM performance metrics in GRC team reviews | Test information sharing protocols in next tabletop exercise",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1055",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1056",
    "summary": "C-SCRM improvement process findings not systematically fed back into enterprise improvement cycle",
    "description": "C-SCRM improvement process findings not systematically fed back into enterprise improvement cycle",
    "complianceRequirement": "GV.SC-03 Ex1",
    "controlId": "GV.SC-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete integrated control set documentation | Formalize C-SCRM improvement feedback loop to ERM process",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1056",
    "linkedArtifacts": [
      "Third Party Risk Management Policy",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1057",
    "summary": "SBOM requirements only enforced for vendors onboarded after Q3 2025",
    "description": "SBOM requirements only enforced for vendors onboarded after Q3 2025",
    "complianceRequirement": "GV.SC-05 Ex1",
    "controlId": "GV.SC-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate pre-template contracts at renewal with current security addenda | Extend SBOM requirements to all Tier 1 vendors regardless of onboarding date",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1057",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1058",
    "summary": "Product integrity checks not formalized for hardware components",
    "description": "Product integrity checks not formalized for hardware components",
    "complianceRequirement": "GV.SC-06 Ex1",
    "controlId": "GV.SC-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Streamline due diligence process to meet 15-day SLA | Formalize hardware integrity verification procedures",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1058",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1059",
    "summary": "Vendor disruption scenario not included in most recent tabletop exercise",
    "description": "Vendor disruption scenario not included in most recent tabletop exercise",
    "complianceRequirement": "GV.SC-07 Ex1",
    "controlId": "GV.SC-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete overdue Tier 1 vendor assessment within 30 days | Include vendor disruption scenario in next tabletop exercise",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1059",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1060",
    "summary": "Crisis communication contact directory not updated since Q3 2025",
    "description": "Crisis communication contact directory not updated since Q3 2025",
    "complianceRequirement": "GV.SC-08 Ex1",
    "controlId": "GV.SC-08 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand tabletop exercise participation to all Tier 1 vendors | Update crisis communication contact directory quarterly",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1060",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1061",
    "summary": "Supplier maintenance access logs not reviewed systematically (only on-demand)",
    "description": "Supplier maintenance access logs not reviewed systematically (only on-demand)",
    "complianceRequirement": "GV.SC-09 Ex1",
    "controlId": "GV.SC-09 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Achieve 100% SBOM coverage for critical applications by Q3 2026 | Implement weekly review of supplier maintenance access logs",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1061",
    "linkedArtifacts": [
      "Third Party Risk Management Policy",
      "Authorized Software Inventory"
    ]
  },
  {
    "id": "FND-1062",
    "summary": "Data leakage risk assessment not documented for either sampled termination",
    "description": "Data leakage risk assessment not documented for either sampled termination",
    "complianceRequirement": "GV.SC-10 Ex1",
    "controlId": "GV.SC-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add API key and service account sweep to offboarding checklist | Require documented data leakage risk assessment for all terminations | Create Tier 1 vendor transition plan template",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1062",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1063",
    "summary": "Transition plan template not formalized for Tier 1 vendor transitions",
    "description": "Transition plan template not formalized for Tier 1 vendor transitions",
    "complianceRequirement": "GV.SC-10 Ex1",
    "controlId": "GV.SC-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add API key and service account sweep to offboarding checklist | Require documented data leakage risk assessment for all terminations | Create Tier 1 vendor transition plan template",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1063",
    "linkedArtifacts": [
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1064",
    "summary": "3 service accounts created during emergency changes not in CMDB inventory",
    "description": "3 service accounts created during emergency changes not in CMDB inventory",
    "complianceRequirement": "PR.AA-01 Ex1",
    "controlId": "PR.AA-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared developer SSH key by deploying HashiCorp Vault SSH CA; implement interim session monitoring | Reconcile 3 undocumented service accounts into CMDB; implement emergency change reconciliation process | Automate AWS IAM and Kubernetes deprovisioning through ServiceNow webhook-triggered Lambda function | Implement automated role-change detection to remove prior entitlements on department/title changes | Migrate credential recovery from knowledge-based to video-based identity verification for privileged accounts | Enable MFA on AWS root account using hardware security key",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1064",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Service Account Inventory"
    ]
  },
  {
    "id": "FND-1065",
    "summary": "AWS IAM and Kubernetes deprovisioning requires manual intervention (24-48 hour gap after termination)",
    "description": "AWS IAM and Kubernetes deprovisioning requires manual intervention (24-48 hour gap after termination)",
    "complianceRequirement": "PR.AA-01 Ex1",
    "controlId": "PR.AA-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared developer SSH key by deploying HashiCorp Vault SSH CA; implement interim session monitoring | Reconcile 3 undocumented service accounts into CMDB; implement emergency change reconciliation process | Automate AWS IAM and Kubernetes deprovisioning through ServiceNow webhook-triggered Lambda function | Implement automated role-change detection to remove prior entitlements on department/title changes | Migrate credential recovery from knowledge-based to video-based identity verification for privileged accounts | Enable MFA on AWS root account using hardware security key",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1065",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Service Account Inventory"
    ]
  },
  {
    "id": "FND-1066",
    "summary": "Role-change workflow not fully automated; access creep identified at 12% of AD group memberships",
    "description": "Role-change workflow not fully automated; access creep identified at 12% of AD group memberships",
    "complianceRequirement": "PR.AA-01 Ex1",
    "controlId": "PR.AA-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared developer SSH key by deploying HashiCorp Vault SSH CA; implement interim session monitoring | Reconcile 3 undocumented service accounts into CMDB; implement emergency change reconciliation process | Automate AWS IAM and Kubernetes deprovisioning through ServiceNow webhook-triggered Lambda function | Implement automated role-change detection to remove prior entitlements on department/title changes | Migrate credential recovery from knowledge-based to video-based identity verification for privileged accounts | Enable MFA on AWS root account using hardware security key",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1066",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Service Account Inventory"
    ]
  },
  {
    "id": "FND-1067",
    "summary": "Credential recovery relies on knowledge-based identity verification, susceptible to social engineering",
    "description": "Credential recovery relies on knowledge-based identity verification, susceptible to social engineering",
    "complianceRequirement": "PR.AA-01 Ex1",
    "controlId": "PR.AA-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared developer SSH key by deploying HashiCorp Vault SSH CA; implement interim session monitoring | Reconcile 3 undocumented service accounts into CMDB; implement emergency change reconciliation process | Automate AWS IAM and Kubernetes deprovisioning through ServiceNow webhook-triggered Lambda function | Implement automated role-change detection to remove prior entitlements on department/title changes | Migrate credential recovery from knowledge-based to video-based identity verification for privileged accounts | Enable MFA on AWS root account using hardware security key",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1067",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Service Account Inventory"
    ]
  },
  {
    "id": "FND-1068",
    "summary": "No defined identity assurance levels mapped to access sensitivity (all users receive same proofing level)",
    "description": "No defined identity assurance levels mapped to access sensitivity (all users receive same proofing level)",
    "complianceRequirement": "PR.AA-02 Ex1",
    "controlId": "PR.AA-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared developer SSH key through HashiCorp Vault SSH CA deployment; restore individual credential binding | Define tiered identity proofing assurance levels (basic, enhanced, high) aligned to NIST SP 800-63A | Implement recorded video verification with automated retention in HR document management system | Automate contractor account expiration tied to contract end date in Workday | Extend identity proofing requirements to MFA device replacement and credential recovery processes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1068",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1069",
    "summary": "Remote video verification is not recorded or retained for audit purposes",
    "description": "Remote video verification is not recorded or retained for audit purposes",
    "complianceRequirement": "PR.AA-02 Ex1",
    "controlId": "PR.AA-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared developer SSH key through HashiCorp Vault SSH CA deployment; restore individual credential binding | Define tiered identity proofing assurance levels (basic, enhanced, high) aligned to NIST SP 800-63A | Implement recorded video verification with automated retention in HR document management system | Automate contractor account expiration tied to contract end date in Workday | Extend identity proofing requirements to MFA device replacement and credential recovery processes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1069",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1070",
    "summary": "Contractor credential expiration not automatically tied to contract end date in Workday",
    "description": "Contractor credential expiration not automatically tied to contract end date in Workday",
    "complianceRequirement": "PR.AA-02 Ex1",
    "controlId": "PR.AA-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared developer SSH key through HashiCorp Vault SSH CA deployment; restore individual credential binding | Define tiered identity proofing assurance levels (basic, enhanced, high) aligned to NIST SP 800-63A | Implement recorded video verification with automated retention in HR document management system | Automate contractor account expiration tied to contract end date in Workday | Extend identity proofing requirements to MFA device replacement and credential recovery processes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1070",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Third Party Risk Management Policy"
    ]
  },
  {
    "id": "FND-1071",
    "summary": "Shared developer SSH key on port 45001 bypasses all authentication controls including MFA",
    "description": "Shared developer SSH key on port 45001 bypasses all authentication controls including MFA",
    "complianceRequirement": "PR.AA-03 Ex1",
    "controlId": "PR.AA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable hardware MFA on AWS root account immediately; store key in office safe | Remediate shared developer SSH key; deploy HashiCorp Vault SSH CA with MFA-backed certificate issuance | Complete MFA Phase 2 enrollment to reach 100%; enforce conditional access policy blocking password-only login | Rotate and migrate 5 long-lived AWS IAM access keys to SSO-federated temporary credentials | Extend FIDO2 hardware key requirement to all IT administrators and engineering leads (Phase 3) | Integrate SentinelOne compliance API with Palo Alto for automated network quarantine of unhealthy devices",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1071",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1072",
    "summary": "MFA enrollment at 85%, not 100%; 15% of users authenticate with password only",
    "description": "MFA enrollment at 85%, not 100%; 15% of users authenticate with password only",
    "complianceRequirement": "PR.AA-03 Ex1",
    "controlId": "PR.AA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable hardware MFA on AWS root account immediately; store key in office safe | Remediate shared developer SSH key; deploy HashiCorp Vault SSH CA with MFA-backed certificate issuance | Complete MFA Phase 2 enrollment to reach 100%; enforce conditional access policy blocking password-only login | Rotate and migrate 5 long-lived AWS IAM access keys to SSO-federated temporary credentials | Extend FIDO2 hardware key requirement to all IT administrators and engineering leads (Phase 3) | Integrate SentinelOne compliance API with Palo Alto for automated network quarantine of unhealthy devices",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1072",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1073",
    "summary": "5 AWS IAM accounts using long-lived access keys (14 months oldest, no rotation)",
    "description": "5 AWS IAM accounts using long-lived access keys (14 months oldest, no rotation)",
    "complianceRequirement": "PR.AA-03 Ex1",
    "controlId": "PR.AA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable hardware MFA on AWS root account immediately; store key in office safe | Remediate shared developer SSH key; deploy HashiCorp Vault SSH CA with MFA-backed certificate issuance | Complete MFA Phase 2 enrollment to reach 100%; enforce conditional access policy blocking password-only login | Rotate and migrate 5 long-lived AWS IAM access keys to SSO-federated temporary credentials | Extend FIDO2 hardware key requirement to all IT administrators and engineering leads (Phase 3) | Integrate SentinelOne compliance API with Palo Alto for automated network quarantine of unhealthy devices",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1073",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1074",
    "summary": "No automated network quarantine for SentinelOne non-compliant devices",
    "description": "No automated network quarantine for SentinelOne non-compliant devices",
    "complianceRequirement": "PR.AA-03 Ex1",
    "controlId": "PR.AA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable hardware MFA on AWS root account immediately; store key in office safe | Remediate shared developer SSH key; deploy HashiCorp Vault SSH CA with MFA-backed certificate issuance | Complete MFA Phase 2 enrollment to reach 100%; enforce conditional access policy blocking password-only login | Rotate and migrate 5 long-lived AWS IAM access keys to SSO-federated temporary credentials | Extend FIDO2 hardware key requirement to all IT administrators and engineering leads (Phase 3) | Integrate SentinelOne compliance API with Palo Alto for automated network quarantine of unhealthy devices",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1074",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1075",
    "summary": "Phishing-resistant MFA (FIDO2) limited to security team; not extended to all privileged users",
    "description": "Phishing-resistant MFA (FIDO2) limited to security team; not extended to all privileged users",
    "complianceRequirement": "PR.AA-03 Ex1",
    "controlId": "PR.AA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Enable hardware MFA on AWS root account immediately; store key in office safe | Remediate shared developer SSH key; deploy HashiCorp Vault SSH CA with MFA-backed certificate issuance | Complete MFA Phase 2 enrollment to reach 100%; enforce conditional access policy blocking password-only login | Rotate and migrate 5 long-lived AWS IAM access keys to SSO-federated temporary credentials | Extend FIDO2 hardware key requirement to all IT administrators and engineering leads (Phase 3) | Integrate SentinelOne compliance API with Palo Alto for automated network quarantine of unhealthy devices",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1075",
    "linkedArtifacts": [
      "Information Security Policy",
      "Access Management Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1076",
    "summary": "2 SaaS applications have stale federation metadata after January 2026 certificate rotation",
    "description": "2 SaaS applications have stale federation metadata after January 2026 certificate rotation",
    "complianceRequirement": "PR.AA-04 Ex1",
    "controlId": "PR.AA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Refresh stale federation metadata on 2 SaaS applications; implement automated metadata refresh tied to certificate lifecycle | Enable SAML assertion encryption for all applications that support it; document exceptions | Migrate federation inventory from spreadsheet to ServiceNow CMDB with automated certificate expiration alerting | Implement back-channel logout (OIDC) for critical applications to enable real-time session revocation | Standardize Kubernetes projected service account token expiration across all namespaces | Conduct annual assertion verification testing across all 35 integrated relying parties",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1076",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1077",
    "summary": "Federation inventory maintained in spreadsheet, not in ServiceNow CMDB",
    "description": "Federation inventory maintained in spreadsheet, not in ServiceNow CMDB",
    "complianceRequirement": "PR.AA-04 Ex1",
    "controlId": "PR.AA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Refresh stale federation metadata on 2 SaaS applications; implement automated metadata refresh tied to certificate lifecycle | Enable SAML assertion encryption for all applications that support it; document exceptions | Migrate federation inventory from spreadsheet to ServiceNow CMDB with automated certificate expiration alerting | Implement back-channel logout (OIDC) for critical applications to enable real-time session revocation | Standardize Kubernetes projected service account token expiration across all namespaces | Conduct annual assertion verification testing across all 35 integrated relying parties",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1077",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1078",
    "summary": "Back-channel logout not configured; token caching creates up to 1-hour revocation gap",
    "description": "Back-channel logout not configured; token caching creates up to 1-hour revocation gap",
    "complianceRequirement": "PR.AA-04 Ex1",
    "controlId": "PR.AA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Refresh stale federation metadata on 2 SaaS applications; implement automated metadata refresh tied to certificate lifecycle | Enable SAML assertion encryption for all applications that support it; document exceptions | Migrate federation inventory from spreadsheet to ServiceNow CMDB with automated certificate expiration alerting | Implement back-channel logout (OIDC) for critical applications to enable real-time session revocation | Standardize Kubernetes projected service account token expiration across all namespaces | Conduct annual assertion verification testing across all 35 integrated relying parties",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1078",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1079",
    "summary": "Kubernetes service account token expiration not consistently configured across namespaces",
    "description": "Kubernetes service account token expiration not consistently configured across namespaces",
    "complianceRequirement": "PR.AA-04 Ex1",
    "controlId": "PR.AA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Refresh stale federation metadata on 2 SaaS applications; implement automated metadata refresh tied to certificate lifecycle | Enable SAML assertion encryption for all applications that support it; document exceptions | Migrate federation inventory from spreadsheet to ServiceNow CMDB with automated certificate expiration alerting | Implement back-channel logout (OIDC) for critical applications to enable real-time session revocation | Standardize Kubernetes projected service account token expiration across all namespaces | Conduct annual assertion verification testing across all 35 integrated relying parties",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1079",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1080",
    "summary": "No automated assertion verification testing at relying parties",
    "description": "No automated assertion verification testing at relying parties",
    "complianceRequirement": "PR.AA-04 Ex1",
    "controlId": "PR.AA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Refresh stale federation metadata on 2 SaaS applications; implement automated metadata refresh tied to certificate lifecycle | Enable SAML assertion encryption for all applications that support it; document exceptions | Migrate federation inventory from spreadsheet to ServiceNow CMDB with automated certificate expiration alerting | Implement back-channel logout (OIDC) for critical applications to enable real-time session revocation | Standardize Kubernetes projected service account token expiration across all namespaces | Conduct annual assertion verification testing across all 35 integrated relying parties",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1080",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1081",
    "summary": "Badge deactivation relies on manual handoff between IT and facilities",
    "description": "Badge deactivation relies on manual handoff between IT and facilities",
    "complianceRequirement": "PR.AA-06 Ex1",
    "controlId": "PR.AA-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Automate badge deactivation through ServiceNow offboarding workflow; eliminate manual facilities handoff | Forward ACS physical access logs to SIEM for correlation with logical access events | Implement anti-tailgating measures at main building entrance (turnstiles or optical sensors) | Migrate from paper visitor log to digital visitor management system (Envoy, SwipedOn) | Integrate server room camera footage with ACS badge events for automated video retrieval | Evaluate biometric authentication (fingerprint or palm) for server room entry",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1081",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Access Management Policy",
      "Alma Security Hardware Inventory"
    ]
  },
  {
    "id": "FND-1082",
    "summary": "Physical access logs not forwarded to SIEM for logical-physical correlation",
    "description": "Physical access logs not forwarded to SIEM for logical-physical correlation",
    "complianceRequirement": "PR.AA-06 Ex1",
    "controlId": "PR.AA-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Automate badge deactivation through ServiceNow offboarding workflow; eliminate manual facilities handoff | Forward ACS physical access logs to SIEM for correlation with logical access events | Implement anti-tailgating measures at main building entrance (turnstiles or optical sensors) | Migrate from paper visitor log to digital visitor management system (Envoy, SwipedOn) | Integrate server room camera footage with ACS badge events for automated video retrieval | Evaluate biometric authentication (fingerprint or palm) for server room entry",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1082",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Access Management Policy",
      "Alma Security Hardware Inventory"
    ]
  },
  {
    "id": "FND-1083",
    "summary": "No anti-tailgating measures at main building entrance",
    "description": "No anti-tailgating measures at main building entrance",
    "complianceRequirement": "PR.AA-06 Ex1",
    "controlId": "PR.AA-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Automate badge deactivation through ServiceNow offboarding workflow; eliminate manual facilities handoff | Forward ACS physical access logs to SIEM for correlation with logical access events | Implement anti-tailgating measures at main building entrance (turnstiles or optical sensors) | Migrate from paper visitor log to digital visitor management system (Envoy, SwipedOn) | Integrate server room camera footage with ACS badge events for automated video retrieval | Evaluate biometric authentication (fingerprint or palm) for server room entry",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1083",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Access Management Policy",
      "Alma Security Hardware Inventory"
    ]
  },
  {
    "id": "FND-1084",
    "summary": "Visitor log is paper-based with no digital visitor management system",
    "description": "Visitor log is paper-based with no digital visitor management system",
    "complianceRequirement": "PR.AA-06 Ex1",
    "controlId": "PR.AA-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Automate badge deactivation through ServiceNow offboarding workflow; eliminate manual facilities handoff | Forward ACS physical access logs to SIEM for correlation with logical access events | Implement anti-tailgating measures at main building entrance (turnstiles or optical sensors) | Migrate from paper visitor log to digital visitor management system (Envoy, SwipedOn) | Integrate server room camera footage with ACS badge events for automated video retrieval | Evaluate biometric authentication (fingerprint or palm) for server room entry",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1084",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Access Management Policy",
      "Alma Security Hardware Inventory"
    ]
  },
  {
    "id": "FND-1085",
    "summary": "Server room camera footage not integrated with ACS badge logs for automated correlation",
    "description": "Server room camera footage not integrated with ACS badge logs for automated correlation",
    "complianceRequirement": "PR.AA-06 Ex1",
    "controlId": "PR.AA-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Automate badge deactivation through ServiceNow offboarding workflow; eliminate manual facilities handoff | Forward ACS physical access logs to SIEM for correlation with logical access events | Implement anti-tailgating measures at main building entrance (turnstiles or optical sensors) | Migrate from paper visitor log to digital visitor management system (Envoy, SwipedOn) | Integrate server room camera footage with ACS badge events for automated video retrieval | Evaluate biometric authentication (fingerprint or palm) for server room entry",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1085",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Access Management Policy",
      "Alma Security Hardware Inventory"
    ]
  },
  {
    "id": "FND-1086",
    "summary": "Contractor coverage incomplete. The 12 EMEA-based contractors are enrolled in the same training program but content is n",
    "description": "**Contractor coverage incomplete.** The 12 EMEA-based contractors are enrolled in the same training program but content is not localized. The AUP acknowledgment requirement has not been formally extended to all contractor personnel through the vendor onboarding process.",
    "complianceRequirement": "PR.AT-01 Ex1",
    "controlId": "PR.AT-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement scored post-training quizzes in Workday with 80% pass threshold and auto-remediation for failures | Extend AUP acknowledgment and training requirements to all contractor personnel through vendor onboarding | Add vishing and smishing simulation capabilities to the phishing program at next platform renewal | Build consolidated awareness metrics dashboard combining phishing results, Workday completions, and reporting behavior | Establish \"Phish Spotter\" recognition program to positively reinforce reporting behavior | Add pre-training baseline quiz at onboarding to measure incoming awareness level and track improvement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1086",
    "linkedArtifacts": [
      "Acceptable Use Policy",
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1087",
    "summary": "No vishing or SMS simulation. Phishing simulations are limited to email-based campaigns",
    "description": "**No vishing or SMS simulation.** Phishing simulations are limited to email-based campaigns. Voice-based (vishing) and SMS-based (smishing) social engineering vectors are not tested, leaving a gap in assessing employee preparedness for non-email attack channels.",
    "complianceRequirement": "PR.AT-01 Ex1",
    "controlId": "PR.AT-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement scored post-training quizzes in Workday with 80% pass threshold and auto-remediation for failures | Extend AUP acknowledgment and training requirements to all contractor personnel through vendor onboarding | Add vishing and smishing simulation capabilities to the phishing program at next platform renewal | Build consolidated awareness metrics dashboard combining phishing results, Workday completions, and reporting behavior | Establish \"Phish Spotter\" recognition program to positively reinforce reporting behavior | Add pre-training baseline quiz at onboarding to measure incoming awareness level and track improvement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1087",
    "linkedArtifacts": [
      "Acceptable Use Policy",
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1088",
    "summary": "No unified assessment dashboard. Phishing simulation results, Workday completion records, and incident reporting data ex",
    "description": "**No unified assessment dashboard.** Phishing simulation results, Workday completion records, and incident reporting data exist in separate systems with no consolidated view of workforce security awareness posture.",
    "complianceRequirement": "PR.AT-01 Ex1",
    "controlId": "PR.AT-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement scored post-training quizzes in Workday with 80% pass threshold and auto-remediation for failures | Extend AUP acknowledgment and training requirements to all contractor personnel through vendor onboarding | Add vishing and smishing simulation capabilities to the phishing program at next platform renewal | Build consolidated awareness metrics dashboard combining phishing results, Workday completions, and reporting behavior | Establish \"Phish Spotter\" recognition program to positively reinforce reporting behavior | Add pre-training baseline quiz at onboarding to measure incoming awareness level and track improvement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1088",
    "linkedArtifacts": [
      "Acceptable Use Policy",
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1089",
    "summary": "Training tracked outside Workday. Specialized training completion is tracked in team-level spreadsheets and vendor porta",
    "description": "**Training tracked outside Workday.** Specialized training completion is tracked in team-level spreadsheets and vendor portals rather than the centralized Workday platform. This creates fragmented audit trails and limits management visibility into compliance.",
    "complianceRequirement": "PR.AT-02 Ex1",
    "controlId": "PR.AT-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create and publish a formal role classification matrix defining criteria for specialized training designation, reviewed annually | Migrate all specialized training tracking into Workday Learning with role-based curricula and centralized compliance reporting | Develop documented training plans for each specialized role (D&R, VM, DevSecOps, network/system admin) mapped to tools and responsibilities | Establish mandatory developer security training covering OWASP Top 10, secure coding, and dependency scanning | Implement semi-annual role-specific competency assessments combining knowledge tests and scenario-based exercises | Establish quarterly tabletop exercise calendar with rotating scenarios for the D&R team | Draft policy amendment establishing formal annual specialized role refresher requirements distinct from general awareness | Administer baseline competency assessment to all specialized role personnel before next training cycle",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1089",
    "linkedArtifacts": [
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Acceptable Use Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1090",
    "summary": "No formal competency assessments. There are no structured, periodic tests or evaluations to measure whether specialized ",
    "description": "**No formal competency assessments.** There are no structured, periodic tests or evaluations to measure whether specialized personnel have retained and can apply role-specific knowledge. Competency is inferred from operational performance rather than directly assessed.",
    "complianceRequirement": "PR.AT-02 Ex1",
    "controlId": "PR.AT-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create and publish a formal role classification matrix defining criteria for specialized training designation, reviewed annually | Migrate all specialized training tracking into Workday Learning with role-based curricula and centralized compliance reporting | Develop documented training plans for each specialized role (D&R, VM, DevSecOps, network/system admin) mapped to tools and responsibilities | Establish mandatory developer security training covering OWASP Top 10, secure coding, and dependency scanning | Implement semi-annual role-specific competency assessments combining knowledge tests and scenario-based exercises | Establish quarterly tabletop exercise calendar with rotating scenarios for the D&R team | Draft policy amendment establishing formal annual specialized role refresher requirements distinct from general awareness | Administer baseline competency assessment to all specialized role personnel before next training cycle",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1090",
    "linkedArtifacts": [
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Acceptable Use Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1091",
    "summary": "No annual specialized refresher policy. While general awareness refreshers are mandated quarterly, there is no distinct ",
    "description": "**No annual specialized refresher policy.** While general awareness refreshers are mandated quarterly, there is no distinct policy requirement for specialized role refreshers covering role-specific content. Refresher activity depends on vendor release cycles and individual initiative.",
    "complianceRequirement": "PR.AT-02 Ex1",
    "controlId": "PR.AT-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create and publish a formal role classification matrix defining criteria for specialized training designation, reviewed annually | Migrate all specialized training tracking into Workday Learning with role-based curricula and centralized compliance reporting | Develop documented training plans for each specialized role (D&R, VM, DevSecOps, network/system admin) mapped to tools and responsibilities | Establish mandatory developer security training covering OWASP Top 10, secure coding, and dependency scanning | Implement semi-annual role-specific competency assessments combining knowledge tests and scenario-based exercises | Establish quarterly tabletop exercise calendar with rotating scenarios for the D&R team | Draft policy amendment establishing formal annual specialized role refresher requirements distinct from general awareness | Administer baseline competency assessment to all specialized role personnel before next training cycle",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1091",
    "linkedArtifacts": [
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Acceptable Use Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1092",
    "summary": "Developer security training is optional. Developer and DevSecOps roles are not formally designated as specialized traini",
    "description": "**Developer security training is optional.** Developer and DevSecOps roles are not formally designated as specialized training roles despite having production access and writing security-sensitive code. Security training for these roles is limited to optional lunch-and-learn sessions.",
    "complianceRequirement": "PR.AT-02 Ex1",
    "controlId": "PR.AT-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create and publish a formal role classification matrix defining criteria for specialized training designation, reviewed annually | Migrate all specialized training tracking into Workday Learning with role-based curricula and centralized compliance reporting | Develop documented training plans for each specialized role (D&R, VM, DevSecOps, network/system admin) mapped to tools and responsibilities | Establish mandatory developer security training covering OWASP Top 10, secure coding, and dependency scanning | Implement semi-annual role-specific competency assessments combining knowledge tests and scenario-based exercises | Establish quarterly tabletop exercise calendar with rotating scenarios for the D&R team | Draft policy amendment establishing formal annual specialized role refresher requirements distinct from general awareness | Administer baseline competency assessment to all specialized role personnel before next training cycle",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1092",
    "linkedArtifacts": [
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Acceptable Use Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1093",
    "summary": "VM team lacks formal curriculum. While the VM team members are skilled, there is no documented training plan that maps t",
    "description": "**VM team lacks formal curriculum.** While the VM team members are skilled, there is no documented training plan that maps to their specific responsibilities with Alma's AWS and Windows domain controller infrastructure.",
    "complianceRequirement": "PR.AT-02 Ex1",
    "controlId": "PR.AT-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create and publish a formal role classification matrix defining criteria for specialized training designation, reviewed annually | Migrate all specialized training tracking into Workday Learning with role-based curricula and centralized compliance reporting | Develop documented training plans for each specialized role (D&R, VM, DevSecOps, network/system admin) mapped to tools and responsibilities | Establish mandatory developer security training covering OWASP Top 10, secure coding, and dependency scanning | Implement semi-annual role-specific competency assessments combining knowledge tests and scenario-based exercises | Establish quarterly tabletop exercise calendar with rotating scenarios for the D&R team | Draft policy amendment establishing formal annual specialized role refresher requirements distinct from general awareness | Administer baseline competency assessment to all specialized role personnel before next training cycle",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1093",
    "linkedArtifacts": [
      "Q1 2026 Security Awareness Training Completion Evidence",
      "Acceptable Use Policy",
      "Q1 2026 Phishing Simulation Report"
    ]
  },
  {
    "id": "FND-1094",
    "summary": "Data classification schema is still in development, meaning encryption requirements cannot be fully mapped to data sensi",
    "description": "Data classification schema is still in development, meaning encryption requirements cannot be fully mapped to data sensitivity levels",
    "complianceRequirement": "PR.DS-01 Ex1",
    "controlId": "PR.DS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete S3 bucket migration to SSE-KMS customer-managed keys across all buckets | Complete data classification schema to drive encryption requirements by sensitivity level | Evaluate 90-day key rotation for KMS keys protecting biometric data | Deploy centralized encryption compliance dashboard covering cloud and on-premises | Extend SentinelOne FIM coverage to all Kubernetes worker nodes | Establish quarterly proactive data integrity validation program for critical data stores | Implement centralized BitLocker compliance reporting for on-premises infrastructure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1094",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Data Classification Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1095",
    "summary": "No centralized encryption compliance dashboard spanning both cloud and on-premises environments, limiting cross-environm",
    "description": "No centralized encryption compliance dashboard spanning both cloud and on-premises environments, limiting cross-environment visibility",
    "complianceRequirement": "PR.DS-01 Ex1",
    "controlId": "PR.DS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete S3 bucket migration to SSE-KMS customer-managed keys across all buckets | Complete data classification schema to drive encryption requirements by sensitivity level | Evaluate 90-day key rotation for KMS keys protecting biometric data | Deploy centralized encryption compliance dashboard covering cloud and on-premises | Extend SentinelOne FIM coverage to all Kubernetes worker nodes | Establish quarterly proactive data integrity validation program for critical data stores | Implement centralized BitLocker compliance reporting for on-premises infrastructure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1095",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Data Classification Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1096",
    "summary": "File integrity monitoring via SentinelOne has coverage gaps on some Kubernetes worker nodes",
    "description": "File integrity monitoring via SentinelOne has coverage gaps on some Kubernetes worker nodes",
    "complianceRequirement": "PR.DS-01 Ex1",
    "controlId": "PR.DS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete S3 bucket migration to SSE-KMS customer-managed keys across all buckets | Complete data classification schema to drive encryption requirements by sensitivity level | Evaluate 90-day key rotation for KMS keys protecting biometric data | Deploy centralized encryption compliance dashboard covering cloud and on-premises | Extend SentinelOne FIM coverage to all Kubernetes worker nodes | Establish quarterly proactive data integrity validation program for critical data stores | Implement centralized BitLocker compliance reporting for on-premises infrastructure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1096",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Data Classification Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1097",
    "summary": "Key rotation cycle of 365 days may be insufficient for keys protecting biometric data (highest sensitivity)",
    "description": "Key rotation cycle of 365 days may be insufficient for keys protecting biometric data (highest sensitivity)",
    "complianceRequirement": "PR.DS-01 Ex1",
    "controlId": "PR.DS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete S3 bucket migration to SSE-KMS customer-managed keys across all buckets | Complete data classification schema to drive encryption requirements by sensitivity level | Evaluate 90-day key rotation for KMS keys protecting biometric data | Deploy centralized encryption compliance dashboard covering cloud and on-premises | Extend SentinelOne FIM coverage to all Kubernetes worker nodes | Establish quarterly proactive data integrity validation program for critical data stores | Implement centralized BitLocker compliance reporting for on-premises infrastructure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1097",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Data Classification Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1098",
    "summary": "Proactive data integrity validation program is not yet established; reliance on reactive FIM monitoring only",
    "description": "Proactive data integrity validation program is not yet established; reliance on reactive FIM monitoring only",
    "complianceRequirement": "PR.DS-01 Ex1",
    "controlId": "PR.DS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete S3 bucket migration to SSE-KMS customer-managed keys across all buckets | Complete data classification schema to drive encryption requirements by sensitivity level | Evaluate 90-day key rotation for KMS keys protecting biometric data | Deploy centralized encryption compliance dashboard covering cloud and on-premises | Extend SentinelOne FIM coverage to all Kubernetes worker nodes | Establish quarterly proactive data integrity validation program for critical data stores | Implement centralized BitLocker compliance reporting for on-premises infrastructure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1098",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Data Classification Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1099",
    "summary": "On-premises encryption compliance is not centrally reported, requiring manual verification",
    "description": "On-premises encryption compliance is not centrally reported, requiring manual verification",
    "complianceRequirement": "PR.DS-01 Ex1",
    "controlId": "PR.DS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete S3 bucket migration to SSE-KMS customer-managed keys across all buckets | Complete data classification schema to drive encryption requirements by sensitivity level | Evaluate 90-day key rotation for KMS keys protecting biometric data | Deploy centralized encryption compliance dashboard covering cloud and on-premises | Extend SentinelOne FIM coverage to all Kubernetes worker nodes | Establish quarterly proactive data integrity validation program for critical data stores | Implement centralized BitLocker compliance reporting for on-premises infrastructure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1099",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "Data Classification Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1100",
    "summary": "No automated TLS certificate expiration monitoring beyond ACM auto-renewal (third-party certificates may lack monitoring",
    "description": "No automated TLS certificate expiration monitoring beyond ACM auto-renewal (third-party certificates may lack monitoring)",
    "complianceRequirement": "PR.DS-02 Ex1",
    "controlId": "PR.DS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Upgrade all ALB security policies to TLS 1.3 default where client compatibility allows | Deploy certificate expiration monitoring with 30/14/7-day alerting for all certificates (including non-ACM) | Audit and document all VPN split tunnel exceptions with business justification | Extend automated TLS scanning to internal service mesh endpoints | Complete S3 SecureTransport condition rollout to all buckets | Enforce encrypted-only policy in dev/staging environments with documented exceptions | Document on-premises transport encryption standards explicitly for Windows DC environment",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1100",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1101",
    "summary": "VPN split tunnel exceptions are not fully documented with business justifications",
    "description": "VPN split tunnel exceptions are not fully documented with business justifications",
    "complianceRequirement": "PR.DS-02 Ex1",
    "controlId": "PR.DS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Upgrade all ALB security policies to TLS 1.3 default where client compatibility allows | Deploy certificate expiration monitoring with 30/14/7-day alerting for all certificates (including non-ACM) | Audit and document all VPN split tunnel exceptions with business justification | Extend automated TLS scanning to internal service mesh endpoints | Complete S3 SecureTransport condition rollout to all buckets | Enforce encrypted-only policy in dev/staging environments with documented exceptions | Document on-premises transport encryption standards explicitly for Windows DC environment",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1101",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1102",
    "summary": "Automated SSL scanning does not cover internal-only service mesh endpoints",
    "description": "Automated SSL scanning does not cover internal-only service mesh endpoints",
    "complianceRequirement": "PR.DS-02 Ex1",
    "controlId": "PR.DS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Upgrade all ALB security policies to TLS 1.3 default where client compatibility allows | Deploy certificate expiration monitoring with 30/14/7-day alerting for all certificates (including non-ACM) | Audit and document all VPN split tunnel exceptions with business justification | Extend automated TLS scanning to internal service mesh endpoints | Complete S3 SecureTransport condition rollout to all buckets | Enforce encrypted-only policy in dev/staging environments with documented exceptions | Document on-premises transport encryption standards explicitly for Windows DC environment",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1102",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1103",
    "summary": "On-premises Windows DC transport encryption policy is not formally documented separately from the general encryption sta",
    "description": "On-premises Windows DC transport encryption policy is not formally documented separately from the general encryption standard",
    "complianceRequirement": "PR.DS-02 Ex1",
    "controlId": "PR.DS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Upgrade all ALB security policies to TLS 1.3 default where client compatibility allows | Deploy certificate expiration monitoring with 30/14/7-day alerting for all certificates (including non-ACM) | Audit and document all VPN split tunnel exceptions with business justification | Extend automated TLS scanning to internal service mesh endpoints | Complete S3 SecureTransport condition rollout to all buckets | Enforce encrypted-only policy in dev/staging environments with documented exceptions | Document on-premises transport encryption standards explicitly for Windows DC environment",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1103",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1104",
    "summary": "Development and staging environments may allow plaintext connections for debugging purposes without documented exception",
    "description": "Development and staging environments may allow plaintext connections for debugging purposes without documented exception tracking",
    "complianceRequirement": "PR.DS-02 Ex1",
    "controlId": "PR.DS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Upgrade all ALB security policies to TLS 1.3 default where client compatibility allows | Deploy certificate expiration monitoring with 30/14/7-day alerting for all certificates (including non-ACM) | Audit and document all VPN split tunnel exceptions with business justification | Extend automated TLS scanning to internal service mesh endpoints | Complete S3 SecureTransport condition rollout to all buckets | Enforce encrypted-only policy in dev/staging environments with documented exceptions | Document on-premises transport encryption standards explicitly for Windows DC environment",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1104",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1105",
    "summary": "S3 SecureTransport condition not yet applied to all buckets (in progress via S3 Bucket Security project)",
    "description": "S3 SecureTransport condition not yet applied to all buckets (in progress via S3 Bucket Security project)",
    "complianceRequirement": "PR.DS-02 Ex1",
    "controlId": "PR.DS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Upgrade all ALB security policies to TLS 1.3 default where client compatibility allows | Deploy certificate expiration monitoring with 30/14/7-day alerting for all certificates (including non-ACM) | Audit and document all VPN split tunnel exceptions with business justification | Extend automated TLS scanning to internal service mesh endpoints | Complete S3 SecureTransport condition rollout to all buckets | Enforce encrypted-only policy in dev/staging environments with documented exceptions | Document on-premises transport encryption standards explicitly for Windows DC environment",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1105",
    "linkedArtifacts": [
      "Encryption Standards Policy",
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1106",
    "summary": "Application-level memory clearing of biometric data after processing has not been validated through code review or memor",
    "description": "Application-level memory clearing of biometric data after processing has not been validated through code review or memory analysis",
    "complianceRequirement": "PR.DS-10 Ex1",
    "controlId": "PR.DS-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Draft secure coding standard for memory handling of sensitive data (biometric data, authentication tokens) | Conduct code review and memory analysis of biometric processing pipeline to verify memory clearing | Establish a unified data-in-use protection program with defined scope, controls inventory, and coverage metrics | Evaluate and deploy DLP controls for data-in-use exfiltration paths (screen capture, clipboard, memory dumps) | Conduct container runtime security assessment with penetration testing | Evaluate confidential computing options (Intel SGX, AMD SEV) for biometric processing workloads as a roadmap item",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1106",
    "linkedArtifacts": [
      "Data Classification Policy",
      "Encryption Standards Policy",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1107",
    "summary": "No hardware-based confidential computing (Intel SGX, AMD SEV) for biometric processing workloads; data is unencrypted in",
    "description": "No hardware-based confidential computing (Intel SGX, AMD SEV) for biometric processing workloads; data is unencrypted in memory during processing",
    "complianceRequirement": "PR.DS-10 Ex1",
    "controlId": "PR.DS-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Draft secure coding standard for memory handling of sensitive data (biometric data, authentication tokens) | Conduct code review and memory analysis of biometric processing pipeline to verify memory clearing | Establish a unified data-in-use protection program with defined scope, controls inventory, and coverage metrics | Evaluate and deploy DLP controls for data-in-use exfiltration paths (screen capture, clipboard, memory dumps) | Conduct container runtime security assessment with penetration testing | Evaluate confidential computing options (Intel SGX, AMD SEV) for biometric processing workloads as a roadmap item",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1107",
    "linkedArtifacts": [
      "Data Classification Policy",
      "Encryption Standards Policy",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1108",
    "summary": "No unified data-in-use protection program; controls exist across multiple tools but are not managed as a coordinated cap",
    "description": "No unified data-in-use protection program; controls exist across multiple tools but are not managed as a coordinated capability with coverage metrics",
    "complianceRequirement": "PR.DS-10 Ex1",
    "controlId": "PR.DS-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Draft secure coding standard for memory handling of sensitive data (biometric data, authentication tokens) | Conduct code review and memory analysis of biometric processing pipeline to verify memory clearing | Establish a unified data-in-use protection program with defined scope, controls inventory, and coverage metrics | Evaluate and deploy DLP controls for data-in-use exfiltration paths (screen capture, clipboard, memory dumps) | Conduct container runtime security assessment with penetration testing | Evaluate confidential computing options (Intel SGX, AMD SEV) for biometric processing workloads as a roadmap item",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1108",
    "linkedArtifacts": [
      "Data Classification Policy",
      "Encryption Standards Policy",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1109",
    "summary": "DLP monitoring does not specifically cover data-in-use exfiltration vectors (screen capture, clipboard scraping, memory ",
    "description": "DLP monitoring does not specifically cover data-in-use exfiltration vectors (screen capture, clipboard scraping, memory dump extraction)",
    "complianceRequirement": "PR.DS-10 Ex1",
    "controlId": "PR.DS-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Draft secure coding standard for memory handling of sensitive data (biometric data, authentication tokens) | Conduct code review and memory analysis of biometric processing pipeline to verify memory clearing | Establish a unified data-in-use protection program with defined scope, controls inventory, and coverage metrics | Evaluate and deploy DLP controls for data-in-use exfiltration paths (screen capture, clipboard, memory dumps) | Conduct container runtime security assessment with penetration testing | Evaluate confidential computing options (Intel SGX, AMD SEV) for biometric processing workloads as a roadmap item",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1109",
    "linkedArtifacts": [
      "Data Classification Policy",
      "Encryption Standards Policy",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1110",
    "summary": "Container runtime security has not been independently audited or penetration tested",
    "description": "Container runtime security has not been independently audited or penetration tested",
    "complianceRequirement": "PR.DS-10 Ex1",
    "controlId": "PR.DS-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Draft secure coding standard for memory handling of sensitive data (biometric data, authentication tokens) | Conduct code review and memory analysis of biometric processing pipeline to verify memory clearing | Establish a unified data-in-use protection program with defined scope, controls inventory, and coverage metrics | Evaluate and deploy DLP controls for data-in-use exfiltration paths (screen capture, clipboard, memory dumps) | Conduct container runtime security assessment with penetration testing | Evaluate confidential computing options (Intel SGX, AMD SEV) for biometric processing workloads as a roadmap item",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1110",
    "linkedArtifacts": [
      "Data Classification Policy",
      "Encryption Standards Policy",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1111",
    "summary": "Data-in-use protection requirements are not yet mapped to data classification levels",
    "description": "Data-in-use protection requirements are not yet mapped to data classification levels",
    "complianceRequirement": "PR.DS-10 Ex1",
    "controlId": "PR.DS-10 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Draft secure coding standard for memory handling of sensitive data (biometric data, authentication tokens) | Conduct code review and memory analysis of biometric processing pipeline to verify memory clearing | Establish a unified data-in-use protection program with defined scope, controls inventory, and coverage metrics | Evaluate and deploy DLP controls for data-in-use exfiltration paths (screen capture, clipboard, memory dumps) | Conduct container runtime security assessment with penetration testing | Evaluate confidential computing options (Intel SGX, AMD SEV) for biometric processing workloads as a roadmap item",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1111",
    "linkedArtifacts": [
      "Data Classification Policy",
      "Encryption Standards Policy",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1112",
    "summary": "RTO and RPO targets are defined informally and have not been formally approved by business stakeholders",
    "description": "RTO and RPO targets are defined informally and have not been formally approved by business stakeholders",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1112",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1113",
    "summary": "Q1 2026 quarterly restore test has not yet been conducted (due by end of March)",
    "description": "Q1 2026 quarterly restore test has not yet been conducted (due by end of March)",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1113",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1114",
    "summary": "S3 Object Lock (WORM protection) is not yet deployed to all backup buckets; rollout in progress via S3 Bucket Security p",
    "description": "S3 Object Lock (WORM protection) is not yet deployed to all backup buckets; rollout in progress via S3 Bucket Security project",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1114",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1115",
    "summary": "Velero backup scope does not cover all Kubernetes namespaces; some non-production workloads with persistent data lack ba",
    "description": "Velero backup scope does not cover all Kubernetes namespaces; some non-production workloads with persistent data lack backup coverage",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1115",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1116",
    "summary": "No automated alerting for backup job failures; current monitoring relies on manual log review",
    "description": "No automated alerting for backup job failures; current monitoring relies on manual log review",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1116",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1117",
    "summary": "On-premises backup replication to AWS relies on a manual scheduled transfer process without failure alerting",
    "description": "On-premises backup replication to AWS relies on a manual scheduled transfer process without failure alerting",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1117",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1118",
    "summary": "DR plan is still in development through the Cloud Security Optimization project ($100K); formal recovery procedures not ",
    "description": "DR plan is still in development through the Cloud Security Optimization project ($100K); formal recovery procedures not yet documented",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1118",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1119",
    "summary": "Cross-region backup restoration has not been tested",
    "description": "Cross-region backup restoration has not been tested",
    "complianceRequirement": "PR.DS-11 Ex1",
    "controlId": "PR.DS-11 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Execute Q1 2026 quarterly restore test before end of March to maintain testing cadence | Formalize RTO and RPO targets with business stakeholder approval through DR plan | Implement automated alerting for backup job failures across all platforms with escalation SLA | Complete S3 Object Lock deployment to all backup buckets for ransomware resilience | Expand Velero backup scope to include all Kubernetes namespaces with persistent data | Automate on-premises backup replication to AWS with failure alerting | Plan and execute full-environment DR recovery test once DR plan is completed | Include cross-region restore test in quarterly testing program",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1119",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Data Classification Policy"
    ]
  },
  {
    "id": "FND-1120",
    "summary": "No formal network segmentation policy — Segmentation exists in practice but is not governed by a documented policy defin",
    "description": "**No formal network segmentation policy** — Segmentation exists in practice but is not governed by a documented policy defining trust zones, allowed flows, and review cadence",
    "complianceRequirement": "PR.IR-01 Ex1",
    "controlId": "PR.IR-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate WAF deployment to close the most significant application-layer protection gap | Draft and approve a network segmentation policy that defines trust zones, allowed traffic flows, and review cadence | Enforce Kubernetes network policies across all production namespaces | Evaluate NAC solutions for the corporate network, prioritizing integration with existing endpoint management | Include segmentation validation in the next penetration test scope | Isolate the Windows Server 2012 R2 fileserver on a restricted VLAN until Q3 upgrade completes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1120",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Physical Security Policy",
      "Backup and Restore Procedure"
    ]
  },
  {
    "id": "FND-1121",
    "summary": "NAC not implemented — No pre-admission device posture assessment; devices connect to the corporate network based on phys",
    "description": "**NAC not implemented** — No pre-admission device posture assessment; devices connect to the corporate network based on physical access alone",
    "complianceRequirement": "PR.IR-01 Ex1",
    "controlId": "PR.IR-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate WAF deployment to close the most significant application-layer protection gap | Draft and approve a network segmentation policy that defines trust zones, allowed traffic flows, and review cadence | Enforce Kubernetes network policies across all production namespaces | Evaluate NAC solutions for the corporate network, prioritizing integration with existing endpoint management | Include segmentation validation in the next penetration test scope | Isolate the Windows Server 2012 R2 fileserver on a restricted VLAN until Q3 upgrade completes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1121",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Physical Security Policy",
      "Backup and Restore Procedure"
    ]
  },
  {
    "id": "FND-1122",
    "summary": "Kubernetes network policies incomplete — Not all namespaces enforce network policies, allowing potential east-west later",
    "description": "**Kubernetes network policies incomplete** — Not all namespaces enforce network policies, allowing potential east-west lateral movement within the cluster",
    "complianceRequirement": "PR.IR-01 Ex1",
    "controlId": "PR.IR-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate WAF deployment to close the most significant application-layer protection gap | Draft and approve a network segmentation policy that defines trust zones, allowed traffic flows, and review cadence | Enforce Kubernetes network policies across all production namespaces | Evaluate NAC solutions for the corporate network, prioritizing integration with existing endpoint management | Include segmentation validation in the next penetration test scope | Isolate the Windows Server 2012 R2 fileserver on a restricted VLAN until Q3 upgrade completes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1122",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Physical Security Policy",
      "Backup and Restore Procedure"
    ]
  },
  {
    "id": "FND-1123",
    "summary": "Windows Server 2012 R2 on the network — Legacy fileserver on an unsupported OS increases the attack surface for the netw",
    "description": "**Windows Server 2012 R2 on the network** — Legacy fileserver on an unsupported OS increases the attack surface for the network segment it occupies; Q3 upgrade planned but currently exposed",
    "complianceRequirement": "PR.IR-01 Ex1",
    "controlId": "PR.IR-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate WAF deployment to close the most significant application-layer protection gap | Draft and approve a network segmentation policy that defines trust zones, allowed traffic flows, and review cadence | Enforce Kubernetes network policies across all production namespaces | Evaluate NAC solutions for the corporate network, prioritizing integration with existing endpoint management | Include segmentation validation in the next penetration test scope | Isolate the Windows Server 2012 R2 fileserver on a restricted VLAN until Q3 upgrade completes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1123",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Physical Security Policy",
      "Backup and Restore Procedure"
    ]
  },
  {
    "id": "FND-1124",
    "summary": "No regular segmentation testing — Segmentation effectiveness has not been independently validated through penetration te",
    "description": "**No regular segmentation testing** — Segmentation effectiveness has not been independently validated through penetration testing or red team exercises",
    "complianceRequirement": "PR.IR-01 Ex1",
    "controlId": "PR.IR-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate WAF deployment to close the most significant application-layer protection gap | Draft and approve a network segmentation policy that defines trust zones, allowed traffic flows, and review cadence | Enforce Kubernetes network policies across all production namespaces | Evaluate NAC solutions for the corporate network, prioritizing integration with existing endpoint management | Include segmentation validation in the next penetration test scope | Isolate the Windows Server 2012 R2 fileserver on a restricted VLAN until Q3 upgrade completes",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1124",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Physical Security Policy",
      "Backup and Restore Procedure"
    ]
  },
  {
    "id": "FND-1125",
    "summary": "Fire suppression inspection records not reviewed — Cannot independently confirm testing cadence, last inspection date, o",
    "description": "**Fire suppression inspection records not reviewed** — Cannot independently confirm testing cadence, last inspection date, or system reliability",
    "complianceRequirement": "PR.IR-02 Ex1",
    "controlId": "PR.IR-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a formal environmental risk assessment for the Redwood City data center facility | Obtain and review fire suppression inspection records; establish an annual review cycle | Verify flood/water detection sensor deployment or install sensors in the data center | Document UPS capacity, battery replacement schedule, and establish load testing cadence | Implement monthly environmental trend reporting from HVAC monitoring data | Create escalation procedures linking environmental monitoring alerts to IT incident management",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1125",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1126",
    "summary": "Flood detection uncertain — Presence of water intrusion sensors in the data center has not been confirmed, relevant give",
    "description": "**Flood detection uncertain** — Presence of water intrusion sensors in the data center has not been confirmed, relevant given Northern California flood risk",
    "complianceRequirement": "PR.IR-02 Ex1",
    "controlId": "PR.IR-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a formal environmental risk assessment for the Redwood City data center facility | Obtain and review fire suppression inspection records; establish an annual review cycle | Verify flood/water detection sensor deployment or install sensors in the data center | Document UPS capacity, battery replacement schedule, and establish load testing cadence | Implement monthly environmental trend reporting from HVAC monitoring data | Create escalation procedures linking environmental monitoring alerts to IT incident management",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1126",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1127",
    "summary": "UPS capacity and testing undocumented — Battery replacement schedule, load testing cadence, and capacity relative to cur",
    "description": "**UPS capacity and testing undocumented** — Battery replacement schedule, load testing cadence, and capacity relative to current equipment load are not documented",
    "complianceRequirement": "PR.IR-02 Ex1",
    "controlId": "PR.IR-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a formal environmental risk assessment for the Redwood City data center facility | Obtain and review fire suppression inspection records; establish an annual review cycle | Verify flood/water detection sensor deployment or install sensors in the data center | Document UPS capacity, battery replacement schedule, and establish load testing cadence | Implement monthly environmental trend reporting from HVAC monitoring data | Create escalation procedures linking environmental monitoring alerts to IT incident management",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1127",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1128",
    "summary": "No environmental trend reporting — HVAC monitoring captures events but trends are not analyzed to identify gradual degra",
    "description": "**No environmental trend reporting** — HVAC monitoring captures events but trends are not analyzed to identify gradual degradation or capacity concerns",
    "complianceRequirement": "PR.IR-02 Ex1",
    "controlId": "PR.IR-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a formal environmental risk assessment for the Redwood City data center facility | Obtain and review fire suppression inspection records; establish an annual review cycle | Verify flood/water detection sensor deployment or install sensors in the data center | Document UPS capacity, battery replacement schedule, and establish load testing cadence | Implement monthly environmental trend reporting from HVAC monitoring data | Create escalation procedures linking environmental monitoring alerts to IT incident management",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1128",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1129",
    "summary": "Environmental monitoring not linked to IT incident management — Environmental alerts may not trigger appropriate IT resp",
    "description": "**Environmental monitoring not linked to IT incident management** — Environmental alerts may not trigger appropriate IT response procedures",
    "complianceRequirement": "PR.IR-02 Ex1",
    "controlId": "PR.IR-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a formal environmental risk assessment for the Redwood City data center facility | Obtain and review fire suppression inspection records; establish an annual review cycle | Verify flood/water detection sensor deployment or install sensors in the data center | Document UPS capacity, battery replacement schedule, and establish load testing cadence | Implement monthly environmental trend reporting from HVAC monitoring data | Create escalation procedures linking environmental monitoring alerts to IT incident management",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1129",
    "linkedArtifacts": [
      "Physical Security Policy",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1130",
    "summary": "RTO/RPO not formally defined — Recovery objectives have not been documented or agreed upon with business stakeholders, m",
    "description": "**RTO/RPO not formally defined** — Recovery objectives have not been documented or agreed upon with business stakeholders, making it impossible to measure DR readiness",
    "complianceRequirement": "PR.IR-03 Ex1",
    "controlId": "PR.IR-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan as part of the Cloud Security Optimization project with defined RTO/RPO for all Tier 1 systems | Formally document failover test results including scenarios, success criteria, recovery times observed, and issues encountered | Establish a semi-annual failover testing cadence tied to infrastructure change milestones | Conduct a DR tabletop exercise after the DR plan is completed to validate coordination procedures | Validate backup schedules against defined RPOs once recovery objectives are established | Assess on-premises resilience requirements and document accepted risk or remediation plan for Redwood City DC",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1130",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1131",
    "summary": "Failover test results not formally documented — While testing was performed, formal documentation of scenarios tested, s",
    "description": "**Failover test results not formally documented** — While testing was performed, formal documentation of scenarios tested, success criteria, observed recovery times, and lessons learned is limited",
    "complianceRequirement": "PR.IR-03 Ex1",
    "controlId": "PR.IR-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan as part of the Cloud Security Optimization project with defined RTO/RPO for all Tier 1 systems | Formally document failover test results including scenarios, success criteria, recovery times observed, and issues encountered | Establish a semi-annual failover testing cadence tied to infrastructure change milestones | Conduct a DR tabletop exercise after the DR plan is completed to validate coordination procedures | Validate backup schedules against defined RPOs once recovery objectives are established | Assess on-premises resilience requirements and document accepted risk or remediation plan for Redwood City DC",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1131",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1132",
    "summary": "No failover testing cadence established — Testing was performed but no recurring schedule ensures continued validation a",
    "description": "**No failover testing cadence established** — Testing was performed but no recurring schedule ensures continued validation as infrastructure evolves",
    "complianceRequirement": "PR.IR-03 Ex1",
    "controlId": "PR.IR-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan as part of the Cloud Security Optimization project with defined RTO/RPO for all Tier 1 systems | Formally document failover test results including scenarios, success criteria, recovery times observed, and issues encountered | Establish a semi-annual failover testing cadence tied to infrastructure change milestones | Conduct a DR tabletop exercise after the DR plan is completed to validate coordination procedures | Validate backup schedules against defined RPOs once recovery objectives are established | Assess on-premises resilience requirements and document accepted risk or remediation plan for Redwood City DC",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1132",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1133",
    "summary": "No DR tabletop exercise — Coordination-level disaster recovery has not been tested; only technical failover has been val",
    "description": "**No DR tabletop exercise** — Coordination-level disaster recovery has not been tested; only technical failover has been validated",
    "complianceRequirement": "PR.IR-03 Ex1",
    "controlId": "PR.IR-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan as part of the Cloud Security Optimization project with defined RTO/RPO for all Tier 1 systems | Formally document failover test results including scenarios, success criteria, recovery times observed, and issues encountered | Establish a semi-annual failover testing cadence tied to infrastructure change milestones | Conduct a DR tabletop exercise after the DR plan is completed to validate coordination procedures | Validate backup schedules against defined RPOs once recovery objectives are established | Assess on-premises resilience requirements and document accepted risk or remediation plan for Redwood City DC",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1133",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1134",
    "summary": "On-premises resilience gap — Redwood City data center does not have equivalent multi-site resilience capabilities",
    "description": "**On-premises resilience gap** — Redwood City data center does not have equivalent multi-site resilience capabilities",
    "complianceRequirement": "PR.IR-03 Ex1",
    "controlId": "PR.IR-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan as part of the Cloud Security Optimization project with defined RTO/RPO for all Tier 1 systems | Formally document failover test results including scenarios, success criteria, recovery times observed, and issues encountered | Establish a semi-annual failover testing cadence tied to infrastructure change milestones | Conduct a DR tabletop exercise after the DR plan is completed to validate coordination procedures | Validate backup schedules against defined RPOs once recovery objectives are established | Assess on-premises resilience requirements and document accepted risk or remediation plan for Redwood City DC",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1134",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1135",
    "summary": "No capacity model for business growth — The relationship between customer growth (targeting 10,000 customers), feature d",
    "description": "**No capacity model for business growth** — The relationship between customer growth (targeting 10,000 customers), feature deployment, and infrastructure resource requirements is not modeled",
    "complianceRequirement": "PR.IR-04 Ex1",
    "controlId": "PR.IR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish a quarterly capacity planning review that correlates business growth projections with infrastructure resource requirements | Deploy WAF with rate limiting and application-layer DDoS mitigation rules as part of the WAF Install project | Develop and test a DDoS response runbook including escalation criteria and AWS Shield Advanced engagement procedures | Implement rate limiting at the ALB or application layer as an interim measure before WAF deployment | Develop a capacity model linking customer growth targets to compute, storage, and network projections | Document Redwood City DC physical capacity and incorporate into capacity planning | Assess log storage capacity against retention and audit requirements (AU-04)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1135",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1136",
    "summary": "No WAF for application-layer DDoS mitigation — AWS Shield Standard only protects against volumetric Layer 3/4 attacks; a",
    "description": "**No WAF for application-layer DDoS mitigation** — AWS Shield Standard only protects against volumetric Layer 3/4 attacks; application-layer (Layer 7) DDoS attacks are not mitigated; WAF project ($112K) in progress",
    "complianceRequirement": "PR.IR-04 Ex1",
    "controlId": "PR.IR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish a quarterly capacity planning review that correlates business growth projections with infrastructure resource requirements | Deploy WAF with rate limiting and application-layer DDoS mitigation rules as part of the WAF Install project | Develop and test a DDoS response runbook including escalation criteria and AWS Shield Advanced engagement procedures | Implement rate limiting at the ALB or application layer as an interim measure before WAF deployment | Develop a capacity model linking customer growth targets to compute, storage, and network projections | Document Redwood City DC physical capacity and incorporate into capacity planning | Assess log storage capacity against retention and audit requirements (AU-04)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1136",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1137",
    "summary": "No DDoS response runbook — Procedures for responding to an active DDoS attack are not documented, including escalation p",
    "description": "**No DDoS response runbook** — Procedures for responding to an active DDoS attack are not documented, including escalation paths and decision criteria for engaging AWS Shield Advanced",
    "complianceRequirement": "PR.IR-04 Ex1",
    "controlId": "PR.IR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish a quarterly capacity planning review that correlates business growth projections with infrastructure resource requirements | Deploy WAF with rate limiting and application-layer DDoS mitigation rules as part of the WAF Install project | Develop and test a DDoS response runbook including escalation criteria and AWS Shield Advanced engagement procedures | Implement rate limiting at the ALB or application layer as an interim measure before WAF deployment | Develop a capacity model linking customer growth targets to compute, storage, and network projections | Document Redwood City DC physical capacity and incorporate into capacity planning | Assess log storage capacity against retention and audit requirements (AU-04)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1137",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1138",
    "summary": "No rate limiting — Neither the load balancer nor the application layer enforces rate limiting, leaving the platform vuln",
    "description": "**No rate limiting** — Neither the load balancer nor the application layer enforces rate limiting, leaving the platform vulnerable to request flooding",
    "complianceRequirement": "PR.IR-04 Ex1",
    "controlId": "PR.IR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish a quarterly capacity planning review that correlates business growth projections with infrastructure resource requirements | Deploy WAF with rate limiting and application-layer DDoS mitigation rules as part of the WAF Install project | Develop and test a DDoS response runbook including escalation criteria and AWS Shield Advanced engagement procedures | Implement rate limiting at the ALB or application layer as an interim measure before WAF deployment | Develop a capacity model linking customer growth targets to compute, storage, and network projections | Document Redwood City DC physical capacity and incorporate into capacity planning | Assess log storage capacity against retention and audit requirements (AU-04)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1138",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1139",
    "summary": "On-premises capacity not documented — Physical capacity constraints (rack space, power, cooling) for the Redwood City da",
    "description": "**On-premises capacity not documented** — Physical capacity constraints (rack space, power, cooling) for the Redwood City data center are not formally assessed",
    "complianceRequirement": "PR.IR-04 Ex1",
    "controlId": "PR.IR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish a quarterly capacity planning review that correlates business growth projections with infrastructure resource requirements | Deploy WAF with rate limiting and application-layer DDoS mitigation rules as part of the WAF Install project | Develop and test a DDoS response runbook including escalation criteria and AWS Shield Advanced engagement procedures | Implement rate limiting at the ALB or application layer as an interim measure before WAF deployment | Develop a capacity model linking customer growth targets to compute, storage, and network projections | Document Redwood City DC physical capacity and incorporate into capacity planning | Assess log storage capacity against retention and audit requirements (AU-04)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1139",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1140",
    "summary": "Log storage capacity not assessed — Retention requirements versus available storage for audit and investigation logs hav",
    "description": "**Log storage capacity not assessed** — Retention requirements versus available storage for audit and investigation logs have not been evaluated",
    "complianceRequirement": "PR.IR-04 Ex1",
    "controlId": "PR.IR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish a quarterly capacity planning review that correlates business growth projections with infrastructure resource requirements | Deploy WAF with rate limiting and application-layer DDoS mitigation rules as part of the WAF Install project | Develop and test a DDoS response runbook including escalation criteria and AWS Shield Advanced engagement procedures | Implement rate limiting at the ALB or application layer as an interim measure before WAF deployment | Develop a capacity model linking customer growth targets to compute, storage, and network projections | Document Redwood City DC physical capacity and incorporate into capacity planning | Assess log storage capacity against retention and audit requirements (AU-04)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1140",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1141",
    "summary": "Windows Server 2012 R2 capacity limitations — Legacy fileserver may present storage and performance constraints given it",
    "description": "**Windows Server 2012 R2 capacity limitations** — Legacy fileserver may present storage and performance constraints given its age; Q3 upgrade planned",
    "complianceRequirement": "PR.IR-04 Ex1",
    "controlId": "PR.IR-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Establish a quarterly capacity planning review that correlates business growth projections with infrastructure resource requirements | Deploy WAF with rate limiting and application-layer DDoS mitigation rules as part of the WAF Install project | Develop and test a DDoS response runbook including escalation criteria and AWS Shield Advanced engagement procedures | Implement rate limiting at the ALB or application layer as an interim measure before WAF deployment | Develop a capacity model linking customer growth targets to compute, storage, and network projections | Document Redwood City DC physical capacity and incorporate into capacity planning | Assess log storage capacity against retention and audit requirements (AU-04)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1141",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "Physical Security Policy",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1142",
    "summary": "Kubernetes node baselines have not been independently validated against the CIS Kubernetes Benchmark (kube-bench not dep",
    "description": "Kubernetes node baselines have not been independently validated against the CIS Kubernetes Benchmark (kube-bench not deployed)",
    "complianceRequirement": "PR.PS-01 Ex1",
    "controlId": "PR.PS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Migrate remaining 5% of systems to hardened baselines or decommission legacy dev environments | Deploy kube-bench for CIS Kubernetes Benchmark validation on EKS nodes | Implement equivalent automated compliance monitoring for on-premises Windows DC (DSC or SCAP) | Establish quarterly baseline review cadence aligned to CIS Benchmark release cycle | Expand AWS Config auto-remediation coverage from 30% to 60%+ of rules",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1142",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Patch Management Procedure",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1143",
    "summary": "On-premises Windows domain controller configurations are managed separately from the IaC workflow and lack equivalent au",
    "description": "On-premises Windows domain controller configurations are managed separately from the IaC workflow and lack equivalent automated compliance monitoring",
    "complianceRequirement": "PR.PS-01 Ex1",
    "controlId": "PR.PS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Migrate remaining 5% of systems to hardened baselines or decommission legacy dev environments | Deploy kube-bench for CIS Kubernetes Benchmark validation on EKS nodes | Implement equivalent automated compliance monitoring for on-premises Windows DC (DSC or SCAP) | Establish quarterly baseline review cadence aligned to CIS Benchmark release cycle | Expand AWS Config auto-remediation coverage from 30% to 60%+ of rules",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1143",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Patch Management Procedure",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1144",
    "summary": "Baseline review cadence is ad hoc rather than formally scheduled; no evidence of periodic review aligned with CIS Benchm",
    "description": "Baseline review cadence is ad hoc rather than formally scheduled; no evidence of periodic review aligned with CIS Benchmark update cycles",
    "complianceRequirement": "PR.PS-01 Ex1",
    "controlId": "PR.PS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Migrate remaining 5% of systems to hardened baselines or decommission legacy dev environments | Deploy kube-bench for CIS Kubernetes Benchmark validation on EKS nodes | Implement equivalent automated compliance monitoring for on-premises Windows DC (DSC or SCAP) | Establish quarterly baseline review cadence aligned to CIS Benchmark release cycle | Expand AWS Config auto-remediation coverage from 30% to 60%+ of rules",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1144",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Patch Management Procedure",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1145",
    "summary": "Auto-remediation coverage is limited to approximately 30% of AWS Config rules; the majority of deviations require manual",
    "description": "Auto-remediation coverage is limited to approximately 30% of AWS Config rules; the majority of deviations require manual remediation",
    "complianceRequirement": "PR.PS-01 Ex1",
    "controlId": "PR.PS-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Migrate remaining 5% of systems to hardened baselines or decommission legacy dev environments | Deploy kube-bench for CIS Kubernetes Benchmark validation on EKS nodes | Implement equivalent automated compliance monitoring for on-premises Windows DC (DSC or SCAP) | Establish quarterly baseline review cadence aligned to CIS Benchmark release cycle | Expand AWS Config auto-remediation coverage from 30% to 60%+ of rules",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1145",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Patch Management Procedure",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1146",
    "summary": "No software bill of materials (SBOM) for the SaaS platform; transitive dependency vulnerabilities not systematically tra",
    "description": "No software bill of materials (SBOM) for the SaaS platform; transitive dependency vulnerabilities not systematically tracked",
    "complianceRequirement": "PR.PS-02 Ex1",
    "controlId": "PR.PS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate Windows Server 2012 R2 migration to SharePoint Online/OneDrive; refresh risk acceptance documentation | Implement SBOM generation and automated SCA scanning in CI/CD pipeline | Deploy container image signing (Sigstore Cosign) and admission controller verification | Implement automated dependency update tooling (Dependabot or Renovate) | Automate Kubernetes node draining and rolling updates for patching | Conduct SaaS audit to identify unreviewed tools and route through procurement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1146",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1147",
    "summary": "Container image signing (Sigstore/Cosign) not implemented; no cryptographic verification of image integrity between buil",
    "description": "Container image signing (Sigstore/Cosign) not implemented; no cryptographic verification of image integrity between build and deployment",
    "complianceRequirement": "PR.PS-02 Ex1",
    "controlId": "PR.PS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate Windows Server 2012 R2 migration to SharePoint Online/OneDrive; refresh risk acceptance documentation | Implement SBOM generation and automated SCA scanning in CI/CD pipeline | Deploy container image signing (Sigstore Cosign) and admission controller verification | Implement automated dependency update tooling (Dependabot or Renovate) | Automate Kubernetes node draining and rolling updates for patching | Conduct SaaS audit to identify unreviewed tools and route through procurement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1147",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1148",
    "summary": "Kubernetes node patching occasionally exceeds SLA due to workload scheduling coordination challenges",
    "description": "Kubernetes node patching occasionally exceeds SLA due to workload scheduling coordination challenges",
    "complianceRequirement": "PR.PS-02 Ex1",
    "controlId": "PR.PS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate Windows Server 2012 R2 migration to SharePoint Online/OneDrive; refresh risk acceptance documentation | Implement SBOM generation and automated SCA scanning in CI/CD pipeline | Deploy container image signing (Sigstore Cosign) and admission controller verification | Implement automated dependency update tooling (Dependabot or Renovate) | Automate Kubernetes node draining and rolling updates for patching | Conduct SaaS audit to identify unreviewed tools and route through procurement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1148",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1149",
    "summary": "Application-layer dependency patching (npm, pip) relies on developer-initiated updates rather than automated tooling",
    "description": "Application-layer dependency patching (npm, pip) relies on developer-initiated updates rather than automated tooling",
    "complianceRequirement": "PR.PS-02 Ex1",
    "controlId": "PR.PS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate Windows Server 2012 R2 migration to SharePoint Online/OneDrive; refresh risk acceptance documentation | Implement SBOM generation and automated SCA scanning in CI/CD pipeline | Deploy container image signing (Sigstore Cosign) and admission controller verification | Implement automated dependency update tooling (Dependabot or Renovate) | Automate Kubernetes node draining and rolling updates for patching | Conduct SaaS audit to identify unreviewed tools and route through procurement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1149",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1150",
    "summary": "Software procurement process does not consistently capture free/open-source tools used by developers",
    "description": "Software procurement process does not consistently capture free/open-source tools used by developers",
    "complianceRequirement": "PR.PS-02 Ex1",
    "controlId": "PR.PS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate Windows Server 2012 R2 migration to SharePoint Online/OneDrive; refresh risk acceptance documentation | Implement SBOM generation and automated SCA scanning in CI/CD pipeline | Deploy container image signing (Sigstore Cosign) and admission controller verification | Implement automated dependency update tooling (Dependabot or Renovate) | Automate Kubernetes node draining and rolling updates for patching | Conduct SaaS audit to identify unreviewed tools and route through procurement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1150",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1151",
    "summary": "Estimated 15-20% of SaaS tools in use have not been through formal security review",
    "description": "Estimated 15-20% of SaaS tools in use have not been through formal security review",
    "complianceRequirement": "PR.PS-02 Ex1",
    "controlId": "PR.PS-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Accelerate Windows Server 2012 R2 migration to SharePoint Online/OneDrive; refresh risk acceptance documentation | Implement SBOM generation and automated SCA scanning in CI/CD pipeline | Deploy container image signing (Sigstore Cosign) and admission controller verification | Implement automated dependency update tooling (Dependabot or Renovate) | Automate Kubernetes node draining and rolling updates for patching | Conduct SaaS audit to identify unreviewed tools and route through procurement",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1151",
    "linkedArtifacts": [
      "Authorized Software Inventory",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1152",
    "summary": "CMDB updates lag for asset transfers, relocations, and returns, resulting in stale inventory records identified during r",
    "description": "CMDB updates lag for asset transfers, relocations, and returns, resulting in stale inventory records identified during reconciliation",
    "complianceRequirement": "PR.PS-03 Ex1",
    "controlId": "PR.PS-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Replace Windows 2012 R2 fileserver hardware as part of Q3 2026 migration; combined hardware and software failure risk is critical | Implement unified asset management dashboard combining on-premises CMDB and AWS resources | Develop standardized lifecycle replacement policy for server and infrastructure hardware | Implement automated hardware lifecycle alerting in ServiceNow based on vendor EOL data | Update hardware disposal procedures to current state and audit disposal vendor practices | Extend CMDB lifecycle tracking to network infrastructure (switches, access points)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1152",
    "linkedArtifacts": [
      "Alma Security Hardware Inventory",
      "Authorized Software Inventory",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1153",
    "summary": "Windows Server 2012 R2 fileserver runs on out-of-warranty Dell hardware with no vendor support, compounding the software",
    "description": "Windows Server 2012 R2 fileserver runs on out-of-warranty Dell hardware with no vendor support, compounding the software EOL risk with hardware failure risk",
    "complianceRequirement": "PR.PS-03 Ex1",
    "controlId": "PR.PS-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Replace Windows 2012 R2 fileserver hardware as part of Q3 2026 migration; combined hardware and software failure risk is critical | Implement unified asset management dashboard combining on-premises CMDB and AWS resources | Develop standardized lifecycle replacement policy for server and infrastructure hardware | Implement automated hardware lifecycle alerting in ServiceNow based on vendor EOL data | Update hardware disposal procedures to current state and audit disposal vendor practices | Extend CMDB lifecycle tracking to network infrastructure (switches, access points)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1153",
    "linkedArtifacts": [
      "Alma Security Hardware Inventory",
      "Authorized Software Inventory",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1154",
    "summary": "No standardized lifecycle replacement policy for server and infrastructure hardware; replacement is reactive rather than",
    "description": "No standardized lifecycle replacement policy for server and infrastructure hardware; replacement is reactive rather than planned",
    "complianceRequirement": "PR.PS-03 Ex1",
    "controlId": "PR.PS-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Replace Windows 2012 R2 fileserver hardware as part of Q3 2026 migration; combined hardware and software failure risk is critical | Implement unified asset management dashboard combining on-premises CMDB and AWS resources | Develop standardized lifecycle replacement policy for server and infrastructure hardware | Implement automated hardware lifecycle alerting in ServiceNow based on vendor EOL data | Update hardware disposal procedures to current state and audit disposal vendor practices | Extend CMDB lifecycle tracking to network infrastructure (switches, access points)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1154",
    "linkedArtifacts": [
      "Alma Security Hardware Inventory",
      "Authorized Software Inventory",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1155",
    "summary": "Network infrastructure (switches, access points) has minimal lifecycle tracking in CMDB",
    "description": "Network infrastructure (switches, access points) has minimal lifecycle tracking in CMDB",
    "complianceRequirement": "PR.PS-03 Ex1",
    "controlId": "PR.PS-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Replace Windows 2012 R2 fileserver hardware as part of Q3 2026 migration; combined hardware and software failure risk is critical | Implement unified asset management dashboard combining on-premises CMDB and AWS resources | Develop standardized lifecycle replacement policy for server and infrastructure hardware | Implement automated hardware lifecycle alerting in ServiceNow based on vendor EOL data | Update hardware disposal procedures to current state and audit disposal vendor practices | Extend CMDB lifecycle tracking to network infrastructure (switches, access points)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1155",
    "linkedArtifacts": [
      "Alma Security Hardware Inventory",
      "Authorized Software Inventory",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1156",
    "summary": "Hardware disposal procedure documentation has not been updated since June 2024",
    "description": "Hardware disposal procedure documentation has not been updated since June 2024",
    "complianceRequirement": "PR.PS-03 Ex1",
    "controlId": "PR.PS-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Replace Windows 2012 R2 fileserver hardware as part of Q3 2026 migration; combined hardware and software failure risk is critical | Implement unified asset management dashboard combining on-premises CMDB and AWS resources | Develop standardized lifecycle replacement policy for server and infrastructure hardware | Implement automated hardware lifecycle alerting in ServiceNow based on vendor EOL data | Update hardware disposal procedures to current state and audit disposal vendor practices | Extend CMDB lifecycle tracking to network infrastructure (switches, access points)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1156",
    "linkedArtifacts": [
      "Alma Security Hardware Inventory",
      "Authorized Software Inventory",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1157",
    "summary": "No automated EOL alerting based on vendor lifecycle data; tracking depends on institutional knowledge",
    "description": "No automated EOL alerting based on vendor lifecycle data; tracking depends on institutional knowledge",
    "complianceRequirement": "PR.PS-03 Ex1",
    "controlId": "PR.PS-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Replace Windows 2012 R2 fileserver hardware as part of Q3 2026 migration; combined hardware and software failure risk is critical | Implement unified asset management dashboard combining on-premises CMDB and AWS resources | Develop standardized lifecycle replacement policy for server and infrastructure hardware | Implement automated hardware lifecycle alerting in ServiceNow based on vendor EOL data | Update hardware disposal procedures to current state and audit disposal vendor practices | Extend CMDB lifecycle tracking to network infrastructure (switches, access points)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1157",
    "linkedArtifacts": [
      "Alma Security Hardware Inventory",
      "Authorized Software Inventory",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1158",
    "summary": "On-premises systems (Windows DC, legacy fileserver) forward to local syslog server but are not integrated into the Cloud",
    "description": "On-premises systems (Windows DC, legacy fileserver) forward to local syslog server but are not integrated into the CloudWatch-based monitoring workflow",
    "complianceRequirement": "PR.PS-04 Ex1",
    "controlId": "PR.PS-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate and implement a centralized SIEM with cross-source correlation capability | Integrate on-premises system logs into the centralized monitoring platform | Establish 24/7 monitoring coverage through MDR service or SOC expansion | Develop platform-specific logging configuration standards (Windows Event IDs, auditd rules, K8s audit policy) | Define application-layer security logging requirements and integrate into development standards | Initiate quarterly threat hunting exercises using existing CloudWatch Logs Insights",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1158",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1159",
    "summary": "No 24/7 SOC monitoring; security team operates during business hours with PagerDuty on-call for critical alerts only",
    "description": "No 24/7 SOC monitoring; security team operates during business hours with PagerDuty on-call for critical alerts only",
    "complianceRequirement": "PR.PS-04 Ex1",
    "controlId": "PR.PS-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate and implement a centralized SIEM with cross-source correlation capability | Integrate on-premises system logs into the centralized monitoring platform | Establish 24/7 monitoring coverage through MDR service or SOC expansion | Develop platform-specific logging configuration standards (Windows Event IDs, auditd rules, K8s audit policy) | Define application-layer security logging requirements and integrate into development standards | Initiate quarterly threat hunting exercises using existing CloudWatch Logs Insights",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1159",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1160",
    "summary": "No cross-source correlation capability (e.g., correlating failed auth attempts with subsequent access from different IP)",
    "description": "No cross-source correlation capability (e.g., correlating failed auth attempts with subsequent access from different IP)",
    "complianceRequirement": "PR.PS-04 Ex1",
    "controlId": "PR.PS-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate and implement a centralized SIEM with cross-source correlation capability | Integrate on-premises system logs into the centralized monitoring platform | Establish 24/7 monitoring coverage through MDR service or SOC expansion | Develop platform-specific logging configuration standards (Windows Event IDs, auditd rules, K8s audit policy) | Define application-layer security logging requirements and integrate into development standards | Initiate quarterly threat hunting exercises using existing CloudWatch Logs Insights",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1160",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1161",
    "summary": "Application-layer security logging is limited to error rates and latency; no behavioral analysis or business logic abuse",
    "description": "Application-layer security logging is limited to error rates and latency; no behavioral analysis or business logic abuse detection",
    "complianceRequirement": "PR.PS-04 Ex1",
    "controlId": "PR.PS-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate and implement a centralized SIEM with cross-source correlation capability | Integrate on-premises system logs into the centralized monitoring platform | Establish 24/7 monitoring coverage through MDR service or SOC expansion | Develop platform-specific logging configuration standards (Windows Event IDs, auditd rules, K8s audit policy) | Define application-layer security logging requirements and integrate into development standards | Initiate quarterly threat hunting exercises using existing CloudWatch Logs Insights",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1161",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1162",
    "summary": "Logging policy lacks platform-specific configuration standards (specific Windows Event IDs, Linux auditd rules, K8s audi",
    "description": "Logging policy lacks platform-specific configuration standards (specific Windows Event IDs, Linux auditd rules, K8s audit policy levels)",
    "complianceRequirement": "PR.PS-04 Ex1",
    "controlId": "PR.PS-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate and implement a centralized SIEM with cross-source correlation capability | Integrate on-premises system logs into the centralized monitoring platform | Establish 24/7 monitoring coverage through MDR service or SOC expansion | Develop platform-specific logging configuration standards (Windows Event IDs, auditd rules, K8s audit policy) | Define application-layer security logging requirements and integrate into development standards | Initiate quarterly threat hunting exercises using existing CloudWatch Logs Insights",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1162",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1163",
    "summary": "No proactive threat hunting program; detection is entirely alert-driven",
    "description": "No proactive threat hunting program; detection is entirely alert-driven",
    "complianceRequirement": "PR.PS-04 Ex1",
    "controlId": "PR.PS-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate and implement a centralized SIEM with cross-source correlation capability | Integrate on-premises system logs into the centralized monitoring platform | Establish 24/7 monitoring coverage through MDR service or SOC expansion | Develop platform-specific logging configuration standards (Windows Event IDs, auditd rules, K8s audit policy) | Define application-layer security logging requirements and integrate into development standards | Initiate quarterly threat hunting exercises using existing CloudWatch Logs Insights",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1163",
    "linkedArtifacts": [
      "AWS Config Compliance Snapshot",
      "Weekly Vulnerability Scan Summary",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1164",
    "summary": "40% of users (engineering and product teams) have local admin rights on macOS devices, bypassing IT installation restric",
    "description": "40% of users (engineering and product teams) have local admin rights on macOS devices, bypassing IT installation restrictions",
    "complianceRequirement": "PR.PS-05 Ex1",
    "controlId": "PR.PS-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared SSH key on Kubernetes nodes; implement individual key-based access with audit logging | Enable SentinelOne full enforcement mode for non-developer endpoints; define developer workstation exception policy | Implement just-in-time privilege elevation (Jamf Privileges.app or equivalent) to reduce persistent local admin access from 40% | Deploy OPA Gatekeeper or Kyverno for comprehensive Kubernetes pod security enforcement | Evaluate SELinux or AppArmor enforcement for production Linux servers | Extend approved software catalog to developer toolchains; implement ServiceNow-to-SentinelOne sync",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1164",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Authorized Software Inventory",
      "Acceptable Use Policy"
    ]
  },
  {
    "id": "FND-1165",
    "summary": "Linux server execution control relies on baseline noexec mount options only; no allowlist-level enforcement (SELinux not",
    "description": "Linux server execution control relies on baseline noexec mount options only; no allowlist-level enforcement (SELinux not enabled)",
    "complianceRequirement": "PR.PS-05 Ex1",
    "controlId": "PR.PS-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared SSH key on Kubernetes nodes; implement individual key-based access with audit logging | Enable SentinelOne full enforcement mode for non-developer endpoints; define developer workstation exception policy | Implement just-in-time privilege elevation (Jamf Privileges.app or equivalent) to reduce persistent local admin access from 40% | Deploy OPA Gatekeeper or Kyverno for comprehensive Kubernetes pod security enforcement | Evaluate SELinux or AppArmor enforcement for production Linux servers | Extend approved software catalog to developer toolchains; implement ServiceNow-to-SentinelOne sync",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1165",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Authorized Software Inventory",
      "Acceptable Use Policy"
    ]
  },
  {
    "id": "FND-1166",
    "summary": "Kubernetes nodes accessible via shared SSH key on port 45001 with root access, allowing arbitrary code execution on clus",
    "description": "Kubernetes nodes accessible via shared SSH key on port 45001 with root access, allowing arbitrary code execution on cluster hosts and bypassing all container-level controls",
    "complianceRequirement": "PR.PS-05 Ex1",
    "controlId": "PR.PS-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared SSH key on Kubernetes nodes; implement individual key-based access with audit logging | Enable SentinelOne full enforcement mode for non-developer endpoints; define developer workstation exception policy | Implement just-in-time privilege elevation (Jamf Privileges.app or equivalent) to reduce persistent local admin access from 40% | Deploy OPA Gatekeeper or Kyverno for comprehensive Kubernetes pod security enforcement | Evaluate SELinux or AppArmor enforcement for production Linux servers | Extend approved software catalog to developer toolchains; implement ServiceNow-to-SentinelOne sync",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1166",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Authorized Software Inventory",
      "Acceptable Use Policy"
    ]
  },
  {
    "id": "FND-1167",
    "summary": "Kubernetes pod security standards only partially enforced through custom admission webhook",
    "description": "Kubernetes pod security standards only partially enforced through custom admission webhook",
    "complianceRequirement": "PR.PS-05 Ex1",
    "controlId": "PR.PS-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared SSH key on Kubernetes nodes; implement individual key-based access with audit logging | Enable SentinelOne full enforcement mode for non-developer endpoints; define developer workstation exception policy | Implement just-in-time privilege elevation (Jamf Privileges.app or equivalent) to reduce persistent local admin access from 40% | Deploy OPA Gatekeeper or Kyverno for comprehensive Kubernetes pod security enforcement | Evaluate SELinux or AppArmor enforcement for production Linux servers | Extend approved software catalog to developer toolchains; implement ServiceNow-to-SentinelOne sync",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1167",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Authorized Software Inventory",
      "Acceptable Use Policy"
    ]
  },
  {
    "id": "FND-1168",
    "summary": "Approved software catalog does not cover open-source tools, browser extensions, or developer libraries",
    "description": "Approved software catalog does not cover open-source tools, browser extensions, or developer libraries",
    "complianceRequirement": "PR.PS-05 Ex1",
    "controlId": "PR.PS-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared SSH key on Kubernetes nodes; implement individual key-based access with audit logging | Enable SentinelOne full enforcement mode for non-developer endpoints; define developer workstation exception policy | Implement just-in-time privilege elevation (Jamf Privileges.app or equivalent) to reduce persistent local admin access from 40% | Deploy OPA Gatekeeper or Kyverno for comprehensive Kubernetes pod security enforcement | Evaluate SELinux or AppArmor enforcement for production Linux servers | Extend approved software catalog to developer toolchains; implement ServiceNow-to-SentinelOne sync",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1168",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Authorized Software Inventory",
      "Acceptable Use Policy"
    ]
  },
  {
    "id": "FND-1169",
    "summary": "No automated sync between ServiceNow catalog and SentinelOne allowlist",
    "description": "No automated sync between ServiceNow catalog and SentinelOne allowlist",
    "complianceRequirement": "PR.PS-05 Ex1",
    "controlId": "PR.PS-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Remediate shared SSH key on Kubernetes nodes; implement individual key-based access with audit logging | Enable SentinelOne full enforcement mode for non-developer endpoints; define developer workstation exception policy | Implement just-in-time privilege elevation (Jamf Privileges.app or equivalent) to reduce persistent local admin access from 40% | Deploy OPA Gatekeeper or Kyverno for comprehensive Kubernetes pod security enforcement | Evaluate SELinux or AppArmor enforcement for production Linux servers | Extend approved software catalog to developer toolchains; implement ServiceNow-to-SentinelOne sync",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1169",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Authorized Software Inventory",
      "Acceptable Use Policy"
    ]
  },
  {
    "id": "FND-1170",
    "summary": "No SAST tooling integrated into CI/CD pipeline; source code is not automatically analyzed for security vulnerabilities b",
    "description": "No SAST tooling integrated into CI/CD pipeline; source code is not automatically analyzed for security vulnerabilities before deployment",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1170",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1171",
    "summary": "No DAST tooling; the running application is not tested for vulnerabilities like SQL injection or XSS through automated s",
    "description": "No DAST tooling; the running application is not tested for vulnerabilities like SQL injection or XSS through automated scanning",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1171",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1172",
    "summary": "No security quality gates in the pipeline; container images with critical CVEs can deploy to production without blocking",
    "description": "No security quality gates in the pipeline; container images with critical CVEs can deploy to production without blocking",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1172",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1173",
    "summary": "SQL Injection Mitigation project ($60K budget) has not started despite being identified through vulnerability scanning; ",
    "description": "SQL Injection Mitigation project ($60K budget) has not started despite being identified through vulnerability scanning; this represents a known, unaddressed vulnerability class in the production application",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1173",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1174",
    "summary": "No SBOM generation or automated software composition analysis for dependency tracking",
    "description": "No SBOM generation or automated software composition analysis for dependency tracking",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1174",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1175",
    "summary": "No threat modeling practice for new features or architectural changes",
    "description": "No threat modeling practice for new features or architectural changes",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1175",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1176",
    "summary": "No developer security training program specific to secure coding practices",
    "description": "No developer security training program specific to secure coding practices",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1176",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1177",
    "summary": "npm audit not enforced in the pipeline; dependency vulnerability scanning relies on ad-hoc developer initiative",
    "description": "npm audit not enforced in the pipeline; dependency vulnerability scanning relies on ad-hoc developer initiative",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1177",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1178",
    "summary": "No license compliance scanning for third-party dependencies",
    "description": "No license compliance scanning for third-party dependencies",
    "complianceRequirement": "PR.PS-06 Ex1",
    "controlId": "PR.PS-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Prioritize and begin SQL Injection Mitigation project immediately; this is a known critical vulnerability in production | Integrate SAST tool (Semgrep, SonarQube, or Snyk Code) into GitLab CI pipeline with quality gates | Implement security quality gates that block deployment on critical/high findings | Develop formal SSDLC policy aligned to NIST SP 800-218 (SSDF); do not wait for Q3 2026 timeline | Add automated dependency scanning (Snyk, Dependabot) and enforce npm audit in pipeline | Implement SBOM generation (Syft, CycloneDX) in CI/CD pipeline | Implement DAST scanning in staging environment (OWASP ZAP or Burp Suite Enterprise) | Establish lightweight threat modeling for security-sensitive features",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "High",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1178",
    "linkedArtifacts": [
      "Weekly Vulnerability Scan Summary",
      "Patch Management Procedure",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1179",
    "summary": "No formal communication cadence — Recovery status update frequency is ad hoc rather than defined at regular intervals fo",
    "description": "**No formal communication cadence** — Recovery status update frequency is ad hoc rather than defined at regular intervals for different stakeholder groups",
    "complianceRequirement": "RC.CO-03 Ex1",
    "controlId": "RC.CO-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a tabletop exercise focused on recovery communication, testing notification procedures and stakeholder update cadence | Define a recovery communication cadence matrix specifying update frequency by stakeholder group and incident severity | Document crisis communication procedures for critical supplier coordination, including AWS and key SaaS vendors | Review and formalize Slack channel access controls for recovery communication channels | Compile a contractual information-sharing obligation register for use during recovery communications",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1179",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1180",
    "summary": "Supplier communication not formalized — Crisis communication procedures for coordinating with critical suppliers (AWS, S",
    "description": "**Supplier communication not formalized** — Crisis communication procedures for coordinating with critical suppliers (AWS, SaaS vendors) are not documented",
    "complianceRequirement": "RC.CO-03 Ex1",
    "controlId": "RC.CO-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a tabletop exercise focused on recovery communication, testing notification procedures and stakeholder update cadence | Define a recovery communication cadence matrix specifying update frequency by stakeholder group and incident severity | Document crisis communication procedures for critical supplier coordination, including AWS and key SaaS vendors | Review and formalize Slack channel access controls for recovery communication channels | Compile a contractual information-sharing obligation register for use during recovery communications",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1180",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1181",
    "summary": "Slack channel access controls not reviewed — Recovery communication channels have not been formally reviewed for appropr",
    "description": "**Slack channel access controls not reviewed** — Recovery communication channels have not been formally reviewed for appropriate access controls and information security",
    "complianceRequirement": "RC.CO-03 Ex1",
    "controlId": "RC.CO-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a tabletop exercise focused on recovery communication, testing notification procedures and stakeholder update cadence | Define a recovery communication cadence matrix specifying update frequency by stakeholder group and incident severity | Document crisis communication procedures for critical supplier coordination, including AWS and key SaaS vendors | Review and formalize Slack channel access controls for recovery communication channels | Compile a contractual information-sharing obligation register for use during recovery communications",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1181",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1182",
    "summary": "No contractual obligation register — Information-sharing requirements from customer and vendor contracts are not consoli",
    "description": "**No contractual obligation register** — Information-sharing requirements from customer and vendor contracts are not consolidated into a reference register for recovery communication",
    "complianceRequirement": "RC.CO-03 Ex1",
    "controlId": "RC.CO-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct a tabletop exercise focused on recovery communication, testing notification procedures and stakeholder update cadence | Define a recovery communication cadence matrix specifying update frequency by stakeholder group and incident severity | Document crisis communication procedures for critical supplier coordination, including AWS and key SaaS vendors | Review and formalize Slack channel access controls for recovery communication channels | Compile a contractual information-sharing obligation register for use during recovery communications",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1182",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1183",
    "summary": "Approval workflow not formalized — The public communication approval process (legal review, leadership sign-off) is unde",
    "description": "**Approval workflow not formalized** — The public communication approval process (legal review, leadership sign-off) is understood but not documented as a formal workflow with defined roles and timelines",
    "complianceRequirement": "RC.CO-04 Ex1",
    "controlId": "RC.CO-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Pre-approve public communication templates for common incident types (data breach, service outage, security event) to enable rapid deployment | Formalize the public communication approval workflow with defined roles, review steps, and target timelines | Conduct an independent review of breach notification compliance against applicable state and contractual requirements | Include public communication as a component of the next tabletop exercise to validate the approval and release process",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1183",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1184",
    "summary": "Breach notification compliance not independently verified — Compliance with specific regulatory notification timelines a",
    "description": "**Breach notification compliance not independently verified** — Compliance with specific regulatory notification timelines and content requirements has not been independently validated",
    "complianceRequirement": "RC.CO-04 Ex1",
    "controlId": "RC.CO-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Pre-approve public communication templates for common incident types (data breach, service outage, security event) to enable rapid deployment | Formalize the public communication approval workflow with defined roles, review steps, and target timelines | Conduct an independent review of breach notification compliance against applicable state and contractual requirements | Include public communication as a component of the next tabletop exercise to validate the approval and release process",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1184",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1185",
    "summary": "No public communication rehearsal — Public messaging has not been tested through a tabletop or simulation exercise to va",
    "description": "**No public communication rehearsal** — Public messaging has not been tested through a tabletop or simulation exercise to validate the end-to-end approval and release process",
    "complianceRequirement": "RC.CO-04 Ex1",
    "controlId": "RC.CO-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Pre-approve public communication templates for common incident types (data breach, service outage, security event) to enable rapid deployment | Formalize the public communication approval workflow with defined roles, review steps, and target timelines | Conduct an independent review of breach notification compliance against applicable state and contractual requirements | Include public communication as a component of the next tabletop exercise to validate the approval and release process",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1185",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1186",
    "summary": "Recovery plan not rehearsed end-to-end — Quarterly restore tests validate backup restoration but do not exercise the ful",
    "description": "**Recovery plan not rehearsed end-to-end** — Quarterly restore tests validate backup restoration but do not exercise the full recovery plan activation including role notification, decision-making, and communication procedures",
    "complianceRequirement": "RC.RP-01 Ex1",
    "controlId": "RC.RP-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan under the Cloud Security Optimization project with formal recovery plan activation criteria and procedures | Conduct a tabletop recovery exercise that tests the full recovery plan activation sequence including role notification and decision-making | Document formal recovery authorization criteria and delegation of authority | Establish recovery role training for all personnel with designated recovery responsibilities",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1186",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1187",
    "summary": "No formal recovery training — Personnel with recovery responsibilities have not received dedicated recovery role trainin",
    "description": "**No formal recovery training** — Personnel with recovery responsibilities have not received dedicated recovery role training or participated in tabletop exercises",
    "complianceRequirement": "RC.RP-01 Ex1",
    "controlId": "RC.RP-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan under the Cloud Security Optimization project with formal recovery plan activation criteria and procedures | Conduct a tabletop recovery exercise that tests the full recovery plan activation sequence including role notification and decision-making | Document formal recovery authorization criteria and delegation of authority | Establish recovery role training for all personnel with designated recovery responsibilities",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1187",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1188",
    "summary": "Recovery authorization criteria informal — The authority and criteria to initiate recovery operations are understood ope",
    "description": "**Recovery authorization criteria informal** — The authority and criteria to initiate recovery operations are understood operationally but not formally documented",
    "complianceRequirement": "RC.RP-01 Ex1",
    "controlId": "RC.RP-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Complete the DR plan under the Cloud Security Optimization project with formal recovery plan activation criteria and procedures | Conduct a tabletop recovery exercise that tests the full recovery plan activation sequence including role notification and decision-making | Document formal recovery authorization criteria and delegation of authority | Establish recovery role training for all personnel with designated recovery responsibilities",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1188",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1189",
    "summary": "Limited multi-system recovery coordination — Procedures for coordinating recovery across multiple interdependent systems",
    "description": "**Limited multi-system recovery coordination** — Procedures for coordinating recovery across multiple interdependent systems are not documented",
    "complianceRequirement": "RC.RP-02 Ex1",
    "controlId": "RC.RP-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop a recovery prioritization matrix that maps systems to business impact and defines recovery sequencing | Document multi-system recovery coordination procedures addressing interdependencies between AWS, Kubernetes, and PostgreSQL | Include resource constraint scenarios in recovery planning to address degraded recovery capacity | Incorporate recovery action selection criteria into the DR plan deliverable from the Cloud Security Optimization project",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1189",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1190",
    "summary": "DR plan incomplete — The Cloud Security Optimization project will formalize recovery action selection criteria, but is n",
    "description": "**DR plan incomplete** — The Cloud Security Optimization project will formalize recovery action selection criteria, but is not yet delivered",
    "complianceRequirement": "RC.RP-02 Ex1",
    "controlId": "RC.RP-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop a recovery prioritization matrix that maps systems to business impact and defines recovery sequencing | Document multi-system recovery coordination procedures addressing interdependencies between AWS, Kubernetes, and PostgreSQL | Include resource constraint scenarios in recovery planning to address degraded recovery capacity | Incorporate recovery action selection criteria into the DR plan deliverable from the Cloud Security Optimization project",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1190",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1191",
    "summary": "Resource constraint planning absent — No documented approach for adjusting recovery priorities when personnel or infrast",
    "description": "**Resource constraint planning absent** — No documented approach for adjusting recovery priorities when personnel or infrastructure resources are constrained",
    "complianceRequirement": "RC.RP-02 Ex1",
    "controlId": "RC.RP-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop a recovery prioritization matrix that maps systems to business impact and defines recovery sequencing | Document multi-system recovery coordination procedures addressing interdependencies between AWS, Kubernetes, and PostgreSQL | Include resource constraint scenarios in recovery planning to address degraded recovery capacity | Incorporate recovery action selection criteria into the DR plan deliverable from the Cloud Security Optimization project",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1191",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1192",
    "summary": "Restoration asset inventory incomplete — Not all restoration assets (Kubernetes manifests, infrastructure-as-code templa",
    "description": "**Restoration asset inventory incomplete** — Not all restoration assets (Kubernetes manifests, infrastructure-as-code templates, application configuration) are covered by integrity verification",
    "complianceRequirement": "RC.RP-03 Ex1",
    "controlId": "RC.RP-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add IOC scanning to the backup verification process to detect compromised backup assets before restoration | Implement immutable backup copies (AWS S3 Object Lock or equivalent) for critical data stores | Expand backup integrity verification to cover Kubernetes manifests, infrastructure-as-code, and application configuration | Create a comprehensive restoration asset inventory that maps all assets required for full system recovery",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1192",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1193",
    "summary": "No immutable backup copies — Backups are not stored in an immutable or write-once format to protect against ransomware o",
    "description": "**No immutable backup copies** — Backups are not stored in an immutable or write-once format to protect against ransomware or insider tampering",
    "complianceRequirement": "RC.RP-03 Ex1",
    "controlId": "RC.RP-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add IOC scanning to the backup verification process to detect compromised backup assets before restoration | Implement immutable backup copies (AWS S3 Object Lock or equivalent) for critical data stores | Expand backup integrity verification to cover Kubernetes manifests, infrastructure-as-code, and application configuration | Create a comprehensive restoration asset inventory that maps all assets required for full system recovery",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1193",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1194",
    "summary": "Verification scope limited to databases — Automated verification focuses on PostgreSQL backups but does not extend to ap",
    "description": "**Verification scope limited to databases** — Automated verification focuses on PostgreSQL backups but does not extend to application-tier backup assets",
    "complianceRequirement": "RC.RP-03 Ex1",
    "controlId": "RC.RP-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add IOC scanning to the backup verification process to detect compromised backup assets before restoration | Implement immutable backup copies (AWS S3 Object Lock or equivalent) for critical data stores | Expand backup integrity verification to cover Kubernetes manifests, infrastructure-as-code, and application configuration | Create a comprehensive restoration asset inventory that maps all assets required for full system recovery",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1194",
    "linkedArtifacts": [
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1195",
    "summary": "System owner sign-off not formalized — Restoration confirmation relies on informal communication rather than documented ",
    "description": "**System owner sign-off not formalized** — Restoration confirmation relies on informal communication rather than documented acceptance criteria and sign-off procedures",
    "complianceRequirement": "RC.RP-04 Ex1",
    "controlId": "RC.RP-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Define and document RTO and RPO values for all critical systems, starting with the continuous authentication platform | Formalize system owner restoration sign-off with documented acceptance criteria and a sign-off record | Document a post-restoration enhanced monitoring procedure with defined duration, metrics, and escalation thresholds | Establish a systematic process for updating the risk register after incidents, with tracking to closure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1195",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1196",
    "summary": "No post-restoration monitoring enhancement procedure — Enhanced monitoring during post-recovery stabilization is applied",
    "description": "**No post-restoration monitoring enhancement procedure** — Enhanced monitoring during post-recovery stabilization is applied ad hoc rather than following a documented procedure",
    "complianceRequirement": "RC.RP-04 Ex1",
    "controlId": "RC.RP-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Define and document RTO and RPO values for all critical systems, starting with the continuous authentication platform | Formalize system owner restoration sign-off with documented acceptance criteria and a sign-off record | Document a post-restoration enhanced monitoring procedure with defined duration, metrics, and escalation thresholds | Establish a systematic process for updating the risk register after incidents, with tracking to closure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1196",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1197",
    "summary": "Risk register updates not systematic — Post-incident risk reassessment occurs but is not systematically linked to risk r",
    "description": "**Risk register updates not systematic** — Post-incident risk reassessment occurs but is not systematically linked to risk register entries with tracking and closure",
    "complianceRequirement": "RC.RP-04 Ex1",
    "controlId": "RC.RP-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Define and document RTO and RPO values for all critical systems, starting with the continuous authentication platform | Formalize system owner restoration sign-off with documented acceptance criteria and a sign-off record | Document a post-restoration enhanced monitoring procedure with defined duration, metrics, and escalation thresholds | Establish a systematic process for updating the risk register after incidents, with tracking to closure",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1197",
    "linkedArtifacts": [
      "Information Security Policy",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1198",
    "summary": "End-to-end functional testing not automated — Post-restoration testing of the continuous authentication service relies o",
    "description": "**End-to-end functional testing not automated** — Post-restoration testing of the continuous authentication service relies on manual verification rather than automated end-to-end tests",
    "complianceRequirement": "RC.RP-05 Ex1",
    "controlId": "RC.RP-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add IOC scanning as a required step in the post-restoration procedure before returning systems to production | Develop automated end-to-end functional tests for the continuous authentication service that run after restoration | Define a post-restoration stabilization observation period with monitoring criteria before declaring normal operations | Create a post-restoration security control validation checklist covering access controls, encryption, and logging",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1198",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1199",
    "summary": "No defined stabilization period — There is no documented observation period between restoration completion and full oper",
    "description": "**No defined stabilization period** — There is no documented observation period between restoration completion and full operational declaration",
    "complianceRequirement": "RC.RP-05 Ex1",
    "controlId": "RC.RP-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add IOC scanning as a required step in the post-restoration procedure before returning systems to production | Develop automated end-to-end functional tests for the continuous authentication service that run after restoration | Define a post-restoration stabilization observation period with monitoring criteria before declaring normal operations | Create a post-restoration security control validation checklist covering access controls, encryption, and logging",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1199",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1200",
    "summary": "Security control validation not explicit — Post-restoration verification does not include an explicit checklist for conf",
    "description": "**Security control validation not explicit** — Post-restoration verification does not include an explicit checklist for confirming security controls (access controls, encryption, logging) are operational",
    "complianceRequirement": "RC.RP-05 Ex1",
    "controlId": "RC.RP-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Add IOC scanning as a required step in the post-restoration procedure before returning systems to production | Develop automated end-to-end functional tests for the continuous authentication service that run after restoration | Define a post-restoration stabilization observation period with monitoring criteria before declaring normal operations | Create a post-restoration security control validation checklist covering access controls, encryption, and logging",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1200",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Backup and Restore Procedure",
      "Quarterly Backup Restore Test Report"
    ]
  },
  {
    "id": "FND-1201",
    "summary": "Recovery closure criteria not documented — The end of recovery is declared through informal leadership sign-off rather t",
    "description": "**Recovery closure criteria not documented** — The end of recovery is declared through informal leadership sign-off rather than against documented, measurable criteria",
    "complianceRequirement": "RC.RP-06 Ex1",
    "controlId": "RC.RP-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Formalize the post-incident review process with a standard template, required sections, completion deadline (e.g., 14 days post-recovery), and quality review | Document measurable recovery closure criteria that must be met before declaring the end of recovery | Implement a lessons learned tracking system with assigned owners, deadlines, and closure verification | Define retention requirements for incident recovery documentation aligned with regulatory and contractual obligations",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1201",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1202",
    "summary": "Lessons learned tracking incomplete — Lessons learned are captured but not systematically tracked to completion with ass",
    "description": "**Lessons learned tracking incomplete** — Lessons learned are captured but not systematically tracked to completion with assigned owners, deadlines, and closure verification",
    "complianceRequirement": "RC.RP-06 Ex1",
    "controlId": "RC.RP-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Formalize the post-incident review process with a standard template, required sections, completion deadline (e.g., 14 days post-recovery), and quality review | Document measurable recovery closure criteria that must be met before declaring the end of recovery | Implement a lessons learned tracking system with assigned owners, deadlines, and closure verification | Define retention requirements for incident recovery documentation aligned with regulatory and contractual obligations",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1202",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1203",
    "summary": "No recovery documentation retention policy — Incident recovery documentation retention requirements are not defined",
    "description": "**No recovery documentation retention policy** — Incident recovery documentation retention requirements are not defined",
    "complianceRequirement": "RC.RP-06 Ex1",
    "controlId": "RC.RP-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Formalize the post-incident review process with a standard template, required sections, completion deadline (e.g., 14 days post-recovery), and quality review | Document measurable recovery closure criteria that must be met before declaring the end of recovery | Implement a lessons learned tracking system with assigned owners, deadlines, and closure verification | Define retention requirements for incident recovery documentation aligned with regulatory and contractual obligations",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1203",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1204",
    "summary": "No formal root cause analysis methodology (5-Whys, fault tree, Ishikawa) required",
    "description": "No formal root cause analysis methodology (5-Whys, fault tree, Ishikawa) required",
    "complianceRequirement": "RS.AN-03 Ex1",
    "controlId": "RS.AN-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Define minimum root cause documentation standards with required sections (event timeline, attack vector, vulnerability exploited, systemic factors) | Require formal root cause analysis technique (5-Whys or equivalent) for incidents above medium severity | Establish feedback loop from root cause findings to detection rule tuning and control improvement backlog | Conduct quarterly root cause trend analysis to identify systemic security weaknesses",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1204",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1205",
    "summary": "Systemic root cause identification (beyond immediate technical cause) not consistently performed",
    "description": "Systemic root cause identification (beyond immediate technical cause) not consistently performed",
    "complianceRequirement": "RS.AN-03 Ex1",
    "controlId": "RS.AN-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Define minimum root cause documentation standards with required sections (event timeline, attack vector, vulnerability exploited, systemic factors) | Require formal root cause analysis technique (5-Whys or equivalent) for incidents above medium severity | Establish feedback loop from root cause findings to detection rule tuning and control improvement backlog | Conduct quarterly root cause trend analysis to identify systemic security weaknesses",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1205",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1206",
    "summary": "Root cause findings not systematically fed back into detection rule tuning or control improvements",
    "description": "Root cause findings not systematically fed back into detection rule tuning or control improvements",
    "complianceRequirement": "RS.AN-03 Ex1",
    "controlId": "RS.AN-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Define minimum root cause documentation standards with required sections (event timeline, attack vector, vulnerability exploited, systemic factors) | Require formal root cause analysis technique (5-Whys or equivalent) for incidents above medium severity | Establish feedback loop from root cause findings to detection rule tuning and control improvement backlog | Conduct quarterly root cause trend analysis to identify systemic security weaknesses",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1206",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1207",
    "summary": "No checklist of minimum required investigation actions to document",
    "description": "No checklist of minimum required investigation actions to document",
    "complianceRequirement": "RS.AN-06 Ex1",
    "controlId": "RS.AN-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create standardized investigation documentation template with required action recording fields | Implement investigation documentation completeness checklist required before incident closure | Formalize evidence chain-of-custody procedures with dedicated tracking documentation | Add peer review step for investigation documentation quality on incidents above medium severity",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1207",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1208",
    "summary": "Evidence chain-of-custody documentation not formalized beyond ServiceNow record integrity",
    "description": "Evidence chain-of-custody documentation not formalized beyond ServiceNow record integrity",
    "complianceRequirement": "RS.AN-06 Ex1",
    "controlId": "RS.AN-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create standardized investigation documentation template with required action recording fields | Implement investigation documentation completeness checklist required before incident closure | Formalize evidence chain-of-custody procedures with dedicated tracking documentation | Add peer review step for investigation documentation quality on incidents above medium severity",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1208",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1209",
    "summary": "No peer review of investigation documentation for completeness before incident closure",
    "description": "No peer review of investigation documentation for completeness before incident closure",
    "complianceRequirement": "RS.AN-06 Ex1",
    "controlId": "RS.AN-06 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Create standardized investigation documentation template with required action recording fields | Implement investigation documentation completeness checklist required before incident closure | Formalize evidence chain-of-custody procedures with dedicated tracking documentation | Add peer review step for investigation documentation quality on incidents above medium severity",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1209",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1210",
    "summary": "No standardized evidence catalog or manifest per incident",
    "description": "No standardized evidence catalog or manifest per incident",
    "complianceRequirement": "RS.AN-07 Ex1",
    "controlId": "RS.AN-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement standardized evidence manifest template to track all collected data per incident | Extend SentinelOne telemetry retention or implement automated export for active investigations | Deploy dedicated forensic evidence repository with chain-of-custody tracking | Document evidence provenance requirements (collector identity, timestamp, collection method, hash verification)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1210",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1211",
    "summary": "SentinelOne telemetry retention limited to 14 days without manual export",
    "description": "SentinelOne telemetry retention limited to 14 days without manual export",
    "complianceRequirement": "RS.AN-07 Ex1",
    "controlId": "RS.AN-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement standardized evidence manifest template to track all collected data per incident | Extend SentinelOne telemetry retention or implement automated export for active investigations | Deploy dedicated forensic evidence repository with chain-of-custody tracking | Document evidence provenance requirements (collector identity, timestamp, collection method, hash verification)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1211",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1212",
    "summary": "Evidence provenance documentation (who collected, when, how) not formalized",
    "description": "Evidence provenance documentation (who collected, when, how) not formalized",
    "complianceRequirement": "RS.AN-07 Ex1",
    "controlId": "RS.AN-07 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement standardized evidence manifest template to track all collected data per incident | Extend SentinelOne telemetry retention or implement automated export for active investigations | Deploy dedicated forensic evidence repository with chain-of-custody tracking | Document evidence provenance requirements (collector identity, timestamp, collection method, hash verification)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1212",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SentinelOne Application Control Configuration Evidence"
    ]
  },
  {
    "id": "FND-1213",
    "summary": "Magnitude estimation is manual and dependent on individual analyst thoroughness",
    "description": "Magnitude estimation is manual and dependent on individual analyst thoroughness",
    "complianceRequirement": "RS.AN-08 Ex1",
    "controlId": "RS.AN-08 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated IOC sweep triggered upon incident declaration across all detection platforms | Develop standardized magnitude estimation checklist with required scoping actions | Add magnitude validation step requiring independent confirmation of estimated scope | Build cross-platform IOC correlation capability spanning cloud, endpoint, and SaaS environments",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1213",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1214",
    "summary": "Cross-platform magnitude assessment (cloud + endpoint + SaaS) not unified",
    "description": "Cross-platform magnitude assessment (cloud + endpoint + SaaS) not unified",
    "complianceRequirement": "RS.AN-08 Ex1",
    "controlId": "RS.AN-08 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated IOC sweep triggered upon incident declaration across all detection platforms | Develop standardized magnitude estimation checklist with required scoping actions | Add magnitude validation step requiring independent confirmation of estimated scope | Build cross-platform IOC correlation capability spanning cloud, endpoint, and SaaS environments",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1214",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1215",
    "summary": "No validated magnitude estimation validation step before determining response scope",
    "description": "No validated magnitude estimation validation step before determining response scope",
    "complianceRequirement": "RS.AN-08 Ex1",
    "controlId": "RS.AN-08 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated IOC sweep triggered upon incident declaration across all detection platforms | Develop standardized magnitude estimation checklist with required scoping actions | Add magnitude validation step requiring independent confirmation of estimated scope | Build cross-platform IOC correlation capability spanning cloud, endpoint, and SaaS environments",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1215",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SentinelOne Application Control Configuration Evidence",
      "Weekly Vulnerability Scan Summary"
    ]
  },
  {
    "id": "FND-1216",
    "summary": "Notification templates not tested through simulation",
    "description": "Notification templates not tested through simulation",
    "complianceRequirement": "RS.CO-02 Ex1",
    "controlId": "RS.CO-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct tabletop exercise testing external breach notification workflow including regulatory filing and customer communication | Pre-stage customer notification distribution mechanism for rapid deployment during breach | Implement automated notification compliance timeline tracking in ServiceNow | Validate notification templates through legal review annually",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1216",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1217",
    "summary": "No automated tracking of notification compliance timelines",
    "description": "No automated tracking of notification compliance timelines",
    "complianceRequirement": "RS.CO-02 Ex1",
    "controlId": "RS.CO-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct tabletop exercise testing external breach notification workflow including regulatory filing and customer communication | Pre-stage customer notification distribution mechanism for rapid deployment during breach | Implement automated notification compliance timeline tracking in ServiceNow | Validate notification templates through legal review annually",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1217",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1218",
    "summary": "Customer notification distribution mechanism not pre-staged for rapid deployment",
    "description": "Customer notification distribution mechanism not pre-staged for rapid deployment",
    "complianceRequirement": "RS.CO-02 Ex1",
    "controlId": "RS.CO-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct tabletop exercise testing external breach notification workflow including regulatory filing and customer communication | Pre-stage customer notification distribution mechanism for rapid deployment during breach | Implement automated notification compliance timeline tracking in ServiceNow | Validate notification templates through legal review annually",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1218",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1219",
    "summary": "Crisis communication methods with critical suppliers not formalized beyond existing agreements",
    "description": "Crisis communication methods with critical suppliers not formalized beyond existing agreements",
    "complianceRequirement": "RS.CO-03 Ex1",
    "controlId": "RS.CO-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate ISAC membership for voluntary threat intelligence sharing and community engagement | Formalize crisis communication procedures with critical suppliers including backup channels | Add explicit HR notification procedures for insider threat incidents to the playbook | Develop anonymized TTP sharing capability for proactive community contribution",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1219",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1220",
    "summary": "HR notification procedures for insider threat incidents not explicitly defined in the playbook",
    "description": "HR notification procedures for insider threat incidents not explicitly defined in the playbook",
    "complianceRequirement": "RS.CO-03 Ex1",
    "controlId": "RS.CO-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate ISAC membership for voluntary threat intelligence sharing and community engagement | Formalize crisis communication procedures with critical suppliers including backup channels | Add explicit HR notification procedures for insider threat incidents to the playbook | Develop anonymized TTP sharing capability for proactive community contribution",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1220",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1221",
    "summary": "External sharing limited to contractual obligations; no proactive community contribution",
    "description": "External sharing limited to contractual obligations; no proactive community contribution",
    "complianceRequirement": "RS.CO-03 Ex1",
    "controlId": "RS.CO-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Evaluate ISAC membership for voluntary threat intelligence sharing and community engagement | Formalize crisis communication procedures with critical suppliers including backup channels | Add explicit HR notification procedures for insider threat incidents to the playbook | Develop anonymized TTP sharing capability for proactive community contribution",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1221",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "Information Security Policy",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1222",
    "summary": "Playbook lacks explicit triggers for business continuity or disaster recovery plan activation",
    "description": "Playbook lacks explicit triggers for business continuity or disaster recovery plan activation",
    "complianceRequirement": "RS.MA-01 Ex1",
    "controlId": "RS.MA-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct tabletop exercise testing response plan execution against multi-vector scenario | Add explicit BC/DR plan activation triggers to the incident response playbook | Implement response execution KPI tracking (time-to-activate, time-to-contain) in ServiceNow | Document scaled external assistance request procedures for major incidents",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1222",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1223",
    "summary": "No defined process for requesting external incident response assistance at scale",
    "description": "No defined process for requesting external incident response assistance at scale",
    "complianceRequirement": "RS.MA-01 Ex1",
    "controlId": "RS.MA-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct tabletop exercise testing response plan execution against multi-vector scenario | Add explicit BC/DR plan activation triggers to the incident response playbook | Implement response execution KPI tracking (time-to-activate, time-to-contain) in ServiceNow | Document scaled external assistance request procedures for major incidents",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1223",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1224",
    "summary": "Response plan execution metrics (time to activate, time to contain) not systematically tracked",
    "description": "Response plan execution metrics (time to activate, time to contain) not systematically tracked",
    "complianceRequirement": "RS.MA-01 Ex1",
    "controlId": "RS.MA-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Conduct tabletop exercise testing response plan execution against multi-vector scenario | Add explicit BC/DR plan activation triggers to the incident response playbook | Implement response execution KPI tracking (time-to-activate, time-to-contain) in ServiceNow | Document scaled external assistance request procedures for major incidents",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1224",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1225",
    "summary": "No formal triage quality review or calibration process across analysts",
    "description": "No formal triage quality review or calibration process across analysts",
    "complianceRequirement": "RS.MA-02 Ex1",
    "controlId": "RS.MA-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated pre-triage enrichment (asset context, threat intel, historical similar findings) to reduce triage time | Establish triage metrics dashboard tracking volume, time-to-triage, and severity accuracy | Conduct quarterly triage calibration exercises to ensure consistency across analysts | Evaluate options to reduce after-hours triage gap (extended coverage or automated triage for common patterns)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1225",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1226",
    "summary": "Triage metrics (volume, accuracy, time-to-triage) not systematically tracked",
    "description": "Triage metrics (volume, accuracy, time-to-triage) not systematically tracked",
    "complianceRequirement": "RS.MA-02 Ex1",
    "controlId": "RS.MA-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated pre-triage enrichment (asset context, threat intel, historical similar findings) to reduce triage time | Establish triage metrics dashboard tracking volume, time-to-triage, and severity accuracy | Conduct quarterly triage calibration exercises to ensure consistency across analysts | Evaluate options to reduce after-hours triage gap (extended coverage or automated triage for common patterns)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1226",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1227",
    "summary": "No automated pre-triage enrichment to accelerate analyst review",
    "description": "No automated pre-triage enrichment to accelerate analyst review",
    "complianceRequirement": "RS.MA-02 Ex1",
    "controlId": "RS.MA-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated pre-triage enrichment (asset context, threat intel, historical similar findings) to reduce triage time | Establish triage metrics dashboard tracking volume, time-to-triage, and severity accuracy | Conduct quarterly triage calibration exercises to ensure consistency across analysts | Evaluate options to reduce after-hours triage gap (extended coverage or automated triage for common patterns)",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1227",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1228",
    "summary": "Response strategy selection not documented for all incidents (3 of 4 reviewed)",
    "description": "Response strategy selection not documented for all incidents (3 of 4 reviewed)",
    "complianceRequirement": "RS.MA-03 Ex1",
    "controlId": "RS.MA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand categorization taxonomy to include cloud-specific incident types (IAM compromise, S3 exposure, Lambda abuse) | Require response strategy selection documentation for all declared incidents | Integrate asset criticality ratings from CMDB into automated prioritization assistance | Develop concurrent incident resource allocation framework for simultaneous multi-incident scenarios",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1228",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1229",
    "summary": "No automated prioritization assistance based on affected asset criticality",
    "description": "No automated prioritization assistance based on affected asset criticality",
    "complianceRequirement": "RS.MA-03 Ex1",
    "controlId": "RS.MA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand categorization taxonomy to include cloud-specific incident types (IAM compromise, S3 exposure, Lambda abuse) | Require response strategy selection documentation for all declared incidents | Integrate asset criticality ratings from CMDB into automated prioritization assistance | Develop concurrent incident resource allocation framework for simultaneous multi-incident scenarios",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1229",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1230",
    "summary": "Concurrent incident prioritization (resource allocation across simultaneous incidents) not formally addressed",
    "description": "Concurrent incident prioritization (resource allocation across simultaneous incidents) not formally addressed",
    "complianceRequirement": "RS.MA-03 Ex1",
    "controlId": "RS.MA-03 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand categorization taxonomy to include cloud-specific incident types (IAM compromise, S3 exposure, Lambda abuse) | Require response strategy selection documentation for all declared incidents | Integrate asset criticality ratings from CMDB into automated prioritization assistance | Develop concurrent incident resource allocation framework for simultaneous multi-incident scenarios",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1230",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1231",
    "summary": "No automated escalation based on IOC sweep results or scope expansion detection",
    "description": "No automated escalation based on IOC sweep results or scope expansion detection",
    "complianceRequirement": "RS.MA-04 Ex1",
    "controlId": "RS.MA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Migrate real-time incident status tracking from Slack to ServiceNow to maintain single source of truth | Develop cross-functional escalation procedures for legal, communications, and HR engagement | Implement escalation effectiveness metrics (time-to-escalate, escalation accuracy) | Add automated escalation triggers based on IOC sweep results indicating scope expansion",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1231",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1232",
    "summary": "Escalation effectiveness metrics not tracked (time-to-escalate, escalation accuracy)",
    "description": "Escalation effectiveness metrics not tracked (time-to-escalate, escalation accuracy)",
    "complianceRequirement": "RS.MA-04 Ex1",
    "controlId": "RS.MA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Migrate real-time incident status tracking from Slack to ServiceNow to maintain single source of truth | Develop cross-functional escalation procedures for legal, communications, and HR engagement | Implement escalation effectiveness metrics (time-to-escalate, escalation accuracy) | Add automated escalation triggers based on IOC sweep results indicating scope expansion",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1232",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1233",
    "summary": "Cross-functional stakeholder escalation (legal, communications, HR) coordination procedures underdeveloped",
    "description": "Cross-functional stakeholder escalation (legal, communications, HR) coordination procedures underdeveloped",
    "complianceRequirement": "RS.MA-04 Ex1",
    "controlId": "RS.MA-04 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Migrate real-time incident status tracking from Slack to ServiceNow to maintain single source of truth | Develop cross-functional escalation procedures for legal, communications, and HR engagement | Implement escalation effectiveness metrics (time-to-escalate, escalation accuracy) | Add automated escalation triggers based on IOC sweep results indicating scope expansion",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1233",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "SOC Incident Ticket"
    ]
  },
  {
    "id": "FND-1234",
    "summary": "No data integrity verification checkpoint before recovery initiation",
    "description": "No data integrity verification checkpoint before recovery initiation",
    "complianceRequirement": "RS.MA-05 Ex1",
    "controlId": "RS.MA-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand recovery criteria to include data integrity verification and system validation testing checkpoints | Develop structured operational disruption assessment template for recovery planning | Add stakeholder readiness confirmation step before recovery initiation | Implement post-recovery validation checklist to confirm systems operate correctly after restoration",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1234",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1235",
    "summary": "System validation testing not required as a pre-recovery gate",
    "description": "System validation testing not required as a pre-recovery gate",
    "complianceRequirement": "RS.MA-05 Ex1",
    "controlId": "RS.MA-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand recovery criteria to include data integrity verification and system validation testing checkpoints | Develop structured operational disruption assessment template for recovery planning | Add stakeholder readiness confirmation step before recovery initiation | Implement post-recovery validation checklist to confirm systems operate correctly after restoration",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1235",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1236",
    "summary": "Stakeholder readiness confirmation not included in recovery criteria",
    "description": "Stakeholder readiness confirmation not included in recovery criteria",
    "complianceRequirement": "RS.MA-05 Ex1",
    "controlId": "RS.MA-05 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Expand recovery criteria to include data integrity verification and system validation testing checkpoints | Develop structured operational disruption assessment template for recovery planning | Add stakeholder readiness confirmation step before recovery initiation | Implement post-recovery validation checklist to confirm systems operate correctly after restoration",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1236",
    "linkedArtifacts": [
      "Incident Response Playbook (Excerpt)",
      "SOC Incident Ticket",
      "Information Security Policy"
    ]
  },
  {
    "id": "FND-1237",
    "summary": "Containment options for SaaS application compromise not defined",
    "description": "Containment options for SaaS application compromise not defined",
    "complianceRequirement": "RS.MI-01 Ex1",
    "controlId": "RS.MI-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated containment effectiveness verification (connectivity tests, process monitoring) post-isolation | Define containment procedures for SaaS application compromise scenarios | Review and tune automated containment thresholds to balance speed with false positive risk | Implement VLAN-based quarantine for on-premises systems as supplementary containment mechanism",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1237",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1238",
    "summary": "Automated containment thresholds may need tuning to prevent business disruption from false positives",
    "description": "Automated containment thresholds may need tuning to prevent business disruption from false positives",
    "complianceRequirement": "RS.MI-01 Ex1",
    "controlId": "RS.MI-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated containment effectiveness verification (connectivity tests, process monitoring) post-isolation | Define containment procedures for SaaS application compromise scenarios | Review and tune automated containment thresholds to balance speed with false positive risk | Implement VLAN-based quarantine for on-premises systems as supplementary containment mechanism",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1238",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1239",
    "summary": "VLAN-based quarantine for on-premises systems not implemented",
    "description": "VLAN-based quarantine for on-premises systems not implemented",
    "complianceRequirement": "RS.MI-01 Ex1",
    "controlId": "RS.MI-01 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Implement automated containment effectiveness verification (connectivity tests, process monitoring) post-isolation | Define containment procedures for SaaS application compromise scenarios | Review and tune automated containment thresholds to balance speed with false positive risk | Implement VLAN-based quarantine for on-premises systems as supplementary containment mechanism",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1239",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "Incident Response Playbook (Excerpt)",
      "AWS Config Compliance Snapshot"
    ]
  },
  {
    "id": "FND-1240",
    "summary": "Eradication of advanced persistent threats may require capabilities beyond current tooling",
    "description": "Eradication of advanced persistent threats may require capabilities beyond current tooling",
    "complianceRequirement": "RS.MI-02 Ex1",
    "controlId": "RS.MI-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop standardized post-eradication verification checklist including automated re-scan requirement | Implement automated post-eradication validation scan triggered after manual eradication actions | Validate gold image inventory and reimaging procedures quarterly | Assess advanced persistent threat eradication capability gaps and identify tooling enhancements",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1240",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1241",
    "summary": "No automated re-scan or validation after eradication to confirm complete threat removal",
    "description": "No automated re-scan or validation after eradication to confirm complete threat removal",
    "complianceRequirement": "RS.MI-02 Ex1",
    "controlId": "RS.MI-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop standardized post-eradication verification checklist including automated re-scan requirement | Implement automated post-eradication validation scan triggered after manual eradication actions | Validate gold image inventory and reimaging procedures quarterly | Assess advanced persistent threat eradication capability gaps and identify tooling enhancements",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1241",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)"
    ]
  },
  {
    "id": "FND-1242",
    "summary": "Gold image inventory for system reimaging not regularly validated",
    "description": "Gold image inventory for system reimaging not regularly validated",
    "complianceRequirement": "RS.MI-02 Ex1",
    "controlId": "RS.MI-02 Ex1",
    "assessmentId": "ASM-2026-comprehensive-alma",
    "rootCause": "",
    "remediationActionPlan": "Develop standardized post-eradication verification checklist including automated re-scan requirement | Implement automated post-eradication validation scan triggered after manual eradication actions | Validate gold image inventory and reimaging procedures quarterly | Assess advanced persistent threat eradication capability gaps and identify tooling enhancements",
    "remediationOwner": null,
    "dueDate": "",
    "status": "Open",
    "priority": "Medium",
    "createdDate": "2026-04-30T00:00:00.000Z",
    "lastModified": "2026-04-30T00:00:00.000Z",
    "jiraKey": "FND-1242",
    "linkedArtifacts": [
      "SentinelOne Application Control Configuration Evidence",
      "AWS Config Compliance Snapshot",
      "Incident Response Playbook (Excerpt)"
    ]
  }
];
